var _style, _g, _g2, _polygon, _path, _polygon2, _polygon3, _g3, _g4, _g5, _g6, _g7, _path2, _path3, _path4, _path5, _path6, _path7, _g8, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g9, _g0, _g1, _g10, _polygon4, _polygon5, _polygon6, _defs, _g11, _polygon7, _defs2, _defs3, _defs4, _g12, _path110, _g13, _g14, _g15, _polygon8, _g16, _g17, _g18, _g19, _g20, _path111, _path112, _path113, _path114, _g21, _polygon9, _path115, _g22, _g23, _path116, _path117, _path118, _path119, _polygon0, _g24, _g25, _polygon1, _polygon10, _path120, _path121, _path122, _g26, _g27, _g28, _path123, _polygon11, _path124, _path125, _g29, _path126, _path127, _g30, _ellipse, _path128, _g31, _path129, _path130, _g32, _path131, _path132, _g33, _ellipse2, _path133, _g34, _g35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000065787702027170853380000001604267821868711059_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 729.7",
    style: {
      enableBackground: "new 0 0 960 729.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.4;}\r\n\t.st1{fill:#485654;}\r\n\t.st2{fill:#E0E0E0;}\r\n\t.st3{opacity:0.8;fill:#E0E0E0;enable-background:new    ;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#D3D1D3;}\r\n\t.st6{opacity:0.2;fill:#7D8589;enable-background:new    ;}\r\n\t.st7{opacity:0.6;fill:#D7B18F;enable-background:new    ;}\r\n\t.st8{fill:#D7B18F;}\r\n\t.st9{fill:#7D8589;}\r\n\t.st10{fill:#747678;}\r\n\t.st11{fill:#FFE89B;}\r\n\t.st12{fill:#CDA349;}\r\n\t.st13{fill:#E9E9EA;}\r\n\t.st14{fill:#D4D8D3;}\r\n\t.st15{fill:#375D4C;}\r\n\t.st16{fill:#A3A5A8;}\r\n\t.st17{opacity:0.5;fill:#485654;enable-background:new    ;}\r\n\t.st18{opacity:0.6;fill:#485654;enable-background:new    ;}\r\n\t.st19{opacity:0.7;}\r\n\t.st20{fill:#B4B9BB;}\r\n\t.st21{fill:#637E77;}\r\n\t.st22{fill:#C4C6C8;}\r\n\t.st23{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st24{opacity:0.5;}\r\n\t.st25{fill:url(#SVGID_00000090286688625039162590000007215988796818368653_);}\r\n\t.st26{opacity:0.3;fill:#485654;enable-background:new    ;}\r\n\t.st27{fill:url(#SVGID_00000146476831020689209210000017671341844602728885_);}\r\n\t.st28{fill:url(#SVGID_00000155840202670057739000000013536656138474922395_);}\r\n\t.st29{opacity:0.2;fill:url(#SVGID_00000109031097650037810270000013771553751899517572_);enable-background:new    ;}\r\n\t.st30{fill:url(#SVGID_00000009579157747149713070000009146648613178999202_);}\r\n\t.st31{opacity:0.6;fill:#CDA349;enable-background:new    ;}\r\n\t.st32{fill:url(#SVGID_00000177444590822488243290000002887877610790868655_);}\r\n\t.st33{opacity:0.2;fill:url(#SVGID_00000168822871079166846190000003920343193705288637_);enable-background:new    ;}\r\n\t.st34{fill:url(#SVGID_00000152958267451608106580000015947890796202522247_);}\r\n\t.st35{fill:url(#SVGID_00000072271160052841365490000005212729138816986506_);}\r\n\t.st36{opacity:0.2;fill:url(#SVGID_00000176022041226051951860000001670049310022709168_);enable-background:new    ;}\r\n\t.st37{fill:url(#SVGID_00000062885601040355575220000004762434049971217037_);}\r\n\t.st38{fill:url(#SVGID_00000018196736341289682610000000826307333635544487_);}\r\n\t.st39{opacity:0.2;fill:url(#SVGID_00000074400414841475699810000012065321216115825816_);enable-background:new    ;}\r\n\t.st40{fill:url(#SVGID_00000026851825496020258670000012756089898099420853_);}\r\n\t.st41{fill:url(#SVGID_00000172415351302222241930000000444699067899505086_);}\r\n\t.st42{opacity:0.2;fill:url(#SVGID_00000062899951084044899300000001563227572064710038_);enable-background:new    ;}\r\n\t.st43{fill:url(#SVGID_00000065062470115641274450000017784552614931002004_);}\r\n\t.st44{fill:url(#SVGID_00000000185367440913960760000010751013927275218066_);}\r\n\t.st45{opacity:0.2;fill:url(#SVGID_00000150104692111694425260000014595232071251881093_);enable-background:new    ;}\r\n\t.st46{fill:url(#SVGID_00000093898212126247788150000016542821133749872530_);}\r\n\t.st47{fill:url(#SVGID_00000134240144743373332150000009040341817122689704_);}\r\n\t.st48{opacity:0.2;fill:url(#SVGID_00000129889993077352252720000001347243593677192887_);enable-background:new    ;}\r\n\t.st49{fill:url(#SVGID_00000134228109174582719850000001084155648351726514_);}\r\n\t.st50{fill:url(#SVGID_00000099641876333802140750000012038185943049745049_);}\r\n\t.st51{opacity:0.2;fill:url(#SVGID_00000058558510826916582490000011044256404450754222_);enable-background:new    ;}\r\n\t.st52{fill:url(#SVGID_00000054237489168733956490000007467244064506580634_);}\r\n\t.st53{fill:url(#SVGID_00000005982396608945880080000018210555825303488168_);}\r\n\t.st54{opacity:0.2;fill:url(#SVGID_00000154390472660015899670000014429768595786295720_);enable-background:new    ;}\r\n\t.st55{fill:url(#SVGID_00000039104807923315871590000011379139608398692505_);}\r\n\t.st56{fill:url(#SVGID_00000003817502310104766620000012984688635205318042_);}\r\n\t.st57{opacity:0.2;fill:url(#SVGID_00000014633811817969172260000006144993084490942854_);enable-background:new    ;}\r\n\t.st58{fill:url(#SVGID_00000069399434691481320810000012779033868488232321_);}\r\n\t.st59{fill:url(#SVGID_00000107556620999525390140000009809113115263633550_);}\r\n\t.st60{opacity:0.2;fill:url(#SVGID_00000047046130395422548860000000654360082290823613_);enable-background:new    ;}\r\n\t.st61{fill:url(#SVGID_00000015332698833263313570000016907571153322536065_);}\r\n\t.st62{fill:url(#SVGID_00000135674930870901602950000015280849430523828628_);}\r\n\t.st63{opacity:0.2;fill:url(#SVGID_00000036955825019014305800000001465794555065156000_);enable-background:new    ;}\r\n\t.st64{fill:url(#SVGID_00000158718827178254872430000014279668418019563649_);}\r\n\t.st65{fill:url(#SVGID_00000176034034277128750110000003413474356164429195_);}\r\n\t.st66{opacity:0.2;fill:url(#SVGID_00000009577669113011652320000004247635981545249973_);enable-background:new    ;}\r\n\t.st67{fill:url(#SVGID_00000161604818718728240480000012706949233783820947_);}\r\n\t.st68{fill:url(#SVGID_00000049201789762446348440000013554810851431867064_);}\r\n\t.st69{opacity:0.2;fill:url(#SVGID_00000100374395656949097100000000449510860247988620_);enable-background:new    ;}\r\n\t.st70{fill:url(#SVGID_00000093164076212612648370000000259507468188847780_);}\r\n\t.st71{fill:url(#SVGID_00000003068752144201591350000006069646537196179370_);}\r\n\t.st72{opacity:0.2;fill:url(#SVGID_00000162341100459137459080000001579182253584466062_);enable-background:new    ;}\r\n\t.st73{fill:url(#SVGID_00000180328318897430624610000014274946148671677067_);}\r\n\t.st74{fill:url(#SVGID_00000096051644124701047000000011970227550144306860_);}\r\n\t.st75{opacity:0.2;fill:url(#SVGID_00000098933098186726584330000007374676073342559641_);enable-background:new    ;}\r\n\t.st76{fill:url(#SVGID_00000099650816209116834810000015519289757420305078_);}\r\n\t.st77{fill:url(#SVGID_00000005959250540503003030000010024809077520655538_);}\r\n\t.st78{opacity:0.2;fill:url(#SVGID_00000080925341202105914270000010976209939583364995_);enable-background:new    ;}\r\n\t.st79{fill:url(#SVGID_00000146486416834742160590000012451624636246156223_);}\r\n\t.st80{fill:url(#SVGID_00000072263108851636875070000007412855261527181448_);}\r\n\t.st81{opacity:0.2;fill:url(#SVGID_00000065058070781223630320000003400591483834363016_);enable-background:new    ;}\r\n\t.st82{fill:url(#SVGID_00000045601489203750918840000002603493748792582534_);}\r\n\t.st83{fill:url(#SVGID_00000134932787495528469280000002277341505962700200_);}\r\n\t.st84{opacity:0.2;fill:url(#SVGID_00000049222049733308623150000001178478313726388656_);enable-background:new    ;}\r\n\t.st85{fill:url(#SVGID_00000147210819002294909200000003222256921082228666_);}\r\n\t.st86{fill:url(#SVGID_00000117668423186451601970000002476460020962416032_);}\r\n\t.st87{opacity:0.2;fill:url(#SVGID_00000165918511161780484310000004150163547866156469_);enable-background:new    ;}\r\n\t.st88{fill:url(#SVGID_00000080923747091178598610000009424431703366759584_);}\r\n\t.st89{fill:url(#SVGID_00000022547907460652057050000017776822640751786154_);}\r\n\t.st90{opacity:0.2;fill:url(#SVGID_00000013193699410221588150000012858662035555728549_);enable-background:new    ;}\r\n\t.st91{fill:url(#SVGID_00000164473180785136928260000001171180530537163188_);}\r\n\t.st92{fill:url(#SVGID_00000019652693878487139130000002023563211683329950_);}\r\n\t.st93{opacity:0.2;fill:url(#SVGID_00000146485160670523114190000004136362009485811645_);enable-background:new    ;}\r\n\t.st94{fill:url(#SVGID_00000065048416232614258410000017343083730423624067_);}\r\n\t.st95{fill:url(#SVGID_00000062157037273709626000000017255738259567075986_);}\r\n\t.st96{opacity:0.2;fill:url(#SVGID_00000085938885564810504630000002942988752008505223_);enable-background:new    ;}\r\n\t.st97{fill:url(#SVGID_00000046302616415131308440000003369608379131450029_);}\r\n\t.st98{fill:url(#SVGID_00000016057794917378251690000009706431986229711035_);}\r\n\t.st99{opacity:0.2;fill:url(#SVGID_00000158714848482550324430000002091950928744699793_);enable-background:new    ;}\r\n\t.st100{fill:url(#SVGID_00000061464514145854746620000005245212276922890417_);}\r\n\t.st101{fill:url(#SVGID_00000156569037674904410850000003506329146560348804_);}\r\n\t.st102{opacity:0.2;fill:url(#SVGID_00000023974150297002237740000017002267547045676456_);enable-background:new    ;}\r\n\t.st103{fill:url(#SVGID_00000082335011468205365490000004717129144263980470_);}\r\n\t.st104{fill:url(#SVGID_00000106855636865321585580000017656470147046651820_);}\r\n\t.st105{opacity:0.2;fill:url(#SVGID_00000070801751904925376500000008962918824117041546_);enable-background:new    ;}\r\n\t.st106{fill:url(#SVGID_00000040551165458749279500000015337568117403658377_);}\r\n\t.st107{fill:url(#SVGID_00000000934935006353164120000013320877280577650595_);}\r\n\t.st108{opacity:0.2;fill:url(#SVGID_00000145775001776350232380000002931321240432681632_);enable-background:new    ;}\r\n\t.st109{fill:url(#SVGID_00000118392276534477919680000015393949040573593267_);}\r\n\t.st110{fill:url(#SVGID_00000177475773476453266780000005063932289139302543_);}\r\n\t.st111{opacity:0.2;fill:url(#SVGID_00000014607137136707963830000011473279109621730177_);enable-background:new    ;}\r\n\t.st112{fill:url(#SVGID_00000040571066533172470930000014936915810576959116_);}\r\n\t.st113{fill:url(#SVGID_00000016043509221690946430000011639742667354678401_);}\r\n\t.st114{opacity:0.2;fill:url(#SVGID_00000064341199355940584780000004523184681333248154_);enable-background:new    ;}\r\n\t.st115{fill:url(#SVGID_00000149373037280195552450000011873358341199637144_);}\r\n\t.st116{fill:url(#SVGID_00000163052156624527214700000002861977657161015951_);}\r\n\t.st117{opacity:0.2;fill:url(#SVGID_00000046318451242153649560000006961064855802445734_);enable-background:new    ;}\r\n\t.st118{fill:url(#SVGID_00000074406980802405970530000010544484515345556390_);}\r\n\t.st119{fill:url(#SVGID_00000101800910032881593670000001552902784997505160_);}\r\n\t.st120{opacity:0.2;fill:url(#SVGID_00000046318712043775677470000015532187402783444925_);enable-background:new    ;}\r\n\t.st121{fill:url(#SVGID_00000157990142932753560190000017140791013864559763_);}\r\n\t.st122{fill:url(#SVGID_00000103944382531790153420000007099780207219670202_);}\r\n\t.st123{opacity:0.2;fill:url(#SVGID_00000145021838583005714960000005900377227581528240_);enable-background:new    ;}\r\n\t.st124{fill:url(#SVGID_00000003809923575590281030000005019923815098465215_);}\r\n\t.st125{fill:url(#SVGID_00000023281122267542938840000013416096922376385181_);}\r\n\t.st126{opacity:0.2;fill:url(#SVGID_00000119798026266398058220000012002921198235437235_);enable-background:new    ;}\r\n\t.st127{fill:url(#SVGID_00000156587017623247573040000004738805371513022110_);}\r\n\t.st128{fill:url(#SVGID_00000105385153405325094530000000136011198942068910_);}\r\n\t.st129{opacity:0.2;fill:url(#SVGID_00000176006362966985776830000002216570007277915800_);enable-background:new    ;}\r\n\t.st130{fill:url(#SVGID_00000074443123867642375120000017389622030769789606_);}\r\n\t.st131{fill:url(#SVGID_00000065757499199796913960000001158709082067217560_);}\r\n\t.st132{opacity:0.2;fill:url(#SVGID_00000134970830747502135770000014001821621557212304_);enable-background:new    ;}\r\n\t.st133{fill:url(#SVGID_00000101068077805088673050000004788095544807483305_);}\r\n\t.st134{fill:url(#SVGID_00000029761314893658133000000000242266073161568432_);}\r\n\t.st135{opacity:0.2;fill:url(#SVGID_00000067923297581078326120000006552463715351670963_);enable-background:new    ;}\r\n\t.st136{fill:url(#SVGID_00000107571960080775170470000008110050688943011744_);}\r\n\t.st137{fill:url(#SVGID_00000080206073886571778700000016637832079703007877_);}\r\n\t.st138{opacity:0.2;fill:url(#SVGID_00000020396474908880299690000011479791847804489097_);enable-background:new    ;}\r\n\t.st139{fill:url(#SVGID_00000151507647813117349280000009523200436650437005_);}\r\n\t.st140{fill:url(#SVGID_00000009562888438040507150000010419332002424056504_);}\r\n\t.st141{opacity:0.2;fill:url(#SVGID_00000173861553703355992720000015996267685352464289_);enable-background:new    ;}\r\n\t.st142{fill:url(#SVGID_00000083071853156308390320000008843557427996100795_);}\r\n\t.st143{fill:url(#SVGID_00000064355364694699772280000002767882630961360275_);}\r\n\t.st144{opacity:0.2;fill:url(#SVGID_00000132079988628383012410000015060927361193658754_);enable-background:new    ;}\r\n\t.st145{fill:url(#SVGID_00000040575654220125370490000011547369183790536127_);}\r\n\t.st146{fill:url(#SVGID_00000137845263898912601510000009238163862241458866_);}\r\n\t.st147{opacity:0.2;fill:url(#SVGID_00000157280386419647265290000014391334444121490359_);enable-background:new    ;}\r\n\t.st148{fill:url(#SVGID_00000159442792380649599470000011474254850031138746_);}\r\n\t.st149{fill:url(#SVGID_00000150789821870912343430000004076251786055351942_);}\r\n\t.st150{opacity:0.2;fill:url(#SVGID_00000113344876333493234070000012229037825303170198_);enable-background:new    ;}\r\n\t.st151{fill:url(#SVGID_00000180360906532895637770000016457154623663084933_);}\r\n\t.st152{fill:url(#SVGID_00000060746264223856319720000000987487930417845182_);}\r\n\t.st153{opacity:0.2;fill:url(#SVGID_00000129172832373944973450000009889110593851937689_);enable-background:new    ;}\r\n\t.st154{fill:url(#SVGID_00000098921658432910865090000005571836433644008832_);}\r\n\t.st155{fill:url(#SVGID_00000008841702976534144670000014079185503808802700_);}\r\n\t.st156{opacity:0.2;fill:url(#SVGID_00000057863174498934833260000002311467872064934570_);enable-background:new    ;}\r\n\t.st157{fill:url(#SVGID_00000037691987704952855400000004172434181811420824_);}\r\n\t.st158{fill:url(#SVGID_00000172407139157584418450000011285122478617303695_);}\r\n\t.st159{opacity:0.2;fill:url(#SVGID_00000021818084869792932460000006462046031814334120_);enable-background:new    ;}\r\n\t.st160{fill:url(#SVGID_00000049193169829768124290000002429839293305743764_);}\r\n\t.st161{fill:url(#SVGID_00000081628143124530673130000005770493828867570602_);}\r\n\t.st162{opacity:0.2;fill:url(#SVGID_00000171706367894800086500000013580821538479188907_);enable-background:new    ;}\r\n\t.st163{fill:url(#SVGID_00000087403358908461826610000010408690260687073971_);}\r\n\t.st164{fill:url(#SVGID_00000067930096809451786160000015200495342090667934_);}\r\n\t.st165{opacity:0.2;fill:url(#SVGID_00000031172138843020835740000012487402364095379386_);enable-background:new    ;}\r\n\t.st166{fill:url(#SVGID_00000041294276574748280520000007611341789548327297_);}\r\n\t.st167{fill:url(#SVGID_00000018197882218317202590000007153567279412039577_);}\r\n\t.st168{opacity:0.2;fill:url(#SVGID_00000016063230664880008210000015130768620073248444_);enable-background:new    ;}\r\n\t.st169{fill:url(#SVGID_00000116918018545523355970000007715349783961341105_);}\r\n\t.st170{fill:url(#SVGID_00000054263184706145432220000013787864484301431714_);}\r\n\t.st171{opacity:0.2;fill:url(#SVGID_00000152969488679727703960000006528465928287720365_);enable-background:new    ;}\r\n\t.st172{fill:url(#SVGID_00000160163792993178424280000011122209752959437965_);}\r\n\t.st173{fill:url(#SVGID_00000092426464525221748420000018158348872354782860_);}\r\n\t.st174{opacity:0.2;fill:url(#SVGID_00000123441290005094039430000015925139085301571228_);enable-background:new    ;}\r\n\t.st175{fill:url(#SVGID_00000058584114064333929490000001724690458479282830_);}\r\n\t.st176{fill:url(#SVGID_00000073698929897021969830000016253060369490570171_);}\r\n\t.st177{opacity:0.2;fill:url(#SVGID_00000091723213572304601830000008830872883327163050_);enable-background:new    ;}\r\n\t.st178{fill:url(#SVGID_00000054949888068166612570000002017087254231184040_);}\r\n\t.st179{fill:url(#SVGID_00000023261627073759804490000006228085582611331230_);}\r\n\t.st180{opacity:0.2;fill:url(#SVGID_00000161632179445751083010000003364260606888621958_);enable-background:new    ;}\r\n\t.st181{fill:url(#SVGID_00000059267560790952682410000012698027787958259129_);}\r\n\t.st182{fill:url(#SVGID_00000170236423140985683980000015139901558940890506_);}\r\n\t.st183{opacity:0.2;fill:url(#SVGID_00000103985600595978423650000008749354308692944808_);enable-background:new    ;}\r\n\t.st184{fill:url(#SVGID_00000149359148722902875750000013625941605580211358_);}\r\n\t.st185{enable-background:new    ;}\r\n\t.st186{fill:#497775;}\r\n\t.st187{opacity:0.4;fill:#497775;enable-background:new    ;}\r\n\t.st188{fill:#989498;}\r\n\t.st189{fill:#FBCC34;}\r\n\t.st190{fill:#A16733;}\r\n\t.st191{fill:#B96E2B;}\r\n\t.st192{fill:#B0ACB0;}\r\n\t.st193{fill:#D2D5D4;}\r\n\t.st194{fill:#E6E7E8;}\r\n\t.st195{opacity:0.9;fill:#B0ACB0;enable-background:new    ;}\r\n\t.st196{fill:url(#SVGID_00000147943149860255405870000008170244936033002915_);}\r\n\t.st197{opacity:0.8;fill:#1E1E1E;enable-background:new    ;}\r\n\t.st198{clip-path:url(#SVGID_00000129203718193170187290000002347706203311622576_);}\r\n\t.st199{clip-path:url(#SVGID_00000025405101588965486580000014846344188831393428_);}\r\n\t.st200{fill:url(#SVGID_00000164492790350577108520000011660539789186174875_);}\r\n\t.st201{fill:url(#SVGID_00000107561296773241961260000011543907698448166039_);}\r\n\t.st202{clip-path:url(#SVGID_00000131366034885494751540000017035801276886711957_);}\r\n\t\r\n\t\t.st203{opacity:0.7;clip-path:url(#SVGID_00000085224621657146359830000002974207974769931141_);fill:#858E8D;enable-background:new    ;}\r\n\t.st204{fill:#5D5E61;}\r\n\t.st205{opacity:0.7;fill:#1E1E1E;enable-background:new    ;}\r\n\t.st206{opacity:0.7;fill:#9EA0A4;enable-background:new    ;}\r\n\t.st207{opacity:0.5;fill:#B2B3B7;enable-background:new    ;}\r\n\t.st208{fill:#B2B3B7;}\r\n\t.st209{fill:#E2C675;}\r\n\t.st210{fill:#B3B4B4;}\r\n\t.st211{fill:#5E6B69;}\r\n\t.st212{opacity:0.5;fill:url(#SVGID_00000039824920837089559930000001851068889165115048_);enable-background:new    ;}\r\n\t.st213{fill:url(#SVGID_00000180358649008070157660000013285741757027365015_);}\r\n\t.st214{fill:url(#SVGID_00000107574813927875733620000016921439439436288162_);}\r\n\t.st215{fill:#C08329;}\r\n\t.st216{opacity:0.3;fill:#C08329;enable-background:new    ;}\r\n\t.st217{fill:#C3922E;}\r\n\t.st218{fill:#6C301E;}\r\n\t.st219{opacity:0.5;fill:#6C301E;enable-background:new    ;}\r\n\t.st220{fill:#9EA0A4;}\r\n\t.st221{opacity:0.8;fill:#B2B6BA;enable-background:new    ;}\r\n\t.st222{fill:url(#SVGID_00000173156254369539234100000005979305951806038402_);}\r\n\t.st223{fill:url(#SVGID_00000119798213783027809500000005403187537789326783_);}\r\n\t.st224{fill:url(#SVGID_00000006667108073550448900000012388344748614541488_);}\r\n\t.st225{opacity:0.9;fill:#E9E9EA;enable-background:new    ;}\r\n\t.st226{fill:#212121;}\r\n\t.st227{opacity:0.1;fill:#D2D5D4;enable-background:new    ;}\r\n\t.st228{opacity:0.2;fill:#D2D5D4;enable-background:new    ;}\r\n\t.st229{opacity:0.8;fill:#8C959D;enable-background:new    ;}\r\n\t.st230{fill:#C59E78;}\r\n\t.st231{opacity:0.7;fill:#747678;enable-background:new    ;}\r\n\t.st232{fill:url(#SVGID_00000127011572727577767380000001665185444223043243_);}\r\n\t.st233{opacity:0.2;fill:url(#SVGID_00000076572239725075055880000010137548499051456682_);enable-background:new    ;}\r\n\t.st234{fill:url(#SVGID_00000072979801466408113770000004724336553562920092_);}\r\n\t.st235{opacity:0.2;fill:url(#SVGID_00000098927538270771085080000018407911818466609333_);enable-background:new    ;}\r\n\t.st236{fill:url(#SVGID_00000175311469322056161670000003629593258886975400_);}\r\n\t.st237{opacity:0.2;fill:url(#SVGID_00000174561393628850241130000012354667371014634396_);enable-background:new    ;}\r\n\t.st238{fill:url(#SVGID_00000044898831003158117310000005945849126026233511_);}\r\n\t.st239{opacity:0.2;fill:url(#SVGID_00000012445255851044262190000008763658974249638589_);enable-background:new    ;}\r\n\t.st240{opacity:0.6;fill:url(#SVGID_00000083054397164797390900000010969633455818902420_);enable-background:new    ;}\r\n\t.st241{fill:url(#SVGID_00000157989166180013599700000003887577217756477854_);}\r\n\t.st242{opacity:0.2;fill:url(#SVGID_00000085251378323286758880000006104925470839244424_);enable-background:new    ;}\r\n\t.st243{opacity:0.6;}\r\n\t.st244{fill:#F4E6D0;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,98.4c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C355.4,90.6,364,93.5,366.3,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.8,215c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C373.8,207.3,382.5,210.1,384.8,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.6,243.7c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C237.7,235.8,246.3,238.8,248.6,243.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.9,209.6c4.6,9.9-5.6,19.9-22.6,22.6c-17.1,2.6-34.5-3.3-39.1-13c-4.6-9.9,5.6-19.9,22.6-22.6 C513.8,194.1,531.4,199.9,535.9,209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.8,558.3c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C279.9,550.6,288.6,553.4,290.8,558.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468.7,711.6c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C457.7,703.9,466.4,706.7,468.7,711.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M538,562.3c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C527.1,554.5,535.7,557.5,538,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M806.5,480.4c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 S804.3,475.5,806.5,480.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M769.2,430.7c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 S767.1,425.8,769.2,430.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M836.4,283.6c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C825.4,275.8,834.1,278.8,836.4,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M739.6,243.9c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C728.6,236.1,737.3,239.1,739.6,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.1,227.2c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C654.1,219.4,662.9,222.3,665.1,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669,209.1c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C658,201.3,666.7,204.3,669,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1016.6,288.1c-0.9-2.2-3.3-3.9-6.1-5.1c-3.8-3-10.3-4.3-16.8-3.4c-8.4,1.4-13.4,6.4-11.2,11.2 c0.9,2.2,3.3,3.9,6.1,5.1c3.8,3,10.3,4.3,16.8,3.4C1013.8,297.8,1018.8,292.8,1016.6,288.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M804.8,673.1c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C793.9,665.3,802.5,668.2,804.8,673.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M789,720.8c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C778,713.1,786.7,715.9,789,720.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M877.4,718.6c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C866.5,710.9,875.3,713.7,877.4,718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M994.6,518.5c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C997.4,500.4,1003.1,517.1,994.6,518.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M904.5,519.1c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C907.4,501.1,913,517.8,904.5,519.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.4,532.4c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C691.1,514.9,696.8,531.1,688.4,532.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.5,544.7c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C175.2,527.3,180.9,543.4,172.5,544.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.5,532.5c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C197.2,515.1,202.9,531.3,194.5,532.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.9,529.8c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C157.6,512.4,163.3,528.5,154.9,529.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.7,216.6c-3.5,0.5-6.9,2.6-10.4,2.6c-0.5,0-19.4,0-19.9,0c-20.6,0-39.4-7.9-45-19.9 c-6.6-14.4,8.1-29.1,32.9-32.9c3.1-0.5,6.2-0.8,9.3-0.8c0.7,0,19.6,0,20.3,0C507.7,165.2,524.5,212.6,499.7,216.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M891,505.1c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C893.7,486.9,899.4,503.7,891,505.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M859,247.6c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C861.7,229.6,867.4,246.4,859,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M753.8-45.6c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C756.6-63.7,762.3-46.9,753.8-45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.9,79.1c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-12.7,0-12.9,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,12.9,0,13,0C660.7,61,666.4,77.8,657.9,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.4,734.5c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C418.5,726.6,427.1,729.6,429.4,734.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.2,80.1c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C358.2,72.4,366.9,75.2,369.2,80.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "167.9,703.9 210.9,728.5 234.8,728.5 253.8,654.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.4,681.9 148.7,710.9 172.8,710.9 184.3,632.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "407.1,126.4 538,202.1 566.7,202.1 492.9,76.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879.6,625.3l72.3,41.8c2,1.2,2.3,3,0.5,4.1l-45.4,26.1c-1.8,1.1-5,0.9-7-0.3l-72.3-42c-2-1.2-2.3-3-0.5-4.1 l45.4-26.1C874.4,624,877.6,624.1,879.6,625.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.6,682.1l79.2,45.6c3.1,1.8,9.8,2,12.7,0.3l115.7-67c3.1-1.8,3-4.7,0-6.5l-80.8-45.9 c-3.1-1.8-8.1-1.8-11.1,0l-115.7,67C477.5,677.3,477.5,680.3,480.6,682.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M672.9,398.8l-66.5,38.7c-0.5,0.3-3.3,0.3-3.9,0l-21.7-12.5c-0.5-0.3-0.5-0.9,0-1.2l67.6-39 c0.5-0.3,1.5-0.3,2.2,0l22.3,12.9C673.6,397.9,673.6,398.4,672.9,398.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M964,635.2l-86.4-52.5l-31,17.9c-3.1,1.8-3.1,6.2,0,8l98.7,57c2.2,1.2,4.7,1.9,7.3,1.9h21.5L964,635.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "826.5,301.6 770.4,334 797.5,349.6 921.2,349.6 937.1,301.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M626.7,386.9l-15.7-9.1c-0.4-0.3-1.1-0.3-1.5,0l-10.2,5.8h-23.2l-0.8-1.2l25.1-19.9l-57.2-15.2L424.5,416 l4.2,2.4l86.4-0.5l36.2-20.9l24.2,0.5l-5.1,3c-0.4,0.3-0.4,0.7,0,0.9l15.7,9.1c0.3,0.1,0.5,0.1,0.8,0.1h4.1c0,0-0.8-1.2-0.7-1.2 l36.4-21.5C627.1,387.5,627.1,387.1,626.7,386.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376.6,522.9 380.7,518.3 376.8,503.6 341,491.8 314.3,507.1 366.3,537.1 373.5,537.1 375.9,538.5  380.7,538.5 379.3,528.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.9,472.1c0-0.1,0-0.3-0.1-0.4l-0.1-0.1l-0.1-0.1l0,0l0,0l0,0l0,0c0,0-0.1,0-0.1-0.1 c-0.4-0.3-0.8-0.4-1.2-0.5c-0.1,0-0.1,0-0.3-0.1c-0.4-0.1-0.9-0.3-1.4-0.4c-0.1,0-0.3,0-0.4,0c-0.4-0.1-0.9-0.1-1.4-0.1 c-0.1,0-0.3,0-0.4,0c-0.5,0-1.1,0-1.6,0c-0.1,0-0.3,0-0.4,0c-0.8,0-1.5,0.1-1.6,0.1c-0.8,0.1-3.4,0.4-5.1,1.4h-0.1l0,0 c-0.7,0.4-58.8,34-94.1,56.2c-16.3,10.2-17.7,11.8-23,15.7c0.1,0,0.3-0.1,0.4-0.1c-0.4,0.1-0.8,0.4-0.5,0.7 c-4.9,4.2-2.4,3,3.4,0.5c1.2-0.1,4.1-1.6,5.3-2.3l0,0c6.8-3,13.8-6.8,21.1-10.7c9.2-5,18.8-10.3,38.6-21.5 c28.6-16.3,62-35.9,62.6-36.3l0,0l0.1-0.1c0.5-0.3,0.7-0.7,0.8-0.9C534.9,472.4,534.9,472.3,534.9,472.1 C534.9,472.3,534.9,472.1,534.9,472.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31__6_"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "271.5,653.8 172.8,710.8 121.7,681.2 121.7,657.1 271.5,629.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.5,645.6v0.8l-98.7,57l-0.1-0.1l-50.9-29.5V673l51.1,29.5L271.5,645.6z M172.8,699.9l-51.1-29.5v0.8 l50.9,29.5l0.1,0.1l98.7-57v-0.8L172.8,699.9z M172.8,705.3l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57v-0.8L172.8,705.3z  M271.5,651l-98.7,57l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57V651z M172.8,697.2l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57 v-0.8L172.8,697.2z M172.8,689.1l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57v-0.8L172.8,689.1z M172.8,691.8l-51.1-29.5v0.8 l50.9,29.5l0.1,0.1l98.7-57v-0.8L172.8,691.8z M172.8,694.5L121.7,665v0.8l50.9,29.5l0.1,0.1l98.7-57v-0.8L172.8,694.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "168.5,645.6 121.7,657.1 121.7,681.2 172.8,710.8 172.8,686.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "271.5,629.6 172.8,686.7 121.7,657.1 220.5,600.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "271.5,629.6 172.8,686.7 121.7,657.1 220.3,600.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "250.9,641.6 200.6,670.7 149.4,641.2 206.5,608.1 229.1,621.1 222.4,625  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M179.7,628.6l-14.6,29.4l-0.3-0.1l14.6-29.4L179.7,628.6z M176.6,626.8L162,656.2l0.3,0.1l14.6-29.4 L176.6,626.8z M182.3,630.1l-14.5,29.5l0.3,0.1l14.6-29.4L182.3,630.1z M185.3,631.7l-14.6,29.4l0.3,0.1l14.6-29.4 L185.3,631.7z M172.4,627.9l-13.3,26.7l0.3,0.1l13.4-27.2L172.4,627.9z M188.1,633.4l-14.6,29.4l0.3,0.1l14.6-29.4 L188.1,633.4z M162.1,633.8l-8.7,17.5l0.3,0.1l8.8-17.9L162.1,633.8z M146.5,642.8l-1.8,3.5l0.3,0.1l2-3.9L146.5,642.8z  M151.8,639.8l-4.1,8.1l0.3,0.1l4.3-8.7L151.8,639.8z M157,636.8l-6.4,12.9l0.3,0.1l6.5-13.3L157,636.8z M167.2,630.9 l-11,22.1l0.3,0.1l11.1-22.5L167.2,630.9z M190.9,635.1l-14.6,29.4l0.3,0.1l14.6-29.4L190.9,635.1z M222.4,653.2l-3.3,6.6 l0.5-0.3l3.1-6.2L222.4,653.2z M216.7,650l-7.9,16l0.5-0.3l7.6-15.6L216.7,650z M213.8,648.3l-10.2,20.6l0.5-0.3l10-20.2 L213.8,648.3z M225.3,654.8l-0.9,2l0.5-0.3l0.8-1.6L225.3,654.8z M219.5,651.6L214,663l0.5-0.3l5.4-10.8L219.5,651.6z  M211,646.6l-12.5,25.2l0.5-0.3l12.3-24.8L211,646.6z M199.5,639.9l-14.6,29.4l0.3,0.1l14.6-29.4L199.5,639.9z M196.6,638.3 L182,667.7l0.3,0.1l14.6-29.4L196.6,638.3z M193.8,636.7l-14.6,29.4l0.3,0.1l14.6-29.4L193.8,636.7z M205.3,643.3l-14.6,29.4 l0.3,0.1l14.6-29.4L205.3,643.3z M202.3,641.7l-14.6,29.4l0.3,0.1l14.6-29.4L202.3,641.7z M208.1,644.9l-14.6,29.5l0.3,0.1 l0,0l14.5-29.4L208.1,644.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "238.6,615.7 204.8,635.3 182.1,622.2 216,602.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "268.5,631.4 233.3,651.7 226,647.5 257.8,629.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191.1,627.6L191.1,627.6c-9.3,5.4-9.3,14.2,0,19.6c9.3,5.4,24.5,5.4,33.9,0l0,0L191.1,627.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "233.7,651.4 232.4,652.3 181.3,622.7 182.7,621.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "147.9,653.1 133.8,661.2 126.6,657.1 140.7,649  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M196.8,622.2c-0.9,0.5-1.6,1.4-1.6,2H195l-2.8-2.2c-0.4-0.3-0.3-0.4,0-0.5l4.3-2.6l-0.8-0.9h-0.3 l-5.8,3.4v0.1l5.6,3.7l0.7-0.1c-0.1-0.9,0.3-1.6,1.2-2.2c1.1-0.7,3.3-0.9,5.6,0.4c1.8,1.1,2.4,2.3,0.9,3.1 c-1.2,0.7-2.7,0.5-4.1,0.1c-0.4-0.1-0.7-0.1-0.9,0c-0.4,0.1-0.5,0.7,0,1.1c0.8,0.4,3.3,0.4,5.6-0.8c2.8-1.6,2.4-3.4,0.3-4.7 C201.6,620.8,198.8,621.1,196.8,622.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M201.5,614.3c-2.8,1.6-1.4,3.8,2.2,5.8c3.5,2,7.2,3,10,1.2c2.8-1.6,1.4-3.8-2.2-5.8 C208,613.5,204.4,612.7,201.5,614.3z M213,621.1c-1.6,0.9-4.7-0.3-7.6-1.9c-2.8-1.6-5-3.4-3.4-4.3s4.7,0.3,7.6,1.9 C212.6,618.3,214.6,620,213,621.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M210.9,609.1c-2.8,1.6-1.4,3.8,2.2,5.8c3.5,2,7.2,3,10,1.2c2.8-1.6,1.4-3.8-2.2-5.8 C217.4,608.2,213.7,607.3,210.9,609.1z M222.4,615.7c-1.6,0.9-4.7-0.3-7.6-1.9c-2.8-1.6-5-3.4-3.4-4.3 c1.6-0.9,4.7,0.3,7.6,1.9C222,613,224,614.7,222.4,615.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M170.2,677.6c-0.7,0.4-1.1,0.9-1.1,1.4l0,0l-2-1.5c-0.3-0.1-0.3-0.3,0-0.4l3-1.8l-0.5-0.7h-0.1 l-4.1,2.3v0.1l3.8,2.4l0.4-0.1c-0.1-0.7,0.1-1.1,0.8-1.5c0.8-0.4,2.2-0.5,3.8,0.3c1.2,0.7,1.6,1.6,0.7,2.2 c-0.8,0.5-1.9,0.4-2.8,0.1c-0.3-0.1-0.4-0.1-0.7,0s-0.4,0.5,0,0.7c0.5,0.3,2.2,0.3,3.8-0.5c2-1.2,1.8-2.4,0.1-3.3 C173.6,676.6,171.6,676.6,170.2,677.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M173.5,672.2c-2,1.2-0.9,2.6,1.5,3.9c2.4,1.4,4.9,2,6.9,0.8c2-1.2,0.9-2.6-1.5-3.9 C177.9,671.6,175.5,671,173.5,672.2z M181.5,676.8c-1.1,0.7-3.3-0.1-5.3-1.4c-2-1.1-3.4-2.3-2.3-3c1.1-0.7,3.3,0.1,5.3,1.4 C181.1,674.9,182.5,676.1,181.5,676.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M179.8,668.4c-2,1.2-0.9,2.6,1.5,3.9c2.4,1.4,4.9,2,6.9,0.8c2-1.2,0.9-2.6-1.5-3.9 C184.3,667.8,181.9,667.3,179.8,668.4z M187.8,673c-1.1,0.7-3.3-0.1-5.3-1.4c-2-1.1-3.4-2.3-2.3-3c1.1-0.7,3.3,0.1,5.3,1.4 C187.6,671.1,188.9,672.3,187.8,673z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M230.9,609.1l-1.6,3.3l-0.5-0.1l1.6-3.3L230.9,609.1z M232,609.9l-1.6,3.3l0.5,0.1l1.6-3.3L232,609.9z  M233.7,611l-1.6,3.3l0.5,0.1l1.6-3.3L233.7,611z M235.5,611.9l-1.6,3.3l0.5,0.1l1.6-3.3L235.5,611.9z M237.1,612.9l-1.6,3.3 l0.5,0.1l1.6-3.3L237.1,612.9z M238.9,613.9l-1.6,3.3l0.5,0.1l1.6-3.3L238.9,613.9z M240.6,614.9l-1.6,3.3l0.5,0.1l1.6-3.3 L240.6,614.9z M242.4,615.8l-1.6,3.3l0.5,0.1l1.6-3.3L242.4,615.8z M244,616.9l-1.6,3.3l0.5,0.1l1.6-3.3L244,616.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M133.8,653.6c-1.6,0.9-1.6,2.6,0,3.5c1.6,0.9,4.5,0.9,6.1,0s1.6-2.6,0-3.5 C138.3,652.5,135.6,652.5,133.8,653.6z M139.5,656.9c-1.5,0.8-3.8,0.8-5.3,0c-1.5-0.8-1.5-2.2,0-3.1c1.5-0.8,3.8-0.8,5.3,0 C141,654.6,141,656.1,139.5,656.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M179.7,626.5l2.2,0.4l1.9-0.8v1.4l1.9,0.8l-2.2,0.4l-0.7,1.2l-1.4-1.1h-2.3l1.4-1.1L179.7,626.5z  M172.8,635.6l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8V634l-1.9,0.8l-2.2-0.4L172.8,635.6z M172.8,644.3l-1.4,1.1h2.3 l1.4,1.1l0.7-1.2l2.2-0.4L176,644v-1.4l-1.9,0.8l-2.2-0.4L172.8,644.3z M180.5,652l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4 l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L180.5,652z M193.9,656.5l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8 l-2.2-0.4L193.9,656.5z M208.8,656.5l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L208.8,656.5z  M222.2,652l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L222.2,652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "185.9,620 162,633.8 213.2,663.5 237.1,649.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "237.1,673.7 213.2,687.5 213.2,663.5 237.1,649.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "234.4,651.2 183.2,621.7 186.2,619.9 237.4,649.4 237.4,673.5 234.4,675.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "212.6,663.8 161.4,634.1 164.4,632.5 215.7,662 215.7,686 212.6,687.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "234.4,651.2 237.4,649.4 237.4,673.5 234.4,675.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "212.6,663.8 215.7,662 215.7,686 212.6,687.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "337.3,669.3 234.8,728.5 193.2,704.5 193.2,683.1 337.3,647.9  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M337.3,662.1v0.7L234.8,722l-0.1-0.1l-41.4-24v-0.7l41.6,24.1L337.3,662.1z M234.8,718.9l-41.6-24.1v0.7 l41.4,24l0.1,0.1l102.5-59.2v-0.7L234.8,718.9z M234.8,723.6l-41.6-24.1v0.7l41.4,24l0.1,0.1l102.5-59.2v-0.7L234.8,723.6z  M337.3,666.9l-102.5,59.2L193.2,702v0.7l41.4,24l0.1,0.1l102.5-59.2L337.3,666.9L337.3,666.9z M234.8,716.5l-41.6-24.1v0.7 l41.4,24l0.1,0.1l102.5-59.2v-0.7L234.8,716.5z M234.8,709.3l-41.6-24v0.7l41.4,24l0.1,0.1l102.5-59.2v-0.8L234.8,709.3z  M234.8,711.7l-41.6-24.1v0.7l41.4,24l0.1,0.1l102.5-59.2v-0.7L234.8,711.7z M234.8,714.2L193.2,690v0.7l41.4,24l0.1,0.1 l102.5-59.2V655L234.8,714.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "234.8,673 193.2,683.1 193.2,704.5 234.8,728.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "337.3,647.9 234.8,707.1 193.2,683.1 295.8,624  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M235.1,705.5c-0.1,0.1-0.3,0.1-0.4,0l-38.5-22.2c-0.1-0.1-0.1-0.1,0-0.3l99.3-57.3 c0.1-0.1,0.3-0.1,0.4,0l38.5,22.2c0.1,0.1,0.1,0.1,0,0.3L235.1,705.5z M205,683.4c-1.4,0.8-1.4,2,0,2.7l24.6,14.2 c1.2,0.7,3.4,0.7,4.7,0l91.1-52.7c1.4-0.8,1.4-2,0-2.7l-24.6-14.2c-1.2-0.7-3.4-0.7-4.7,0L205,683.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.8,625.7l38.5,22.2L235,705.2L196.5,683L295.8,625.7L295.8,625.7z M234.6,700.5l91.1-52.7 c1.5-0.8,1.5-2.2,0-3L301,630.6c-1.4-0.8-3.7-0.8-5.1,0l-91.1,52.7c-1.5,0.8-1.5,2.2,0,3l24.6,14.2 C230.9,701.3,233.2,701.3,234.6,700.5L234.6,700.5z M295.2,625.4L196,682.7c-0.3,0.1-0.3,0.4,0,0.5l38.5,22.2 c0.3,0.1,0.7,0.1,0.9,0l99.3-57.3c0.3-0.1,0.3-0.4,0-0.5l-38.5-22.2C295.9,625.3,295.5,625.3,295.2,625.4L295.2,625.4z  M234.1,700.2c-1.2,0.7-3.1,0.7-4.2,0L205.3,686c-1.2-0.7-1.1-1.8,0-2.4l91.1-52.7c1.2-0.7,3.1-0.7,4.2,0l24.6,14.2 c1.2,0.7,1.1,1.8,0,2.4L234.1,700.2L234.1,700.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M284.4,636L284.4,636l-3.3-1.8c-0.3-0.1-0.7-0.1-0.9,0l-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l0,0l1.8,1.1 l-0.1,0.1c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l2.2-1.2c0.3-0.1,0.3-0.4,0-0.5l-0.4-0.3 C285.1,635.9,284.7,635.9,284.4,636z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M289.7,630.5c-0.4-0.1-0.8-0.3-1.2-0.3c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4 c-0.3,0.1-0.5,0.3-0.7,0.5s-0.3,0.4-0.1,0.7c0,0.1,0,0.3,0.1,0.4c-0.3,0-0.4-0.1-0.7-0.1c-0.4,0-0.8,0-1.1,0.1 c-0.3,0.1-0.7,0.3-0.9,0.4c-0.3,0.1-0.5,0.3-0.7,0.5s-0.3,0.4-0.1,0.7c0,0.3,0.1,0.4,0.4,0.7c0.3,0.3,0.5,0.4,0.9,0.7 s0.8,0.4,1.2,0.5c0.4,0.1,0.8,0.3,1.2,0.3c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4s0.5-0.3,0.7-0.5s0.3-0.4,0.3-0.7 c0-0.1,0-0.3-0.1-0.4c0.3,0,0.4,0.1,0.7,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4c0.3-0.1,0.5-0.3,0.7-0.5 s0.3-0.4,0.3-0.7s-0.1-0.4-0.4-0.7c-0.3-0.3-0.5-0.4-0.9-0.7S290.1,630.6,289.7,630.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M284.3,636.6l0.5-0.3l0.4,0.3l-2.2,1.2l-0.4-0.3l0.7-0.4l-2.7-1.5l-0.5,0.3l-0.4-0.3 c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.3-0.3,0.3-0.5l0.3-0.1L284.3,636.6z M285.9,632.8c0.4,0.1,0.7,0.3,1.1,0.5 c0.4,0.3,0.7,0.4,0.8,0.7s0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5c-0.4-0.3-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 s0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1 C285.2,632.5,285.6,632.6,285.9,632.8z M285.9,633.8c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3 c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3 c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0 s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3C286.4,634.2,286.2,634.1,285.9,633.8z M290.3,631.3 c0.4,0.3,0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5c-0.4-0.3-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1s0.7,0.1,0.9,0.1 C289.7,630.9,289.9,631,290.3,631.3z M289.3,631.9c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5 c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.3-0.1-0.4-0.3C289.8,632.4,289.5,632.1,289.3,631.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M299.7,657l-0.3,0.1l-7.4-4.3c-0.5-0.4-1.6-0.4-2.2,0l-0.7,0.4c-0.3,0.1-0.4,0.4-0.4,0.7 s-0.1,0.5-0.4,0.7c-0.3,0.3-0.7,0.5-1.1,0.8c-0.5,0.4-0.5,0.9,0,1.2l1.1,0.7c0.5,0.4,1.6,0.4,2.2,0h0.1l4.3,2.4l-0.4,0.3 c-0.5,0.4-0.5,0.9,0,1.2l0.9,0.5c0.5,0.4,1.6,0.4,2.2,0l5.3-3.1c0.5-0.4,0.5-0.9,0-1.2l-0.9-0.5 C301.2,656.6,300.2,656.6,299.7,657z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M312,643.6c-0.9-0.3-2-0.5-2.8-0.5c-0.9,0-1.9,0-2.7,0.3c-0.8,0.3-1.5,0.5-2.2,0.9 c-0.7,0.4-1.2,0.8-1.5,1.2c-0.4,0.5-0.5,1.1-0.5,1.6c0,0.3,0.1,0.5,0.4,0.9c-0.5-0.1-1.1-0.1-1.6-0.1 c-0.9,0-1.9,0-2.7,0.3s-1.5,0.5-2.2,0.9s-1.2,0.8-1.5,1.2c-0.4,0.5-0.5,1.1-0.5,1.6c0.1,0.5,0.4,1.1,0.9,1.6 c0.5,0.5,1.4,1.1,2.3,1.8c1.1,0.7,2,1.1,3,1.4c0.9,0.3,1.9,0.5,2.8,0.5s1.9,0,2.7-0.3c0.8-0.3,1.5-0.5,2.2-0.8 c0.7-0.4,1.2-0.8,1.5-1.2c0.4-0.5,0.5-1.1,0.5-1.6c0-0.3-0.1-0.5-0.3-0.9c0.5,0.1,1.1,0.1,1.5,0.1c0.9,0,1.9,0,2.7-0.3 c0.8-0.3,1.5-0.5,2.2-0.8c0.7-0.4,1.2-0.8,1.5-1.2c0.4-0.5,0.5-1.1,0.5-1.6c-0.1-0.5-0.4-1.1-0.9-1.6 c-0.5-0.5-1.4-1.1-2.3-1.8C313.9,644.4,313,643.9,312,643.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M299.3,658.2l1.4-0.8l0.9,0.5l-5.3,3.1l-0.9-0.5l1.5-0.8l-6.4-3.7l-1.1,0.7l-1.1-0.7 c0.5-0.3,1.1-0.7,1.4-1.1c0.4-0.4,0.5-0.8,0.5-1.1l0.7-0.4L299.3,658.2z M303.1,649c0.8,0.3,1.6,0.7,2.6,1.2 c0.9,0.5,1.6,1.1,2,1.5c0.4,0.4,0.7,0.9,0.8,1.4c0,0.4,0,0.8-0.4,1.1c-0.3,0.4-0.7,0.7-1.2,0.9c-0.5,0.3-1.1,0.5-1.8,0.7 c-0.5,0.1-1.2,0.3-1.9,0.1c-0.7,0-1.5-0.1-2.3-0.4s-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5c-0.4-0.4-0.7-0.9-0.8-1.4 c0-0.4,0-0.8,0.3-1.1c0.3-0.4,0.7-0.7,1.2-0.9s1.1-0.5,1.8-0.7c0.5-0.1,1.2-0.3,2-0.3C301.5,648.6,302.3,648.7,303.1,649z  M302.9,651.7c-0.8-0.5-1.5-0.8-2-1.1c-0.5-0.3-0.9-0.4-1.4-0.5c-0.4-0.1-0.5-0.1-0.8-0.1c-0.1,0-0.4,0-0.4,0.1 c-0.1,0-0.1,0.1-0.3,0.3c0,0.1,0,0.3,0.3,0.4c0.1,0.1,0.5,0.4,0.9,0.8c0.4,0.3,1.1,0.7,1.9,1.2c0.8,0.5,1.5,0.8,2,1.1 c0.5,0.3,0.9,0.4,1.4,0.5c0.4,0.1,0.5,0.1,0.8,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.3-0.3c0-0.1,0-0.3-0.3-0.4 c-0.1-0.1-0.5-0.4-0.9-0.8C304.4,652.7,303.8,652.3,302.9,651.7z M313.8,645.5c0.9,0.5,1.6,1.1,2,1.5 c0.4,0.4,0.7,0.9,0.8,1.4c0,0.4,0,0.8-0.4,1.1c-0.3,0.4-0.7,0.7-1.2,0.9c-0.5,0.3-1.1,0.5-1.8,0.7 c-0.5,0.1-1.2,0.3-1.9,0.1c-0.7,0-1.5-0.1-2.3-0.4c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5 c-0.4-0.4-0.7-0.9-0.8-1.4c0-0.4,0-0.8,0.3-1.1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.3,1.1-0.5,1.8-0.7c0.5-0.1,1.2-0.3,2-0.3 c0.7,0,1.5,0.1,2.3,0.4C312,644.5,312.8,644.9,313.8,645.5z M311.1,647.1c-0.8-0.5-1.5-0.8-2-1.1c-0.5-0.3-0.9-0.4-1.4-0.5 c-0.4-0.1-0.5-0.1-0.8-0.1c-0.1,0-0.4,0-0.4,0.1c-0.1,0-0.1,0.1-0.3,0.3c0,0.1,0,0.3,0.3,0.4c0.1,0.1,0.5,0.4,0.9,0.8 c0.4,0.3,1.1,0.7,1.9,1.2s1.5,0.8,2,1.1c0.5,0.3,0.9,0.4,1.4,0.5c0.4,0.1,0.5,0.1,0.8,0.1c0.1,0,0.3,0,0.4-0.1 c0.1-0.1,0.1-0.1,0.3-0.3c0-0.1,0-0.3-0.3-0.4c-0.1-0.1-0.5-0.4-0.9-0.8C312.6,647.9,311.9,647.5,311.1,647.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M209.2,679.5L209.2,679.5l-3.3-1.8c-0.3-0.1-0.7-0.1-0.9,0l-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l0,0l1.8,1.1 l-0.1,0.1c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l2.2-1.2c0.3-0.1,0.3-0.4,0-0.5l-0.4-0.3 C209.9,679.3,209.5,679.3,209.2,679.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M214.4,673.9c-0.4-0.1-0.8-0.3-1.2-0.3s-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4 c-0.3,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.3,0.4-0.1,0.7c0,0.1,0,0.3,0.1,0.4c-0.3,0-0.4-0.1-0.7-0.1c-0.4,0-0.8,0-1.1,0.1 c-0.3,0.1-0.7,0.3-0.9,0.4c-0.3,0.1-0.5,0.3-0.7,0.5s-0.3,0.4-0.1,0.7c0,0.3,0.1,0.4,0.4,0.7c0.3,0.3,0.5,0.4,0.9,0.7 c0.4,0.3,0.8,0.4,1.2,0.5s0.8,0.3,1.2,0.3s0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4c0.3-0.1,0.5-0.3,0.7-0.5 c0.1-0.3,0.3-0.4,0.3-0.7c0-0.1,0-0.3-0.1-0.4c0.3,0,0.4,0.1,0.7,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4 c0.3-0.1,0.5-0.3,0.7-0.5s0.3-0.4,0.3-0.7s-0.1-0.4-0.4-0.7c-0.3-0.3-0.5-0.4-0.9-0.7 C215.2,674.2,214.8,674.1,214.4,673.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M209.1,680l0.5-0.3l0.4,0.3l-2.2,1.2l-0.4-0.3l0.7-0.4l-2.7-1.5l-0.5,0.3l-0.4-0.3 c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.3-0.3,0.3-0.5l0.3-0.1L209.1,680z M210.6,676.1c0.4,0.1,0.7,0.3,1.1,0.5 s0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 c0-0.1,0-0.3,0.1-0.4s0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1C210,676,210.3,676.1,210.6,676.1z  M210.6,677.3c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3 c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3 C211.3,677.7,211,677.6,210.6,677.3z M215.2,674.7c0.4,0.3,0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5 c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5 s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3 c0.3-0.1,0.5-0.1,0.8-0.1c0.3,0,0.7,0.1,0.9,0.1C214.4,674.3,214.8,674.5,215.2,674.7z M214,675.4 c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3 c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3 C214.6,675.7,214.4,675.6,214,675.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M243.2,699.1L243.2,699.1l-3.3-1.8c-0.3-0.1-0.7-0.1-0.9,0l-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l0,0l1.8,1.1 l-0.1,0.1c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l2.2-1.2c0.3-0.1,0.3-0.4,0-0.5l-0.4-0.3 C243.9,699,243.5,699,243.2,699.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M248.5,693.6c-0.4-0.1-0.8-0.3-1.2-0.3s-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4 c-0.3,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.3,0.4-0.1,0.7c0,0.1,0,0.3,0.1,0.4c-0.3,0-0.4-0.1-0.7-0.1c-0.4,0-0.8,0-1.1,0.1 c-0.3,0.1-0.7,0.3-0.9,0.4c-0.3,0.1-0.5,0.3-0.7,0.5s-0.3,0.4-0.1,0.7c0,0.3,0.1,0.4,0.4,0.7c0.3,0.3,0.5,0.4,0.9,0.7 c0.4,0.3,0.8,0.4,1.2,0.5c0.4,0.1,0.8,0.3,1.2,0.3c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4c0.3-0.1,0.5-0.3,0.7-0.5 s0.3-0.4,0.3-0.7c0-0.1,0-0.3-0.1-0.4c0.3,0,0.4,0.1,0.7,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4 c0.3-0.1,0.5-0.3,0.7-0.5c0.1-0.3,0.3-0.4,0.3-0.7s-0.1-0.4-0.4-0.7c-0.3-0.3-0.5-0.4-0.9-0.7 C249.3,694,248.9,693.7,248.5,693.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M243.1,699.7l0.5-0.3l0.4,0.3l-2.2,1.2l-0.4-0.3l0.7-0.4l-2.7-1.5l-0.5,0.3l-0.4-0.3 c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.3-0.3,0.3-0.5l0.3-0.1L243.1,699.7z M244.7,695.9c0.4,0.1,0.7,0.3,1.1,0.5 c0.4,0.3,0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5-0.1-0.9-0.1c-0.3-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 s0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1 C244,695.6,244.4,695.7,244.7,695.9z M244.7,697c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5 c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.3-0.1-0.4-0.3C245.3,697.4,245,697.2,244.7,697z M249.2,694.4c0.4,0.3,0.7,0.4,0.8,0.7 c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 c0-0.1,0-0.3,0.1-0.4s0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1c0.3,0,0.7,0.1,0.9,0.1 S248.8,694.1,249.2,694.4z M248.1,695.1c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5 c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.3-0.1-0.4-0.3C248.6,695.5,248.4,695.2,248.1,695.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.2336,
    y1: 150.4976,
    x2: 248.2336,
    y2: 174.8262,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 236.8348 941.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C6C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#81908B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M294.4,641.4c2.2,1.2,2.2,3.3,0,4.5c-2.2,1.2-5.7,1.2-7.9,0c-2.2-1.2-2.2-3.3,0-4.5 C288.7,640.2,292.2,640.2,294.4,641.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030476282015025346240000012347010154308007552_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.8482,
    y1: 114.1376,
    x2: 177.8482,
    y2: 192.5032,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 236.8348 941.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C6C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#81908B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030476282015025346240000012347010154308007552_)"
    },
    d: "M244.6,677.5 c6.9,4.1,6.9,10.6,0,14.5c-6.9,4.1-18.3,4.1-25.2,0s-6.9-10.6,0-14.5C226.3,673.5,237.7,673.5,244.6,677.5z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M245,692.3c-7.2,4.2-19,4.2-26.1,0c-7.2-4.2-7.2-11,0-15c7.2-4.2,19-4.2,26.1,0 C252.3,681.4,252.3,688.1,245,692.3z M219.8,677.7c-6.6,3.9-6.6,10.2,0,14.1c6.6,3.9,17.6,3.9,24.2,0 c6.6-3.9,6.6-10.2,0-14.1C237.4,673.9,226.6,673.9,219.8,677.7z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M237.7,677.9c-0.5-0.1-0.8-0.1-1.2-0.1c-0.7,0.1-1.1,0.4-1.2,0.7c0,0.1,0,0.4,0.3,0.7s0.5,0.5,1.1,0.8 c0.4,0.3,1.1,0.7,2,1.2c0.8,0.5,1.5,0.8,2.2,1.1c0.5,0.3,1.1,0.4,1.5,0.5c0.5,0.1,0.8,0.3,1.2,0.1c0.3,0,0.5-0.1,0.8-0.3 c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1,0-0.4-0.3-0.7c-0.3-0.3-0.5-0.5-1.1-0.8c-0.4-0.3-1.1-0.7-1.9-1.2c-0.8-0.5-1.6-0.8-2.2-1.1 C238.5,678.1,238.1,678,237.7,677.9z M242.7,681.1c0.4,0.3,0.8,0.5,0.9,0.8c0.1,0.1,0.3,0.4,0.3,0.4c0,0.3-0.3,0.4-0.7,0.4 c-0.1,0-0.4,0-0.8-0.1c-0.4-0.1-0.8-0.3-1.4-0.5c-0.5-0.3-1.2-0.7-2-1.1c-0.8-0.5-1.5-0.9-1.9-1.2s-0.8-0.5-0.9-0.8 c-0.1-0.1-0.3-0.4-0.3-0.4c0-0.1,0.1-0.1,0.3-0.3c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.8,0.1c0.4,0.1,0.8,0.3,1.4,0.5 s1.2,0.7,2,1.1C241.6,680.3,242.3,680.7,242.7,681.1z M241.1,676.9c-0.8-0.3-1.6-0.4-2.4-0.4c-0.8,0-1.5,0-2.2,0.3 c-1.2,0.4-2.4,1.1-3.1,1.8c-0.3,0.4-0.4,0.8-0.4,1.2c0,0.4,0.3,0.9,0.8,1.4c0.4,0.5,1.2,0.9,2.2,1.6 c0.9,0.5,1.9,0.9,2.7,1.2c0.8,0.3,1.6,0.4,2.4,0.4c0.8,0,1.5,0,2.2-0.3c0.7-0.1,1.2-0.4,1.8-0.7s0.9-0.7,1.4-1.1 c0.3-0.4,0.4-0.8,0.4-1.2c0-0.4-0.3-0.9-0.8-1.4c-0.4-0.5-1.2-0.9-2.2-1.6C242.8,677.6,241.9,677.2,241.1,676.9z  M245.4,679.9c0.4,0.4,0.7,0.8,0.7,1.2s0,0.7-0.3,1.1c-0.5,0.7-1.6,1.4-2.8,1.6c-0.5,0.1-1.2,0.3-1.8,0.1 c-0.7,0-1.4-0.1-2.2-0.4c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5c-0.4-0.4-0.7-0.8-0.7-1.2c0-0.4,0-0.7,0.3-1.1 c0.3-0.3,0.7-0.7,1.2-0.9s1.1-0.5,1.6-0.7c0.5-0.1,1.2-0.3,1.8-0.1c0.7,0,1.4,0.1,2.2,0.4c0.8,0.3,1.6,0.7,2.6,1.2 C244.3,678.9,245,679.5,245.4,679.9z M230.1,690.2l-1.1,0.7l-8.3-4.7c-0.1-0.1-0.3-0.1-0.4,0l-0.7,0.4l-0.1,0.1 c0,0.3-0.1,0.7-0.5,1.1c-0.3,0.4-0.8,0.7-1.4,1.1c-0.1,0.1-0.1,0.1,0,0.3l1.1,0.7c0.1,0.1,0.3,0.1,0.4,0l0.9-0.5l6,3.4 l-1.2,0.7c-0.1,0.1-0.1,0.1,0,0.3l0.9,0.5c0.1,0.1,0.3,0.1,0.4,0l5.3-3.1c0.1-0.1,0.1-0.1,0-0.3l-0.9-0.5 C230.5,690,230.2,690,230.1,690.2z M230.9,690.9l-4.9,2.8l-0.5-0.3l1.2-0.7c0.1-0.1,0.1-0.1,0-0.3l-6.4-3.7 c-0.1-0.1-0.3-0.1-0.4,0l-0.9,0.5l-0.7-0.4c0.5-0.3,0.9-0.7,1.2-0.9c0.4-0.4,0.5-0.8,0.5-1.1l0.4-0.3l8.3,4.7 c0.1,0.1,0.3,0.1,0.4,0l1.1-0.7L230.9,690.9z M230.6,681.1c-0.8,0-1.5,0-2.2,0.3c-1.2,0.4-2.4,1.1-3.1,1.8 c-0.3,0.4-0.4,0.8-0.4,1.2c0,0.4,0.3,0.9,0.8,1.4c0.4,0.5,1.2,0.9,2.2,1.6c0.9,0.5,1.9,0.9,2.7,1.2c0.8,0.3,1.6,0.4,2.4,0.4 c0.8,0,1.5,0,2.2-0.3c0.7-0.1,1.2-0.4,1.8-0.7c0.5-0.3,0.9-0.7,1.4-1.1c0.3-0.4,0.4-0.8,0.4-1.2c0-0.4-0.3-0.9-0.8-1.4 c-0.4-0.5-1.2-0.9-2.2-1.6c-0.9-0.5-1.9-0.9-2.7-1.2C232.1,681.4,231.3,681.1,230.6,681.1z M237.3,684.6 c0.4,0.4,0.7,0.8,0.7,1.2c0,0.4,0,0.7-0.3,1.1c-0.5,0.7-1.6,1.4-2.8,1.6c-0.5,0.1-1.2,0.3-1.8,0.1c-0.7,0-1.4-0.1-2.2-0.4 c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5c-0.4-0.4-0.7-0.8-0.7-1.2s0-0.7,0.3-1.1c0.3-0.3,0.7-0.7,1.2-0.9 c0.5-0.3,1.1-0.5,1.6-0.7c0.5-0.1,1.2-0.3,1.8-0.1c0.7,0,1.4,0.1,2.2,0.4c0.8,0.3,1.6,0.7,2.6,1.2 C236.2,683.7,236.9,684.1,237.3,684.6z M229.4,682.7c-0.4-0.1-0.7-0.1-0.9-0.1c-0.5,0-0.8,0.3-0.9,0.5c0,0.1,0,0.3,0.3,0.5 c0.1,0.3,0.5,0.5,0.9,0.8c0.4,0.3,1.1,0.7,2,1.2c0.8,0.5,1.5,0.8,2,1.1s1.1,0.4,1.4,0.5c0.4,0.1,0.7,0.1,0.9,0.1 s0.4-0.1,0.7-0.1c0.1-0.1,0.3-0.3,0.3-0.4c0-0.1,0-0.4-0.3-0.5c-0.1-0.3-0.5-0.4-0.9-0.8c-0.4-0.3-1.1-0.7-1.9-1.2 s-1.5-0.8-2.2-1.1C230.2,683,229.8,682.9,229.4,682.7z M234.4,685.8c0.4,0.3,0.8,0.5,0.9,0.7c0.3,0.3,0.3,0.3,0.1,0.4 c0,0.1-0.1,0.3-0.4,0.3c0,0-0.3,0-0.5-0.1c-0.3-0.1-0.8-0.3-1.2-0.5c-0.5-0.3-1.2-0.7-2-1.1c-0.8-0.5-1.5-0.9-1.9-1.2 s-0.7-0.5-0.9-0.7c-0.3-0.3-0.3-0.3-0.1-0.3c0,0,0-0.1,0.1-0.1s0.1-0.1,0.3-0.1c0,0,0.1,0,0.5,0.1c0.3,0.1,0.8,0.3,1.2,0.5 c0.5,0.3,1.2,0.7,2,1.1C233.3,685.2,233.9,685.6,234.4,685.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M209.4,685.7l-0.3,0.1l-1.6-2l0.3-0.1l3.7,0.9l-0.8,0.5L210,685l-0.8,0.5L209.4,685.7z M208.4,684.5 l0.5,0.7l0.7-0.4L208.4,684.5z M210.9,682.1l-0.8,0.4l0.7,0.4h0.1c0.3-0.1,0.5-0.3,0.8-0.3s0.5,0.1,0.8,0.3 c0.3,0.1,0.4,0.4,0.4,0.5s-0.1,0.4-0.5,0.5c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.4,0.1-0.7,0.1l-0.1-0.3c0.1,0,0.3,0,0.4,0 c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.3-0.1c-0.1,0-0.3-0.1-0.3-0.1 c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1l-0.1,0.1l-1.4-0.8l1.5-0.8L210.9,682.1z M214.5,682.6l-0.5-0.4 l-0.8,0.5l-0.4-0.1l-0.8-1.6l0.8-0.4l1.8,0.9l0.3-0.1l0.3,0.1l-0.3,0.1l0.5,0.4L214.5,682.6z M213.7,682.2l-1.2-0.7l0.5,1.1 L213.7,682.2z M215.2,679.5l-0.8,0.4l0.7,0.4h0.1c0.3-0.1,0.5-0.3,0.8-0.3s0.5,0.1,0.8,0.3s0.4,0.4,0.4,0.5 s-0.1,0.4-0.5,0.5c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.4,0.1-0.7,0.1l-0.1-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1 c0,0,0.1,0,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1s-0.1-0.1-0.3-0.1c-0.1,0-0.3-0.1-0.3-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0 s-0.1,0-0.3,0.1l-0.1,0.1l-0.1,0.1l-1.4-0.8l1.5-0.8L215.2,679.5z M216.3,678.5c0.1,0,0.3-0.1,0.3-0.1 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.1,0.1v0.1v0.1v0.1c0.3-0.1,0.4-0.1,0.7-0.1 c0.3,0,0.4,0.1,0.7,0.1c0.3,0.1,0.4,0.4,0.4,0.5c0,0.1-0.3,0.4-0.5,0.5c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0-0.3,0.1-0.4,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c-0.3-0.1-0.4-0.3-0.4-0.4c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.3,0.1-0.5,0.1 c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.1-0.3-0.3c0-0.1,0-0.1,0-0.3c0-0.1,0.1-0.1,0.1-0.3 C216.1,678.7,216.3,678.5,216.3,678.5z M217.6,679.3c0,0-0.1,0.1,0,0.1c0,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.4,0.3,0.5,0.3 c0.1,0,0.3,0,0.3,0s0,0,0-0.1c0,0,0-0.1-0.1-0.1l-0.1-0.1c0,0-0.1-0.1-0.3-0.1c-0.1-0.1-0.4-0.1-0.4-0.3 C217.8,679.2,217.8,679.2,217.6,679.3z M216.5,678.7C216.5,678.7,216.5,678.8,216.5,678.7c0,0.1,0.1,0.3,0.3,0.3 c0.3,0.1,0.4,0.1,0.5,0.1c0.1,0,0-0.1-0.1-0.3c-0.1-0.1-0.3-0.1-0.4-0.1C216.7,678.7,216.7,678.7,216.5,678.7z M219.8,678.1 c-0.3-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1 c0.1,0,0.4,0,0.5,0c0.1,0,0.4,0,0.7,0.1c0.3,0.1,0.4,0.1,0.7,0.3s0.4,0.3,0.5,0.4c0.1,0.1,0.1,0.3,0.3,0.4 c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1 C220.3,678.4,220.1,678.3,219.8,678.1z M220.6,677.6c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0 h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3C220.2,677.5,220.3,677.5,220.6,677.6z M222.1,676.8 c-0.3-0.1-0.4-0.3-0.5-0.4s-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1 c0.1,0,0.4,0,0.5,0s0.4,0,0.7,0.1c0.3,0.1,0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4s0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3 c-0.1,0.1-0.1,0.1-0.3,0.3s-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1C222.5,677,222.2,676.9,222.1,676.8z  M222.8,676.4c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1 c0,0-0.1-0.1-0.3-0.3s-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0H222 c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3C222.4,676.1,222.5,676.2,222.8,676.4z M224.3,675.6c-0.3-0.1-0.4-0.3-0.5-0.4 s-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0s0.4,0,0.7,0.1 c0.3,0.1,0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4s0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1C224.7,675.7,224.5,675.7,224.3,675.6z M224.9,675.1 c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 s-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1 c0,0,0.1,0.1,0.3,0.3C224.5,674.9,224.8,675,224.9,675.1z M227.2,672.6l-0.8,0.5l0.7,0.4h0.1c0.3-0.1,0.5-0.3,0.8-0.3 s0.5,0.1,0.8,0.3c0.3,0.1,0.4,0.4,0.4,0.5c0,0.1-0.1,0.4-0.5,0.5c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.4,0.1-0.7,0.1l-0.1-0.3 c0.1,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1s-0.1-0.1-0.3-0.1 c-0.1,0-0.3-0.1-0.3-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1l-0.1,0.1l-1.4-0.8l1.5-0.8L227.2,672.6z  M229.5,672.4c-0.3-0.1-0.4-0.3-0.5-0.4s-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0c0.1,0,0.4,0,0.7,0.1c0.3,0.1,0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4 s0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3s-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1 C230.1,672.7,229.8,672.6,229.5,672.4z M230.4,672c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0h0.1 c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3s-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3C229.9,671.8,230.1,671.9,230.4,672z M231.8,671.2 c-0.3-0.1-0.4-0.3-0.5-0.4s-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1 c0.1,0,0.4,0,0.5,0c0.1,0,0.4,0,0.7,0.1s0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4s0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3 c-0.1,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1 C232.3,671.5,232.1,671.4,231.8,671.2z M232.5,670.7c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0 h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3C232.1,670.5,232.4,670.5,232.5,670.7z M234.4,668.1 l0.3,0.1v0.4c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.3,0.1c0.1,0,0.3,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.3 c0.1,0.1,0.1,0.3,0.1,0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.3-0.4,0.3c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0.1 c-0.1,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0l-0.1-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4-0.1c0.1,0,0.1-0.1,0.1-0.1v-0.1 c0,0,0-0.1-0.1-0.1l-0.1-0.1c-0.1,0-0.1-0.1-0.3-0.1s-0.1,0-0.3,0s-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0.1h-0.3v-0.9l-1.1,0.7 l-0.3-0.1L234.4,668.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084526960793023856060000009143830847210611134_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.8015,
    y1: 199.3971,
    x2: 212.8015,
    y2: 153.8343,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 236.8348 941.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C6C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#A3A5A8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084526960793023856060000009143830847210611134_)"
    },
    d: "M275,659.7 c9.5,5.4,11.9,13,5.3,16.7c-6.5,3.8-19.5,2.4-29-3.1c-9.5-5.4-11.9-13-5.3-16.7C252.7,652.8,265.6,654.2,275,659.7z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M280.6,676.5c-6.6,3.8-19.8,2.4-29.4-3.1c-9.6-5.6-11.9-13.1-5.3-16.9s19.8-2.4,29.4,3.1 C284.9,665,287.2,672.7,280.6,676.5z M246.3,656.7c-6.4,3.7-3.9,11.1,5.3,16.5c9.3,5.4,22.1,6.8,28.4,3.1 s3.9-11.1-5.3-16.5C265.6,654.4,252.7,653.1,246.3,656.7z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M251.2,661.2l-1.5-0.8l0.7-0.4l1.4,0.8c0.4-0.3,0.7-0.4,0.9-0.7c0.3-0.1,0.7-0.3,1.1-0.5l-1.4-0.8 l0.7-0.4l1.5,0.8c1.6-0.7,3.3-1.1,4.7-1.1s2.6,0.3,3.4,0.8c0.5,0.3,0.8,0.7,0.8,0.9c0,0.4-0.1,0.7-0.5,0.8 c-0.4,0.3-0.8,0.3-1.5,0.3c-0.5,0-1.1-0.1-1.5-0.4c-0.7-0.4-0.8-0.8-0.5-1.4c0.1-0.3,0.1-0.4,0.1-0.4c-0.1-0.1-0.7-0.1-1.5,0 c-0.8,0.1-1.8,0.4-2.8,0.8l7.6,4.3c4.3-0.9,7.7-0.8,10.3,0.7c1.2,0.7,1.9,1.5,2.2,2.6s-0.1,2.2-1.2,3.3l3.3,1.9l-0.7,0.4 l-3.1-1.8c-0.7,0.5-1.4,0.9-1.9,1.2l3,1.8l-0.7,0.4l-3-1.8c-2,0.8-3.8,1.2-5.4,1.1c-1.6-0.1-3-0.4-3.9-0.9 c-0.5-0.3-0.8-0.7-0.8-1.1c-0.1-0.4,0.1-0.8,0.5-1.1c0.4-0.3,0.9-0.4,1.5-0.4c0.7,0,1.2,0.1,1.6,0.4c0.4,0.3,0.7,0.5,0.7,0.9 c0,0.3-0.1,0.5-0.5,0.8c0,0-0.1,0-0.3,0.1c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0.1-0.1,0.1,0,0.3c0.3,0.1,1.1,0.3,2.3,0.3 c1.2,0,2.4-0.3,3.8-0.9l-8.9-5.1c-3.9,1.1-7,0.8-9.3-0.4C249.3,665,249.2,663.2,251.2,661.2z M258,665.1l-6-3.4 c-1.2,1.4-1.1,2.4,0.4,3.3C253.6,665.7,255.5,665.7,258,665.1z M252.6,661.2l6.4,3.7c0.5-0.1,1.5-0.4,2.8-0.8l-7.2-4.2 l-1.1,0.5c-0.1,0.1-0.4,0.3-0.5,0.4C252.8,661.1,252.7,661.2,252.6,661.2z M272.9,670.4l-7.6-4.3l-3,0.7l8.7,5 c0.3-0.1,0.4-0.1,0.5-0.3C271.8,671.2,272.2,671,272.9,670.4z M266.2,665.8l7.2,4.1c1.4-1.5,1.1-2.7-0.5-3.8 C271.1,665.3,269,665.1,266.2,665.8z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "255.7,647.1 235.6,658.6 277.2,682.7 297.3,671.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "297.3,692.5 277.2,704.1 277.2,682.7 297.3,671.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "295.1,672.4 253.5,648.3 256,647 297.7,671 297.7,692.3 295.1,693.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "276.8,682.9 235.2,658.9 237.8,657.4 279.4,681.5 279.4,702.9 276.8,704.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "295.1,672.4 297.7,671 297.7,692.3 295.1,693.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "276.8,682.9 279.4,681.5 279.4,702.9 276.8,704.3  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165940769530413151440000000729693786818935727_",
    gradientUnits: "userSpaceOnUse",
    x1: 741.8624,
    y1: 300.146,
    x2: 770.2742,
    y2: 300.146,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165940769530413151440000000729693786818935727_)"
    },
    d: "M761.9,422.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C770.2,427.3,767.5,424.5,761.9,422.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088124875953172738430000004162176392243802244_",
    gradientUnits: "userSpaceOnUse",
    x1: 742.2023,
    y1: 295.1352,
    x2: 769.9638,
    y2: 295.1352,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000088124875953172738430000004162176392243802244_)",
      enableBackground: "new"
    },
    d: " M743.2,433.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C742.4,432.7,742.8,433.3,743.2,433.8z M750.4,438v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C751.1,438.2,750.8,438,750.4,438z M754.6,438.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C755.3,438.6,754.9,438.6,754.6,438.6z  M752.6,438.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C753.2,438.4,752.8,438.4,752.6,438.3z M744.3,435v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C745,435.4,744.6,435.3,744.3,435z M748.4,437.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C749,437.5,748.8,437.5,748.4,437.3z  M746.3,436.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C747,436.7,746.6,436.5,746.3,436.4z M756.6,438.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C757.3,438.6,757,438.6,756.6,438.6z M766.9,435.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C767.6,435.2,767.2,435.3,766.9,435.6z  M758.7,438.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C759.3,438.3,759.1,438.4,758.7,438.4z M768.9,433.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C769.8,432.6,769.4,433.1,768.9,433.7z M764.9,436.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C765.6,436.5,765.2,436.7,764.9,436.8z  M762.9,437.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C763.5,437.3,763.1,437.5,762.9,437.6z M760.7,438.2v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C761.4,438,761.1,438,760.7,438.2z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M766.1,424.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C751.5,421.5,760.6,421.4,766.1,424.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128445334902704655960000017046320997395101100_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.1252,
    y1: 301.5261,
    x2: 768.9761,
    y2: 301.5261,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128445334902704655960000017046320997395101100_)"
    },
    d: "M765.2,425.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C751.9,422.3,760.1,422.2,765.2,425.2z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M747.1,425.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C742.7,431,743.6,428,747.1,425.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173140577038613246160000017114299186664688804_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.2293,
    y1: 520.4857,
    x2: 664.6411,
    y2: 520.4857,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173140577038613246160000017114299186664688804_)"
    },
    d: "M656.3,202.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C664.5,207,661.8,204.1,656.3,202.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143611004487811165130000011478988347041539510_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.5846,
    y1: 515.4749,
    x2: 664.3461,
    y2: 515.4749,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000143611004487811165130000011478988347041539510_)",
      enableBackground: "new"
    },
    d: " M637.6,213.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C636.8,212.4,637.2,212.9,637.6,213.5z M644.9,217.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C645.4,217.7,645.2,217.7,644.9,217.5z M649,218.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C649.6,218.2,649.2,218.2,649,218.2z  M646.9,217.9v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C647.6,218.1,647.2,218.1,646.9,217.9z M638.7,214.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C639.3,215.1,638.9,215,638.7,214.7z M642.7,217v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C643.4,217.1,643.1,217.1,642.7,217z  M640.7,216.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C641.4,216.3,641,216.2,640.7,216.1z M651,218.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C651.7,218.2,651.4,218.2,651,218.2z M661.3,215.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C662,214.8,661.7,215,661.3,215.2z  M653,218.1v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C653.7,217.9,653.4,218.1,653,218.1z M663.3,213.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C664.1,212.3,663.7,212.8,663.3,213.3z M659.3,216.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C659.9,216.1,659.5,216.2,659.3,216.5z  M657.2,217.3v3.1c0.3-0.1,0.7-0.3,0.9-0.3V217C657.9,217,657.5,217.1,657.2,217.3z M655.2,217.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C655.9,217.7,655.5,217.7,655.2,217.8z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M660.5,204.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C645.8,201.2,654.9,201,660.5,204.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097477507669254584040000005098685826171621028_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.5074,
    y1: 521.8907,
    x2: 663.3583,
    y2: 521.8907,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097477507669254584040000005098685826171621028_)"
    },
    d: "M659.5,204.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C646.3,201.8,654.5,201.8,659.5,204.8z"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M641.5,205.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C637,210.6,638,207.5,641.5,205.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071550402010174523170000001543079893145294726_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.3851,
    y1: 514.3915,
    x2: 385.7971,
    y2: 514.3915,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071550402010174523170000001543079893145294726_)"
    },
    d: "M377.4,208.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C385.7,212.9,383,210.1,377.4,208.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094575783196409314520000006401530421021814962_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.7388,
    y1: 509.3807,
    x2: 385.5003,
    y2: 509.3807,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000094575783196409314520000006401530421021814962_)",
      enableBackground: "new"
    },
    d: " M358.7,219.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C357.9,218.5,358.3,219,358.7,219.6z M366.1,223.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C366.6,223.8,366.3,223.6,366.1,223.6z M370.1,224.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C370.8,224.3,370.4,224.2,370.1,224.2z  M368.1,224v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C368.8,224.2,368.4,224,368.1,224z M359.8,220.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C360.5,221.2,360.1,220.9,359.8,220.7z M363.9,223v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C364.6,223.2,364.3,223.1,363.9,223z  M361.9,222v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C362.5,222.4,362.1,222.3,361.9,222z M372.1,224.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C372.8,224.2,372.6,224.2,372.1,224.3z M382.4,221.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C383.1,220.8,382.8,221.1,382.4,221.3z  M374.2,224.2v3.1c0.3,0,0.7-0.1,0.9-0.1V224C374.9,224,374.6,224,374.2,224.2z M384.5,219.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C385.3,218.2,384.9,218.9,384.5,219.4z M380.4,222.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C381.1,222.1,380.7,222.3,380.4,222.4z  M378.4,223.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V223C379.1,223.1,378.6,223.1,378.4,223.2z M376.3,223.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C376.9,223.6,376.6,223.8,376.3,223.8z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M381.6,210.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C367,207.1,376.1,207.1,381.6,210.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070105103886947038120000014264165181092128401_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.6618,
    y1: 515.8812,
    x2: 384.5127,
    y2: 515.8812,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070105103886947038120000014264165181092128401_)"
    },
    d: "M380.7,210.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C367.4,207.9,375.7,207.9,380.7,210.8z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M362.7,211.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C358.2,216.6,359.1,213.6,362.7,211.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051356738181962957680000009131553963601660052_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3937,
    y1: 539.1746,
    x2: 88.8056,
    y2: 539.1746,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051356738181962957680000009131553963601660052_)"
    },
    d: "M80.4,183.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C88.7,188.3,85.9,185.3,80.4,183.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129171644449217728410000009649757342806504084_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.7197,
    y1: 534.1638,
    x2: 88.4816,
    y2: 534.1638,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000129171644449217728410000009649757342806504084_)",
      enableBackground: "new"
    },
    d: " M61.7,194.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C60.9,193.7,61.3,194.2,61.7,194.8z M68.9,198.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C69.6,199,69.3,199,68.9,198.9z M73.1,199.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C73.8,199.5,73.4,199.4,73.1,199.4z M71.1,199.3v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C71.6,199.4,71.4,199.3,71.1,199.3z M62.8,195.9v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C63.5,196.4,63.1,196.1,62.8,195.9z M66.9,198.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C67.6,198.4,67.3,198.3,66.9,198.2z  M64.9,197.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C65.5,197.6,65.1,197.5,64.9,197.2z M75.2,199.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C75.8,199.4,75.4,199.5,75.2,199.5z M85.4,196.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C86.1,196,85.7,196.3,85.4,196.5z M77.2,199.4 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C77.9,199.3,77.6,199.3,77.2,199.4z M87.5,194.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C88.3,193.4,87.9,194.1,87.5,194.7z M83.4,197.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C84.1,197.4,83.7,197.5,83.4,197.6z  M81.4,198.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C82.1,198.3,81.7,198.3,81.4,198.4z M79.2,199v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C79.9,198.9,79.6,199,79.2,199z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84.6,185.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C70,182.3,79.1,182.3,84.6,185.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105385906566562959110000002891070302571097487_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.6429,
    y1: 540.6643,
    x2: 87.4939,
    y2: 540.6643,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105385906566562959110000002891070302571097487_)"
    },
    d: "M83.7,186c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C70.4,183.1,78.7,183.1,83.7,186z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M65.7,186.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C61.2,191.8,62.2,188.8,65.7,186.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026868967143387556190000008262445615581106577_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.1931,
    y1: 485.9518,
    x2: 735.6048,
    y2: 485.9518,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026868967143387556190000008262445615581106577_)"
    },
    d: "M727.2,237c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C735.5,241.4,732.8,238.5,727.2,237z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065753325736440345110000003559517978182381759_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.5329,
    y1: 481.0088,
    x2: 735.2944,
    y2: 481.0088,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000065753325736440345110000003559517978182381759_)",
      enableBackground: "new"
    },
    d: " M708.5,248v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C707.7,246.8,708.1,247.5,708.5,248z M715.7,252.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C716.4,252.2,716.1,252.1,715.7,252.1z M719.9,252.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C720.6,252.6,720.2,252.6,719.9,252.6z  M717.9,252.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C718.6,252.5,718.2,252.5,717.9,252.3z M709.6,249.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C710.3,249.5,709.9,249.4,709.6,249.1z M713.7,251.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C714.4,251.7,714.1,251.5,713.7,251.4z M711.7,250.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5V251C712.3,250.9,711.9,250.6,711.7,250.4z  M722,252.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C722.6,252.6,722.4,252.6,722,252.6z M732.2,249.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C732.9,249.2,732.5,249.5,732.2,249.6z M724,252.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C724.7,252.5,724.4,252.5,724,252.5z  M734.3,247.9v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C735.1,246.7,734.7,247.2,734.3,247.9z M730.2,250.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5 v-3.1C730.9,250.6,730.5,250.7,730.2,250.9z M728.2,251.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1 C728.9,251.4,728.5,251.5,728.2,251.7z M726,252.2v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C726.7,252.1,726.4,252.1,726,252.2z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M731.4,238.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C716.8,235.6,725.9,235.6,731.4,238.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179613447579139640130000007031481855428138932_",
    gradientUnits: "userSpaceOnUse",
    x1: 708.4557,
    y1: 487.4673,
    x2: 734.3068,
    y2: 487.4673,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179613447579139640130000007031481855428138932_)"
    },
    d: "M730.5,239.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C717.2,236.4,725.5,236.2,730.5,239.2z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M712.5,239.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C708,245,709,242.1,712.5,239.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133486918119436410090000010347985596455123110_",
    gradientUnits: "userSpaceOnUse",
    x1: 978.1825,
    y1: 223.3588,
    x2: 1006.5944,
    y2: 223.3588,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133486918119436410090000010347985596455123110_)"
    },
    d: "M998.2,499.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C1006.5,504.1,1003.8,501.3,998.2,499.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106841898069183893060000004608502593312409475_",
    gradientUnits: "userSpaceOnUse",
    x1: 978.5599,
    y1: 218.3481,
    x2: 1006.3214,
    y2: 218.3481,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000106841898069183893060000004608502593312409475_)",
      enableBackground: "new"
    },
    d: " M979.5,510.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C978.7,509.5,979.1,510.1,979.5,510.6z M986.8,514.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C987.5,514.8,987.1,514.8,986.8,514.7z M990.9,515.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C991.6,515.3,991.3,515.3,990.9,515.3z  M988.9,515.1v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C989.6,515.2,989.2,515.2,988.9,515.1z M980.6,511.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C981.3,512.2,980.9,512.1,980.6,511.8z M984.8,514.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C985.4,514.3,985.1,514.3,984.8,514.1z M982.7,513.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C983.3,513.4,983.1,513.3,982.7,513.2z  M992.9,515.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C993.6,515.3,993.4,515.3,992.9,515.3z M1003.2,512.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8 v-3.1C1003.9,512,1003.6,512.1,1003.2,512.4z M995.1,515.2v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C995.7,515.1,995.4,515.2,995.1,515.2 z M1005.3,510.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C1006.1,509.4,1005.8,509.9,1005.3,510.5z M1001.2,513.6v3.1 c0.4-0.1,0.7-0.3,0.9-0.5V513C1001.9,513.3,1001.6,513.4,1001.2,513.6z M999.2,514.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1 C999.9,514.1,999.4,514.3,999.2,514.4z M997.1,514.9v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C997.8,514.8,997.4,514.8,997.1,514.9z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1002.4,501.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C987.9,498.3,996.9,498.1,1002.4,501.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098219294923747740390000005535360340804748961_",
    gradientUnits: "userSpaceOnUse",
    x1: 979.4828,
    y1: 224.7639,
    x2: 1005.3337,
    y2: 224.7639,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098219294923747740390000005535360340804748961_)"
    },
    d: "M1001.5,501.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C988.3,499,996.5,499,1001.5,501.9z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M983.5,502.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C979,507.8,979.9,504.8,983.5,502.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048467752458647694240000006688996262764788611_",
    gradientUnits: "userSpaceOnUse",
    x1: 977.9116,
    y1: 227.1508,
    x2: 1006.3234,
    y2: 227.1508,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048467752458647694240000006688996262764788611_)"
    },
    d: "M998,495.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C1006.2,500.3,1003.4,497.5,998,495.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046326951198096241040000008093884047199588236_",
    gradientUnits: "userSpaceOnUse",
    x1: 978.2445,
    y1: 222.14,
    x2: 1006.006,
    y2: 222.14,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000046326951198096241040000008093884047199588236_)",
      enableBackground: "new"
    },
    d: " M979.3,506.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C978.5,505.7,978.9,506.3,979.3,506.8z M986.4,510.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C987.1,511,986.8,511,986.4,510.9z M990.6,511.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C991.3,511.6,990.9,511.6,990.6,511.6z  M988.6,511.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C989.2,511.4,988.9,511.3,988.6,511.3z M980.3,508v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C981,508.4,980.6,508.2,980.3,508z M984.4,510.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C985.1,510.5,984.8,510.5,984.4,510.3z  M982.4,509.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C983.1,509.7,982.7,509.5,982.4,509.4z M992.7,511.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C993.4,511.6,992.9,511.6,992.7,511.6z M1003,508.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C1003.6,508.2,1003.2,508.3,1003,508.6z  M994.7,511.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C995.4,511.3,995.1,511.4,994.7,511.4z M1005,506.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C1005.8,505.6,1005.4,506.1,1005,506.7z M1000.9,509.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1 C1001.6,509.4,1001.2,509.5,1000.9,509.8z M998.9,510.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C999.6,510.3,999.2,510.5,998.9,510.5z  M996.7,511v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C997.4,510.9,997.1,511,996.7,511z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1002.2,497.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C987.5,494.4,996.6,494.4,1002.2,497.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062881066465834706030000003318283646921960594_",
    gradientUnits: "userSpaceOnUse",
    x1: 979.1677,
    y1: 228.6405,
    x2: 1005.0184,
    y2: 228.6405,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062881066465834706030000003318283646921960594_)"
    },
    d: "M1001.2,498c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C987.9,495.2,996.2,495.2,1001.2,498z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M983.2,498.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C978.7,504,979.7,500.9,983.2,498.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026164614148948739730000011068701756625472664_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.7232,
    y1: 208.5973,
    x2: 698.135,
    y2: 208.5973,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026164614148948739730000011068701756625472664_)"
    },
    d: "M689.9,514.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C698,518.9,695.3,516,689.9,514.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138551344449252518290000003133160187553021838_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.086,
    y1: 203.5865,
    x2: 697.8477,
    y2: 203.5865,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000138551344449252518290000003133160187553021838_)",
      enableBackground: "new"
    },
    d: " M671,525.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C670.4,524.3,670.6,524.8,671,525.4z M678.3,529.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C679,529.6,678.6,529.6,678.3,529.4z M682.4,530.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C683.1,530.1,682.8,530.1,682.4,530.1z  M680.4,529.8v3.1c0.3,0,0.7,0.1,0.9,0.1V530C681.1,530,680.8,530,680.4,529.8z M672.1,526.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C672.8,527,672.4,526.9,672.1,526.6z M676.3,528.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C677,529,676.6,529,676.3,528.9z  M674.1,527.9v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C674.8,528.2,674.6,528.1,674.1,527.9z M684.4,530.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C685.1,530.1,684.8,530.1,684.4,530.1z M694.7,527.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C695.5,526.7,695.1,526.9,694.7,527.1z  M686.6,530v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C687.3,529.8,686.9,530,686.6,530z M696.8,525.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C697.6,524.1,697.3,524.7,696.8,525.2z M692.7,528.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C693.4,528.1,693.1,528.2,692.7,528.3z  M690.7,529.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C691.3,528.9,690.9,529,690.7,529.2z M688.6,529.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C689.3,529.6,688.9,529.6,688.6,529.7z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M693.9,516.2c5.6,3.1,5.6,8.4,0,11.6s-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C679.4,513,688.4,512.9,693.9,516.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136370655820751635150000005888103483169579163_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.9973,
    y1: 210.0024,
    x2: 696.848,
    y2: 210.0024,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136370655820751635150000005888103483169579163_)"
    },
    d: "M693,516.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C679.8,513.7,688,513.7,693,516.7z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M675,517.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C670.5,522.5,671.4,519.5,675,517.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018208094795891392680000007740944557873170608_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.4089,
    y1: 212.3892,
    x2: 697.8209,
    y2: 212.3892,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018208094795891392680000007740944557873170608_)"
    },
    d: "M689.5,510.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C697.7,515.1,695,512.2,689.5,510.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088828353247236307730000002812612118330973623_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.7589,
    y1: 207.3785,
    x2: 697.5204,
    y2: 207.3785,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000088828353247236307730000002812612118330973623_)",
      enableBackground: "new"
    },
    d: " M670.8,521.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C670,520.5,670.4,521,670.8,521.6z M678.1,525.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C678.6,525.8,678.3,525.8,678.1,525.6z M682.1,526.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C682.8,526.3,682.4,526.3,682.1,526.3z  M680.1,526v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C680.8,526.2,680.4,526,680.1,526z M671.8,522.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C672.5,523.2,672.1,522.9,671.8,522.8z M675.9,525.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C676.6,525.2,676.3,525.2,675.9,525.1z  M673.9,524.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C674.6,524.4,674.1,524.3,673.9,524.1z M684.2,526.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C684.8,526.3,684.6,526.3,684.2,526.3z M694.5,523.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C695.1,522.9,694.9,523.1,694.5,523.3z  M686.2,526.2v3.1c0.3,0,0.7-0.1,0.9-0.1V526C686.9,526,686.6,526.2,686.2,526.2z M696.5,521.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C697.3,520.4,696.9,520.9,696.5,521.4z M692.4,524.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5V524C693.1,524.1,692.7,524.3,692.4,524.6z  M690.4,525.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V525C691.1,525.1,690.7,525.2,690.4,525.2z M688.4,525.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C688.9,525.6,688.6,525.8,688.4,525.8z"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M693.7,512.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C679,509.1,688.1,509.1,693.7,512.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165232863944759148290000016397112906734259599_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.6819,
    y1: 213.879,
    x2: 696.5328,
    y2: 213.879,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165232863944759148290000016397112906734259599_)"
    },
    d: "M692.7,512.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C679.4,509.9,687.7,509.9,692.7,512.8z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M674.7,513.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C670.2,518.7,671.2,515.6,674.7,513.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006679386747172160060000008072559676234235783_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.4739,
    y1: 168.6463,
    x2: 538.8859,
    y2: 168.6463,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006679386747172160060000008072559676234235783_)"
    },
    d: "M530.6,554.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C538.7,558.7,536,555.8,530.6,554.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010297727876408879350000012515807152250773922_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.8239,
    y1: 163.771,
    x2: 538.5864,
    y2: 163.771,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000010297727876408879350000012515807152250773922_)",
      enableBackground: "new"
    },
    d: " M511.8,565.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C511.1,564.1,511.4,564.8,511.8,565.3z M519.1,569.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C519.8,569.5,519.4,569.4,519.1,569.4z M523.1,569.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C523.8,569.9,523.6,569.9,523.1,569.9z  M521.1,569.7v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C521.8,569.8,521.5,569.8,521.1,569.7z M512.9,566.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C513.5,566.8,513.1,566.7,512.9,566.4z M517.1,568.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V569C517.7,569,517.3,568.8,517.1,568.7z  M515,567.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C515.6,568,515.3,567.9,515,567.8z M525.3,569.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C525.9,569.9,525.6,569.9,525.3,569.9z M535.5,566.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C536.3,566.5,535.9,566.8,535.5,566.9z  M527.3,569.8v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C528,569.8,527.6,569.8,527.3,569.8z M537.6,565v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C538.3,564,538,564.5,537.6,565z M533.4,568.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C534.1,567.9,533.8,568,533.4,568.2z M531.4,569 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C532.1,568.7,531.8,568.8,531.4,569z M529.4,569.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C530.1,569.4,529.6,569.4,529.4,569.5z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M534.7,556c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C520.2,552.9,529.1,552.7,534.7,556z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024717701075430950700000008097628179061194920_",
    gradientUnits: "userSpaceOnUse",
    x1: 511.7548,
    y1: 170.1619,
    x2: 537.6058,
    y2: 170.1619,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024717701075430950700000008097628179061194920_)"
    },
    d: "M533.8,556.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C520.6,553.7,528.7,553.5,533.8,556.5z"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M515.7,557.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C511.2,562.3,512.2,559.4,515.7,557.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021108826836081738610000013813809133689205693_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.5931,
    y1: 486.0872,
    x2: 244.005,
    y2: 486.0872,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021108826836081738610000013813809133689205693_)"
    },
    d: "M235.6,236.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C243.9,241.4,241.2,238.5,235.6,236.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067233439646111002860000014947394794150279099_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.9475,
    y1: 481.0765,
    x2: 243.7091,
    y2: 481.0765,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000067233439646111002860000014947394794150279099_)",
      enableBackground: "new"
    },
    d: " M216.9,247.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C216.1,246.8,216.5,247.3,216.9,247.9z M224.3,251.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C224.8,252.1,224.5,252.1,224.3,251.9z M228.3,252.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C229,252.6,228.6,252.6,228.3,252.6z  M226.3,252.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C227,252.5,226.6,252.5,226.3,252.3z M218,249.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C218.7,249.5,218.3,249.4,218,249.1z M222.1,251.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C222.8,251.5,222.5,251.5,222.1,251.4z  M220.1,250.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5V251C220.7,250.7,220.3,250.6,220.1,250.4z M230.4,252.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C231,252.6,230.8,252.6,230.4,252.6z M240.6,249.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C241.3,249.2,241.1,249.4,240.6,249.6z  M232.4,252.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C233.1,252.3,232.8,252.5,232.4,252.5z M242.7,247.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C243.5,246.7,243.1,247.2,242.7,247.7z M238.6,250.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C239.3,250.4,238.9,250.6,238.6,250.9z  M236.6,251.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C237.3,251.4,236.9,251.5,236.6,251.7z M234.6,252.2v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C235.1,252.1,234.8,252.1,234.6,252.2z"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M239.8,238.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C225.2,235.4,234.3,235.4,239.8,238.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176041105620913614790000004516407651742805895_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.8707,
    y1: 487.577,
    x2: 242.7216,
    y2: 487.577,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176041105620913614790000004516407651742805895_)"
    },
    d: "M238.9,239.1c5,2.8,5.1,7.6,0,10.6 s-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C225.6,236.2,233.9,236.2,238.9,239.1z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M220.9,239.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C216.4,245,217.4,241.9,220.9,239.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119113292099449867360000013729491780607288202_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.9089,
    y1: 172.7092,
    x2: 292.3207,
    y2: 172.7092,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119113292099449867360000013729491780607288202_)"
    },
    d: "M284,550.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C292.2,554.6,289.4,551.8,284,550.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158730160629888591110000005125845657230923393_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.26,
    y1: 167.7661,
    x2: 292.0216,
    y2: 167.7661,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000158730160629888591110000005125845657230923393_)",
      enableBackground: "new"
    },
    d: " M265.3,561.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C264.5,560,264.9,560.7,265.3,561.3z M272.5,565.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C273.1,565.5,272.9,565.3,272.5,565.3z M276.7,565.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C277.3,565.9,276.9,565.9,276.7,565.9z  M274.6,565.7v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C275.2,565.7,274.9,565.7,274.6,565.7z M266.4,562.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C267.1,562.9,266.6,562.6,266.4,562.3z M270.4,564.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C271.1,564.9,270.7,564.8,270.4,564.6z M268.4,563.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C269.1,564.1,268.7,564,268.4,563.7z  M278.7,565.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C279.4,565.9,279,565.9,278.7,565.9z M289,562.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C289.7,562.5,289.3,562.7,289,562.9z M280.7,565.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C281.4,565.7,281.1,565.7,280.7,565.7z  M291,561.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C291.8,559.9,291.4,560.4,291,561.1z M287,564.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1 C287.6,563.8,287.2,564,287,564.1z M284.8,564.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C285.5,564.8,285.2,564.8,284.8,564.9z  M282.8,565.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C283.4,565.3,283.2,565.3,282.8,565.5z"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M288.2,551.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C273.6,548.8,282.6,548.8,288.2,551.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015335265396927114560000007182620601329612185_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.183,
    y1: 174.1989,
    x2: 291.0338,
    y2: 174.1989,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015335265396927114560000007182620601329612185_)"
    },
    d: "M287.2,552.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C274,549.6,282.2,549.6,287.2,552.5z"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M269.2,553.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C264.8,558.3,265.7,555.3,269.2,553.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081616981266548729740000001994229260221053877_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.9014,
    y1: 210.6287,
    x2: 172.3135,
    y2: 210.6287,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081616981266548729740000001994229260221053877_)"
    },
    d: "M164,512.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C172.3,516.7,169.4,513.9,164,512.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079478128088000155990000015425434705032585642_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2524,
    y1: 205.6857,
    x2: 172.014,
    y2: 205.6857,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000079478128088000155990000015425434705032585642_)",
      enableBackground: "new"
    },
    d: " M145.3,523.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C144.5,522.3,144.8,522.8,145.3,523.3z M152.5,527.4v3.1 c0.3,0.1,0.7,0.1,0.9,0.3v-3.1C153.2,527.5,152.9,527.4,152.5,527.4z M156.7,527.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C157.2,527.9,157,527.9,156.7,527.9z M154.5,527.8v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C155.2,527.9,154.9,527.8,154.5,527.8z  M146.4,524.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1C146.9,525,146.7,524.7,146.4,524.4z M150.5,526.7v3.1 c0.3,0.1,0.7,0.3,0.9,0.3V527C151.1,527,150.7,526.9,150.5,526.7z M148.4,525.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1 C149.1,526.2,148.7,526,148.4,525.8z M158.7,527.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C159.4,527.9,159,527.9,158.7,527.9z M169,525 v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C169.7,524.6,169.3,524.8,169,525z M160.7,527.9v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1 C161.4,527.8,161,527.8,160.7,527.9z M171,523.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C171.9,522,171.4,522.7,171,523.2z M167,526.2 v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C167.7,525.9,167.2,526,167,526.2z M164.8,527v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1 C165.5,526.9,165.2,526.9,164.8,527z M162.8,527.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C163.5,527.4,163.2,527.5,162.8,527.5z"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.1,514c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C153.6,510.9,162.5,510.9,168.1,514z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127735517598657944350000007996837620882420149_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1539,
    y1: 212.1184,
    x2: 171.0048,
    y2: 212.1184,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127735517598657944350000007996837620882420149_)"
    },
    d: "M167.2,514.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C154,511.7,162.1,511.7,167.2,514.5z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M149.2,515.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C144.6,520.4,145.6,517.4,149.2,515.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001627266374375218790000002255906243693227407_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.8498,
    y1: 215.3687,
    x2: 172.2617,
    y2: 215.3687,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001627266374375218790000002255906243693227407_)"
    },
    d: "M163.9,507.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C172.1,512.1,169.4,509.1,163.9,507.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127020810267202915540000018276695424662991248_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2231,
    y1: 210.3579,
    x2: 171.9849,
    y2: 210.3579,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000127020810267202915540000018276695424662991248_)",
      enableBackground: "new"
    },
    d: " M145.2,518.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C144.4,517.5,144.8,518.1,145.2,518.6z M152.5,522.7v3.1 c0.3,0.1,0.7,0.1,0.9,0.3v-3.1C153.2,522.8,152.8,522.8,152.5,522.7z M156.5,523.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C157.2,523.3,157,523.2,156.5,523.2z M154.5,523.1v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C155.2,523.2,154.8,523.1,154.5,523.1z  M146.3,519.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1C146.9,520.2,146.5,519.9,146.3,519.7z M150.5,522v3.1 c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C151.1,522.3,150.7,522.1,150.5,522z M148.3,521v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1 C149,521.4,148.7,521.3,148.3,521z M158.6,523.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C159.3,523.2,159,523.3,158.6,523.3z M168.9,520.4 v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C169.7,519.8,169.3,520.1,168.9,520.4z M160.7,523.2v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1 C161.3,523.1,161,523.1,160.7,523.2z M170.9,518.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C171.7,517.2,171.4,517.9,170.9,518.5z  M166.8,521.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C167.5,521.2,167.2,521.3,166.8,521.4z M164.8,522.3v3.1 c0.3-0.1,0.7-0.3,0.9-0.3V522C165.5,522.1,165.1,522.1,164.8,522.3z M162.8,522.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C163.5,522.7,163,522.8,162.8,522.8z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.1,509.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C153.6,506.1,162.5,506.1,168.1,509.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111890405552524489040000007663138325748418484_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1238,
    y1: 216.8584,
    x2: 170.9747,
    y2: 216.8584,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111890405552524489040000007663138325748418484_)"
    },
    d: "M167.1,509.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C154,506.9,162.1,506.9,167.1,509.8z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M149.1,510.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C144.6,515.6,145.6,512.6,149.1,510.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176009897722439067600000006489921442940283790_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.8757,
    y1: 219.1606,
    x2: 172.2874,
    y2: 219.1606,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176009897722439067600000006489921442940283790_)"
    },
    d: "M164,503.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C172.1,508.3,169.4,505.5,164,503.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183229798820600004680000007943043413334452918_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2231,
    y1: 214.1499,
    x2: 171.9856,
    y2: 214.1499,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000183229798820600004680000007943043413334452918_)",
      enableBackground: "new"
    },
    d: " M145.2,514.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C144.5,513.7,144.8,514.3,145.2,514.8z M152.5,518.9v3.1 c0.3,0.1,0.7,0.1,0.9,0.3v-3.1C153.2,519,152.8,519,152.5,518.9z M156.5,519.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C157.2,519.5,157,519.5,156.5,519.5z M154.5,519.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C155.2,519.4,154.9,519.4,154.5,519.3z  M146.3,516v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1C146.9,516.4,146.5,516.3,146.3,516z M150.5,518.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3 v-3.1C151.1,518.5,150.7,518.5,150.5,518.3z M148.4,517.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1 C149,517.6,148.7,517.5,148.4,517.4z M158.7,519.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C159.4,519.5,159,519.5,158.7,519.5z  M168.9,516.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C169.7,516.2,169.3,516.3,168.9,516.6z M160.7,519.4v3.1 c0.3,0,0.7-0.1,0.9-0.1v-3.1C161.4,519.3,161,519.4,160.7,519.4z M171,514.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C171.7,513.6,171.4,514.1,171,514.7z M166.8,517.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C167.5,517.5,167.2,517.6,166.8,517.8z  M164.8,518.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C165.5,518.3,165.2,518.5,164.8,518.6z M162.8,519.1v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C163.5,519,163,519,162.8,519.1z"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.1,505.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C153.6,502.5,162.5,502.3,168.1,505.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063599502774389125980000007973095741944259753_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1539,
    y1: 220.5407,
    x2: 171.0049,
    y2: 220.5407,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063599502774389125980000007973095741944259753_)"
    },
    d: "M167.2,506.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C154,503.3,162.1,503.2,167.2,506.1z"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M149.1,506.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C144.6,512,145.6,509,149.1,506.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062179799255426960520000003462025981492213386_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.9014,
    y1: 222.8171,
    x2: 172.3135,
    y2: 222.8171,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062179799255426960520000003462025981492213386_)"
    },
    d: "M164,500.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C172.3,504.6,169.4,501.7,164,500.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093171307338496111160000006081114097729580675_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2524,
    y1: 217.8064,
    x2: 172.014,
    y2: 217.8064,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000093171307338496111160000006081114097729580675_)",
      enableBackground: "new"
    },
    d: " M145.3,511.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C144.5,510.1,144.8,510.6,145.3,511.1z M152.5,515.2v3.1 c0.3,0.1,0.7,0.1,0.9,0.3v-3.1C153.2,515.3,152.9,515.3,152.5,515.2z M156.7,515.8v3.3c0.3,0,0.7,0,0.9,0v-3.3 C157.2,515.9,157,515.8,156.7,515.8z M154.5,515.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C155.2,515.8,154.9,515.6,154.5,515.6z  M146.4,512.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8V513C146.9,512.8,146.7,512.5,146.4,512.2z M150.5,514.5v3.1 c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C151.1,514.8,150.7,514.7,150.5,514.5z M148.4,513.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1 C149.1,514,148.7,513.9,148.4,513.6z M158.7,515.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C159.4,515.8,159,515.9,158.7,515.9z M169,512.9 v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C169.7,512.4,169.3,512.6,169,512.9z M160.7,515.8v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1 C161.4,515.6,161,515.6,160.7,515.8z M171,511v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C171.9,509.8,171.4,510.5,171,511z M167,514v3.1 c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C167.7,513.7,167.2,513.9,167,514z M164.8,514.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1 C165.5,514.7,165.2,514.7,164.8,514.8z M162.8,515.3v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C163.5,515.2,163.2,515.3,162.8,515.3z"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.1,501.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C153.6,498.7,162.5,498.7,168.1,501.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145053235267026503280000012613213229639773070_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1539,
    y1: 224.3068,
    x2: 171.0048,
    y2: 224.3068,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145053235267026503280000012613213229639773070_)"
    },
    d: "M167.2,502.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C154,499.5,162.1,499.5,167.2,502.3z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M149.2,503.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C144.6,508.2,145.6,505.2,149.2,503.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027574122615129237490000015442891706077177474_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1109,
    y1: 226.4737,
    x2: 173.5228,
    y2: 226.4737,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027574122615129237490000015442891706077177474_)"
    },
    d: "M165.2,496.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C173.5,500.9,170.6,498,165.2,496.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155123538581773473010000012214322770457921937_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.4617,
    y1: 221.5307,
    x2: 173.2235,
    y2: 221.5307,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000155123538581773473010000012214322770457921937_)",
      enableBackground: "new"
    },
    d: " M146.5,507.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C145.7,506.4,146,506.9,146.5,507.5z M153.7,511.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C154.4,511.7,154.1,511.6,153.7,511.6z M157.9,512.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C158.4,512.1,158.2,512.1,157.9,512.1z  M155.7,512v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C156.4,512,156.1,512,155.7,512z M147.5,508.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C148.2,509.1,147.9,508.8,147.5,508.6z M151.7,510.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C152.3,511.1,151.9,511,151.7,510.9z  M149.6,509.9v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C150.3,510.3,149.9,510.2,149.6,509.9z M159.9,512.1v3.3c0.3,0,0.7,0,0.9,0 v-3.3C160.6,512.1,160.2,512.1,159.9,512.1z M170.2,509.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C170.9,508.7,170.5,509,170.2,509.1z M162,512.1v3.1c0.3,0,0.7-0.1,0.9-0.1V512C162.6,512,162.2,512,162,512.1z M172.3,507.4 v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C173.1,506.1,172.7,506.7,172.3,507.4z M168.1,510.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1 C168.7,510.1,168.5,510.2,168.1,510.3z M166,511.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C166.7,511,166.4,511,166,511.1z  M164,511.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C164.7,511.6,164.4,511.6,164,511.7z"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M169.3,498.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C154.8,495,163.7,495,169.3,498.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039129212292435397170000014871456493958904767_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.3728,
    y1: 227.9634,
    x2: 172.2238,
    y2: 227.9634,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039129212292435397170000014871456493958904767_)"
    },
    d: "M168.5,498.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C155.2,495.8,163.3,495.8,168.5,498.7z"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M150.5,499.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C145.8,504.5,146.8,501.5,150.5,499.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155844350348070231250000007215478952864395439_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.8167,
    y1: 230.2656,
    x2: 172.2286,
    y2: 230.2656,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155844350348070231250000007215478952864395439_)"
    },
    d: "M163.9,492.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C172.1,497.2,169.4,494.2,163.9,492.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183930188269689322760000006651017629227725726_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1878,
    y1: 225.2549,
    x2: 171.9494,
    y2: 225.2549,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000183930188269689322760000006651017629227725726_)",
      enableBackground: "new"
    },
    d: " M145.2,503.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C144.4,502.6,144.8,503.2,145.2,503.7z M152.5,507.8v3.1 c0.3,0.1,0.7,0.1,0.9,0.3V508C153.2,507.9,152.8,507.9,152.5,507.8z M156.5,508.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C157.2,508.4,157,508.3,156.5,508.3z M154.5,508.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C155.2,508.3,154.8,508.2,154.5,508.2z  M146.3,504.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1C146.9,505.3,146.5,505.1,146.3,504.8z M150.3,507.1v3.1 c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C151,507.4,150.7,507.2,150.3,507.1z M148.3,506.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1 C149,506.5,148.7,506.4,148.3,506.1z M158.6,508.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C159.3,508.3,159,508.4,158.6,508.4z  M168.9,505.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C169.5,504.9,169.3,505.2,168.9,505.5z M160.6,508.3v3.1 c0.3,0,0.7-0.1,0.9-0.1v-3.1C161.3,508.2,161,508.2,160.6,508.3z M170.9,503.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C171.7,502.3,171.4,503,170.9,503.6z M166.8,506.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V506C167.5,506.3,167.2,506.4,166.8,506.5z  M164.8,507.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C165.5,507.2,165.1,507.2,164.8,507.4z M162.8,507.9v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C163.5,507.8,163,507.9,162.8,507.9z"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.1,494.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C153.6,491.2,162.5,491.2,168.1,494.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162320099394431550470000011703309727398615969_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1108,
    y1: 231.7553,
    x2: 170.9618,
    y2: 231.7553,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162320099394431550470000011703309727398615969_)"
    },
    d: "M167.1,494.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C154,492.1,162.1,492.1,167.1,494.9z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M149.1,495.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C144.6,500.7,145.6,497.7,149.1,495.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167371873963817766030000007315832671171238272_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.0484,
    y1: 208.4618,
    x2: 204.4601,
    y2: 208.4618,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167371873963817766030000007315832671171238272_)"
    },
    d: "M196.1,514.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C204.4,519,201.6,516,196.1,514.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026850186546876194260000016972191675280175769_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.416,
    y1: 203.4511,
    x2: 204.1775,
    y2: 203.4511,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000026850186546876194260000016972191675280175769_)",
      enableBackground: "new"
    },
    d: " M177.4,525.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C176.6,524.4,177,525,177.4,525.5z M184.7,529.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C185.4,529.7,185,529.7,184.7,529.6z M188.8,530.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C189.5,530.2,189.2,530.2,188.8,530.2z  M186.7,530v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C187.4,530.1,187,530,186.7,530z M178.5,526.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C179.2,527.1,178.8,526.9,178.5,526.7z M182.5,529v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C183.2,529.2,183,529.2,182.5,529z  M180.5,528.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C181.2,528.3,180.9,528.2,180.5,528.1z M190.8,530.2v3.3c0.3,0,0.7,0,0.9,0 v-3.3C191.5,530.2,191.2,530.2,190.8,530.2z M201.1,527.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C201.8,526.7,201.5,527,201.1,527.3 z M192.8,530.1v3.1c0.3,0,0.7-0.1,0.9-0.1V530C193.5,530,193.2,530.1,192.8,530.1z M203.1,525.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C203.9,524.3,203.7,524.8,203.1,525.4z M199.1,528.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C199.7,528.1,199.3,528.2,199.1,528.3 z M197,529.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C197.7,529,197.3,529.2,197,529.2z M195,529.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C195.7,529.6,195.3,529.7,195,529.7z"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M200.3,516.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C185.8,513,194.7,513,200.3,516.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102536277656041377700000004697453899979012255_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.3389,
    y1: 209.9516,
    x2: 203.1897,
    y2: 209.9516,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102536277656041377700000004697453899979012255_)"
    },
    d: "M199.3,516.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C186.2,513.9,194.3,513.9,199.3,516.7z"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M181.3,517.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C176.9,522.5,177.8,519.5,181.3,517.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135664082451331250770000014320474440079441310_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.778,
    y1: 213.2018,
    x2: 203.1898,
    y2: 213.2018,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135664082451331250770000014320474440079441310_)"
    },
    d: "M194.9,509.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C203.1,514.3,200.3,511.4,194.9,509.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011008602570602390970000017442468906117498244_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1288,
    y1: 208.191,
    x2: 202.8907,
    y2: 208.191,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000011008602570602390970000017442468906117498244_)",
      enableBackground: "new"
    },
    d: " M176.2,520.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C175.4,519.7,175.6,520.2,176.2,520.8z M183.4,524.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C184,525,183.8,525,183.4,524.8z M187.6,525.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C188.1,525.5,187.8,525.5,187.6,525.5z  M185.4,525.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C186.1,525.4,185.8,525.4,185.4,525.2z M177.1,522v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C177.8,522.4,177.5,522.3,177.1,522z M181.3,524.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C182,524.4,181.6,524.4,181.3,524.3z  M179.3,523.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C180,523.6,179.6,523.5,179.3,523.3z M189.6,525.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C190.3,525.5,189.9,525.5,189.6,525.5z M199.9,522.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C200.6,522.1,200.2,522.3,199.9,522.5z  M191.6,525.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C192.3,525.2,191.9,525.4,191.6,525.4z M201.9,520.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C202.7,519.5,202.3,520.1,201.9,520.6z M197.7,523.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C198.5,523.3,198.1,523.5,197.7,523.7 z M195.7,524.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C196.4,524.3,196.1,524.4,195.7,524.6z M193.7,525.1v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C194.3,525,194.1,525,193.7,525.1z"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M198.9,511.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C184.4,508.3,193.4,508.3,198.9,511.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132073714245173979210000017173278906919214773_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.0313,
    y1: 214.6915,
    x2: 201.8823,
    y2: 214.6915,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132073714245173979210000017173278906919214773_)"
    },
    d: "M198.1,512c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C184.9,509.1,193,509.1,198.1,512z"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M180.1,512.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C175.5,517.9,176.5,514.8,180.1,512.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021082207305626214300000004447714362782749606_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.8295,
    y1: 216.8583,
    x2: 203.2413,
    y2: 216.8583,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021082207305626214300000004447714362782749606_)"
    },
    d: "M194.9,506.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C203.1,510.5,200.3,507.6,194.9,506.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152229336929177961090000004533107734291011714_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1548,
    y1: 211.9153,
    x2: 202.9164,
    y2: 211.9153,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000152229336929177961090000004533107734291011714_)",
      enableBackground: "new"
    },
    d: " M176.2,517.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C175.4,516,175.8,516.6,176.2,517.1z M183.4,521.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C184,521.3,183.8,521.2,183.4,521.2z M187.6,521.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C188.2,521.7,187.8,521.7,187.6,521.7z  M185.5,521.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C186.1,521.7,185.8,521.6,185.5,521.6z M177.3,518.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V519C177.9,518.7,177.5,518.5,177.3,518.2z M181.3,520.5v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C182,520.8,181.7,520.6,181.3,520.5z  M179.3,519.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C180,519.9,179.6,519.8,179.3,519.5z M189.6,521.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C190.3,521.7,189.9,521.7,189.6,521.7z M199.9,518.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C200.6,518.3,200.2,518.6,199.9,518.7z  M191.6,521.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C192.3,521.6,192,521.6,191.6,521.7z M201.9,517v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C202.7,515.8,202.3,516.4,201.9,517z M197.9,519.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C198.5,519.7,198.1,519.8,197.9,519.9z  M195.8,520.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C196.5,520.6,196.1,520.6,195.8,520.8z M193.7,521.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3V521C194.3,521.2,194.1,521.2,193.7,521.3z"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M199.1,507.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C184.4,504.6,193.5,504.6,199.1,507.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035492073114839313680000014452575645156560574_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.0778,
    y1: 218.3481,
    x2: 201.9287,
    y2: 218.3481,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035492073114839313680000014452575645156560574_)"
    },
    d: "M198.1,508.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C184.9,505.5,193.1,505.5,198.1,508.3z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M180.1,509.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C175.6,514.1,176.6,511.1,180.1,509.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162310131882247213160000009514953389863537025_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.556,
    y1: 196.2734,
    x2: 182.9679,
    y2: 196.2734,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162310131882247213160000009514953389863537025_)"
    },
    d: "M174.7,526.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C182.8,531.1,180.1,528.2,174.7,526.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109733613235558849970000001574321170158243725_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.9218,
    y1: 191.3304,
    x2: 182.6833,
    y2: 191.3304,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000109733613235558849970000001574321170158243725_)",
      enableBackground: "new"
    },
    d: " M155.9,537.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C155.1,536.5,155.5,537.1,155.9,537.7z M163.2,541.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V542C163.9,541.9,163.5,541.8,163.2,541.8z M167.2,542.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C167.9,542.3,167.7,542.3,167.2,542.3z  M165.2,542.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C165.9,542.2,165.6,542.2,165.2,542.2z M157,538.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C157.6,539.3,157.2,539,157,538.8z M161.2,541.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C161.8,541.3,161.4,541.2,161.2,541.1z  M159,540.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C159.7,540.5,159.4,540.3,159,540.1z M169.3,542.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C170,542.3,169.7,542.3,169.3,542.3z M179.6,539.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C180.4,538.9,180,539.2,179.6,539.3z  M171.4,542.2v3.1c0.3,0,0.7-0.1,0.9-0.1V542C172.1,542.2,171.7,542.2,171.4,542.2z M181.6,537.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C182.4,536.3,182.1,536.9,181.6,537.6z M177.5,540.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V540C178.2,540.3,177.9,540.4,177.5,540.5z  M175.5,541.3v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C176.2,541.2,175.8,541.2,175.5,541.3z M173.5,541.9v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C174.2,541.8,173.7,541.8,173.5,541.9z"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M178.8,528.3c5.6,3.1,5.6,8.4,0,11.6s-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C164.3,525.2,173.2,525.2,178.8,528.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024708189469561636700000004790176647589922701_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.8301,
    y1: 197.7632,
    x2: 181.6808,
    y2: 197.7632,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024708189469561636700000004790176647589922701_)"
    },
    d: "M177.8,528.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6S172.8,526,177.8,528.9z"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M159.8,529.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C155.3,534.7,156.3,531.7,159.8,529.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082363411566510178270000011641123431303692202_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.0405,
    y1: 200.0654,
    x2: 182.4526,
    y2: 200.0654,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082363411566510178270000011641123431303692202_)"
    },
    d: "M174.2,522.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C182.4,527.4,179.6,524.4,174.2,522.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149362366790596005190000004608444669359900091_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.3915,
    y1: 195.0546,
    x2: 182.1535,
    y2: 195.0546,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000149362366790596005190000004608444669359900091_)",
      enableBackground: "new"
    },
    d: " M155.5,533.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C154.7,532.8,154.9,533.4,155.5,533.9z M162.6,538v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C163.3,538.1,162.9,538.1,162.6,538z M166.7,538.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C167.4,538.6,167.1,538.6,166.7,538.6z  M164.7,538.4v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C165.3,538.5,165.1,538.4,164.7,538.4z M156.4,535.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C157.1,535.5,156.8,535.3,156.4,535.1z M160.6,537.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C161.3,537.6,160.9,537.6,160.6,537.4z M158.6,536.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5V537C159.1,536.7,158.8,536.6,158.6,536.5z  M168.9,538.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C169.5,538.6,169.1,538.6,168.9,538.6z M179.2,535.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8 v-3.1C179.8,535.1,179.4,535.4,179.2,535.7z M170.9,538.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C171.6,538.4,171.2,538.5,170.9,538.5 z M181.2,533.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C181.9,532.7,181.6,533.2,181.2,533.8z M177,536.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5 v-3.1C177.7,536.5,177.4,536.6,177,536.7z M175,537.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C175.6,537.4,175.4,537.6,175,537.6z  M172.9,538.1v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C173.6,538,173.3,538.1,172.9,538.1z"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M178.2,524.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C163.7,521.4,172.7,521.4,178.2,524.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078039657399063152510000009271265183353451160_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3109,
    y1: 201.5551,
    x2: 181.1619,
    y2: 201.5551,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078039657399063152510000009271265183353451160_)"
    },
    d: "M177.4,525.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C164.1,522.3,172.3,522.3,177.4,525.1z"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M159.4,525.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C154.8,530.9,155.7,527.9,159.4,525.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134236562276814254810000002546943310171159206_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.6464,
    y1: 661.8715,
    x2: 670.0582,
    y2: 661.8715,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134236562276814254810000002546943310171159206_)"
    },
    d: "M661.7,61.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C670,65.5,667.1,62.6,661.7,61.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167375176800221787510000015725644640567236276_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9807,
    y1: 656.9284,
    x2: 669.7422,
    y2: 656.9284,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000167375176800221787510000015725644640567236276_)",
      enableBackground: "new"
    },
    d: " M643,72.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C642.2,70.9,642.6,71.6,643,72.1z M650.2,76.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C650.9,76.3,650.6,76.2,650.2,76.2z M654.4,76.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C655.1,76.7,654.6,76.7,654.4,76.7z M652.3,76.6 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C653,76.6,652.6,76.6,652.3,76.6z M644.1,73.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8V74 C644.8,73.7,644.4,73.4,644.1,73.2z M648.1,75.5v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C648.8,75.7,648.6,75.6,648.1,75.5z  M646.1,74.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C646.8,74.9,646.4,74.8,646.1,74.5z M656.4,76.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C657.1,76.7,656.7,76.7,656.4,76.7z M666.7,73.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C667.4,73.3,667,73.6,666.7,73.7z  M658.4,76.6v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C659.1,76.6,658.8,76.6,658.4,76.6z M668.7,72v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C669.5,70.7,669.1,71.3,668.7,72z M664.7,74.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C665.3,74.7,664.9,74.8,664.7,74.9z  M662.6,75.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C663.3,75.6,662.9,75.6,662.6,75.7z M660.5,76.3v3.1c0.3-0.1,0.7-0.1,0.9-0.3V76 C661.1,76.2,660.9,76.2,660.5,76.3z"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.9,62.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C651.3,59.6,660.3,59.6,665.9,62.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132055885966490804520000005116852781358116518_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.9037,
    y1: 663.3612,
    x2: 668.7545,
    y2: 663.3612,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132055885966490804520000005116852781358116518_)"
    },
    d: "M664.9,63.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C651.7,60.4,659.9,60.4,664.9,63.3z"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M646.9,64c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C642.5,69.1,643.4,66.1,646.9,64z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181055631045401865630000008262957944695005320_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.5779,
    y1: 666.6115,
    x2: 669.9897,
    y2: 666.6115,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181055631045401865630000008262957944695005320_)"
    },
    d: "M661.7,56.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C670,60.7,667.1,57.9,661.7,56.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178185654622476327980000015873470339943369088_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9288,
    y1: 661.6006,
    x2: 669.6904,
    y2: 661.6006,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000178185654622476327980000015873470339943369088_)",
      enableBackground: "new"
    },
    d: " M643,67.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C642.2,66.3,642.5,66.8,643,67.4z M650.2,71.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C650.9,71.6,650.4,71.4,650.2,71.4z M654.2,72v3.3c0.3,0,0.7,0,0.9,0V72C654.9,72.1,654.6,72,654.2,72z M652.2,71.8v3.1 c0.3,0,0.7,0.1,0.9,0.1V72C652.9,72,652.6,71.8,652.2,71.8z M643.9,68.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C644.6,69,644.4,68.7,643.9,68.4z M648.1,70.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V71C648.8,71,648.4,70.9,648.1,70.7z M646.1,69.8 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C646.7,70.2,646.4,70.1,646.1,69.8z M656.4,72.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C657.1,72,656.7,72,656.4,72.1z M666.7,69.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C667.4,68.6,667,68.8,666.7,69.1z M658.4,72v3.1 c0.3,0,0.7-0.1,0.9-0.1v-3.1C659.1,71.8,658.7,71.8,658.4,72z M668.7,67.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C669.4,66,669.1,66.7,668.7,67.2z M664.5,70.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C665.2,69.9,664.9,70.1,664.5,70.2z M662.5,71 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C663.2,70.9,662.9,70.9,662.5,71z M660.5,71.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C661.1,71.4,660.9,71.6,660.5,71.6z"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.8,58c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C651.3,54.9,660.2,54.9,665.8,58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070832224340280434670000009843377964131647882_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.8481,
    y1: 668.1011,
    x2: 668.699,
    y2: 668.1011,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070832224340280434670000009843377964131647882_)"
    },
    d: "M664.9,58.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C651.7,55.7,659.8,55.7,664.9,58.5z"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M646.9,59.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C642.3,64.4,643.3,61.4,646.9,59.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121985574705021495500000013553441447619997837_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.6039,
    y1: 670.4034,
    x2: 670.0156,
    y2: 670.4034,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121985574705021495500000013553441447619997837_)"
    },
    d: "M661.7,52.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C670,57.1,667.1,54.2,661.7,52.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127008011193648057620000009271099050090412465_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9548,
    y1: 665.3926,
    x2: 669.7163,
    y2: 665.3926,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000127008011193648057620000009271099050090412465_)",
      enableBackground: "new"
    },
    d: " M643,63.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C642.2,62.5,642.5,63,643,63.6z M650.2,67.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C650.9,67.8,650.6,67.8,650.2,67.6z M654.4,68.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C655.1,68.3,654.6,68.3,654.4,68.3z M652.2,68v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C652.9,68.2,652.6,68.2,652.2,68z M644.1,64.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C644.6,65.2,644.4,65.1,644.1,64.8z M648.1,67.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C648.8,67.2,648.4,67.2,648.1,67.1z  M646.1,66.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C646.8,66.4,646.4,66.3,646.1,66.1z M656.4,68.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C657.1,68.3,656.7,68.3,656.4,68.3z M666.7,65.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C667.4,64.9,667,65.1,666.7,65.3z  M658.4,68.2v3.1c0.3,0,0.7-0.1,0.9-0.1V68C659.1,68,658.8,68.2,658.4,68.2z M668.7,63.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C669.5,62.3,669.1,62.9,668.7,63.4z M664.7,66.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V66C665.3,66.1,664.9,66.3,664.7,66.5z  M662.5,67.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C663.2,67.1,662.9,67.2,662.5,67.4z M660.5,67.9V71c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C661.1,67.8,660.9,67.8,660.5,67.9z"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.8,54.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C651.3,51.1,660.2,51.1,665.8,54.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121993282798462342340000001189204608455211912_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.8778,
    y1: 671.8084,
    x2: 668.7287,
    y2: 671.8084,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121993282798462342340000001189204608455211912_)"
    },
    d: "M664.9,54.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C651.7,51.9,659.8,51.9,664.9,54.9z"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M646.9,55.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C642.3,60.7,643.3,57.6,646.9,55.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076595322448050028580000002354727276159192497_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.6464,
    y1: 674.0599,
    x2: 670.0582,
    y2: 674.0599,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076595322448050028580000002354727276159192497_)"
    },
    d: "M661.7,48.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C670,53.3,667.1,50.4,661.7,48.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183943317034662340370000016616636804447861139_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9807,
    y1: 669.0491,
    x2: 669.7422,
    y2: 669.0491,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000183943317034662340370000016616636804447861139_)",
      enableBackground: "new"
    },
    d: " M643,59.9V63c-0.4-0.5-0.8-1.2-0.9-1.8v-3C642.2,58.8,642.6,59.4,643,59.9z M650.2,64v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C650.9,64.1,650.6,64,650.2,64z M654.4,64.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C655.1,64.6,654.6,64.5,654.4,64.5z M652.3,64.4v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C653,64.5,652.6,64.4,652.3,64.4z M644.1,61v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C644.8,61.5,644.4,61.3,644.1,61z M648.1,63.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C648.8,63.6,648.6,63.4,648.1,63.3z  M646.1,62.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C646.8,62.7,646.4,62.6,646.1,62.3z M656.4,64.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C657.1,64.5,656.7,64.5,656.4,64.6z M666.7,61.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C667.4,61.1,667,61.4,666.7,61.5z  M658.4,64.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C659.1,64.4,658.8,64.4,658.4,64.5z M668.7,59.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C669.5,58.5,669.1,59.2,668.7,59.8z M664.7,62.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C665.3,62.5,664.9,62.6,664.7,62.7z  M662.6,63.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C663.3,63.4,662.9,63.4,662.6,63.6z M660.5,64.1v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C661.1,64,660.9,64.1,660.5,64.1z"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.9,50.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C651.3,47.4,660.3,47.4,665.9,50.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076589618804756391600000012380614638405417639_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.9037,
    y1: 675.5496,
    x2: 668.7545,
    y2: 675.5496,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076589618804756391600000012380614638405417639_)"
    },
    d: "M664.9,51.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C651.7,48.3,659.9,48.3,664.9,51.1z"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M646.9,51.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C642.5,56.9,643.4,53.9,646.9,51.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109743776156775331660000016126219880943283129_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.8652,
    y1: 677.7164,
    x2: 671.2772,
    y2: 677.7164,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109743776156775331660000016126219880943283129_)"
    },
    d: "M662.9,45.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C671.2,49.6,668.3,46.8,662.9,45.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151516878859706498280000009946615232624645511_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.1899,
    y1: 672.7733,
    x2: 670.9515,
    y2: 672.7733,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000151516878859706498280000009946615232624645511_)",
      enableBackground: "new"
    },
    d: " M644.2,56.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C643.4,55,643.8,55.7,644.2,56.2z M651.4,60.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C652.1,60.4,651.8,60.3,651.4,60.3z M655.6,60.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C656.3,60.9,655.9,60.9,655.6,60.9z M653.6,60.6 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C654.1,60.7,653.8,60.7,653.6,60.6z M645.3,57.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C646,57.7,645.6,57.6,645.3,57.3z M649.4,59.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C650,59.9,649.8,59.8,649.4,59.6z M647.3,58.7 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C648,59,647.6,58.8,647.3,58.7z M657.6,60.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C658.3,60.9,657.9,60.9,657.6,60.9z M667.9,57.9V61c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C668.6,57.5,668.2,57.7,667.9,57.9z  M659.7,60.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C660.3,60.7,660.1,60.7,659.7,60.7z M670,56.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C670.8,54.9,670.4,55.4,670,56.1z M665.9,59.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C666.6,58.8,666.2,59,665.9,59.1z M663.9,59.9 V63c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C664.5,59.6,664.1,59.8,663.9,59.9z M661.7,60.4v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C662.4,60.3,662.1,60.3,661.7,60.4z"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M667.1,46.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C652.5,43.8,661.6,43.8,667.1,46.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063609409338344498590000012317013919444859528_",
    gradientUnits: "userSpaceOnUse",
    x1: 644.1129,
    y1: 679.2319,
    x2: 669.9639,
    y2: 679.2319,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063609409338344498590000012317013919444859528_)"
    },
    d: "M666.2,47.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C652.9,44.6,661.1,44.5,666.2,47.4z"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M648.1,48.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C643.7,53.3,644.6,50.3,648.1,48.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147206144143448235510000006136648292483185043_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.5649,
    y1: 681.5084,
    x2: 669.9768,
    y2: 681.5084,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147206144143448235510000006136648292483185043_)"
    },
    d: "M661.7,41.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C669.8,45.8,667.1,43,661.7,41.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182501167786253192120000013341684380716935570_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9172,
    y1: 676.5653,
    x2: 669.6798,
    y2: 676.5653,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000182501167786253192120000013341684380716935570_)",
      enableBackground: "new"
    },
    d: " M642.9,52.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C642.2,51.4,642.5,51.9,642.9,52.5z M650.2,56.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C650.9,56.7,650.4,56.5,650.2,56.5z M654.2,57.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C654.9,57.1,654.6,57.1,654.2,57.1z M652.2,56.9V60 c0.3,0,0.7,0.1,0.9,0.1v-3.1C652.9,56.9,652.6,56.9,652.2,56.9z M643.9,53.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C644.6,54.1,644.2,53.8,643.9,53.5z M648.1,55.8V59c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C648.8,56.1,648.4,56,648.1,55.8z M646.1,54.9 V58c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C646.7,55.3,646.4,55.2,646.1,54.9z M656.4,57.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C656.9,57.1,656.7,57.1,656.4,57.1z M666.6,54.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C667.4,53.7,667,53.9,666.6,54.1z  M658.4,57.1v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C659.1,56.9,658.7,56.9,658.4,57.1z M668.7,52.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C669.4,51.1,669.1,51.8,668.7,52.3z M664.5,55.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C665.2,55,664.9,55.2,664.5,55.3z  M662.5,56.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C663.2,56,662.9,56,662.5,56.1z M660.5,56.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C661.1,56.5,660.7,56.5,660.5,56.7z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.8,43.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C651.3,40,660.2,40,665.8,43.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172431643965487724040000000332150852177158542_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.8481,
    y1: 682.9981,
    x2: 668.6992,
    y2: 682.9981,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172431643965487724040000000332150852177158542_)"
    },
    d: "M664.9,43.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C651.7,40.8,659.8,40.8,664.9,43.7z"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M646.8,44.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C642.3,49.5,643.3,46.5,646.8,44.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008120169920605248670000002609129857413640379_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.7448,
    y1: 492.8586,
    x2: 866.1566,
    y2: 492.8586,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008120169920605248670000002609129857413640379_)"
    },
    d: "M857.8,230.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C866,234.6,863.3,231.6,857.8,230.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113331553786160945290000010243046937691539871_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.1193,
    y1: 487.8478,
    x2: 865.881,
    y2: 487.8478,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000113331553786160945290000010243046937691539871_)",
      enableBackground: "new"
    },
    d: " M839.1,241.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C838.3,240,838.7,240.6,839.1,241.1z M846.4,245.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C847.1,245.3,846.7,245.3,846.4,245.2z M850.5,245.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C851.2,245.8,850.9,245.8,850.5,245.8z  M848.4,245.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C849.1,245.7,848.7,245.6,848.4,245.6z M840.2,242.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C840.9,242.7,840.5,242.5,840.2,242.3z M844.4,244.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C844.9,244.8,844.7,244.8,844.4,244.6z M842.2,243.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C842.9,243.9,842.6,243.8,842.2,243.7z  M852.5,245.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C853.2,245.8,852.9,245.8,852.5,245.8z M862.8,242.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C863.5,242.5,863.2,242.6,862.8,242.9z M854.7,245.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C855.2,245.6,854.9,245.7,854.7,245.7z  M864.8,241v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C865.6,239.9,865.4,240.4,864.8,241z M860.8,244.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1 C861.4,243.7,861.2,243.8,860.8,244.1z M858.7,244.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C859.4,244.6,859,244.8,858.7,244.8z  M856.7,245.3v3.1c0.3-0.1,0.7-0.1,0.9-0.3V245C857.4,245.2,857,245.3,856.7,245.3z"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M862,231.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C847.5,228.6,856.4,228.6,862,231.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091012734316786941950000011086179254887071369_",
    gradientUnits: "userSpaceOnUse",
    x1: 839.0425,
    y1: 494.3483,
    x2: 864.8934,
    y2: 494.3483,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091012734316786941950000011086179254887071369_)"
    },
    d: "M861,232.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C847.9,229.5,856,229.5,861,232.3z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M843,233.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C838.6,238.1,839.5,235.1,843,233.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029046211235472903290000013210208458670995585_",
    gradientUnits: "userSpaceOnUse",
    x1: 836.4816,
    y1: 497.5986,
    x2: 864.8934,
    y2: 497.5986,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029046211235472903290000013210208458670995585_)"
    },
    d: "M856.6,225.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C864.8,229.9,862,227,856.6,225.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000210688420149514640000013045925155315595959_",
    gradientUnits: "userSpaceOnUse",
    x1: 836.8326,
    y1: 492.5877,
    x2: 864.5941,
    y2: 492.5877,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000000210688420149514640000013045925155315595959_)",
      enableBackground: "new"
    },
    d: " M837.9,236.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C837.1,235.3,837.3,235.8,837.9,236.4z M845.1,240.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C845.7,240.6,845.5,240.6,845.1,240.4z M849.3,241.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C849.9,241.1,849.5,241.1,849.3,241.1z  M847.1,240.8v3.1c0.3,0,0.7,0.1,0.9,0.1V241C847.8,241,847.5,241,847.1,240.8z M839,237.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C839.5,238,839.2,237.9,839,237.6z M843,239.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C843.7,240,843.3,240,843,239.9z M841,238.9v3.1 c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C841.7,239.2,841.3,239.1,841,238.9z M851.3,241.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C852,241.1,851.6,241.1,851.3,241.1z M861.6,238.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C862.3,237.7,861.9,237.9,861.6,238.1z  M853.3,241v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C854,240.8,853.7,241,853.3,241z M863.6,236.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C864.4,235.1,864,235.7,863.6,236.2z M859.5,239.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C860.2,238.9,859.8,239.2,859.5,239.3z  M857.4,240.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C858.1,239.9,857.8,240,857.4,240.2z M855.4,240.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C856,240.6,855.8,240.6,855.4,240.7z"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M860.6,227.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C846.1,224,855.1,223.9,860.6,227.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044158978503922783460000017194981135863758762_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.7555,
    y1: 499.0036,
    x2: 863.6064,
    y2: 499.0036,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044158978503922783460000017194981135863758762_)"
    },
    d: "M859.8,227.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C846.5,224.7,854.7,224.7,859.8,227.7z"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M841.8,228.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C837.2,233.5,838.2,230.5,841.8,228.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047033071806570060140000015370180388993989048_",
    gradientUnits: "userSpaceOnUse",
    x1: 836.5259,
    y1: 501.2551,
    x2: 864.9379,
    y2: 501.2551,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047033071806570060140000015370180388993989048_)"
    },
    d: "M856.6,221.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C864.8,226.1,862,223.2,856.6,221.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126287077777367834170000003377926909536681632_",
    gradientUnits: "userSpaceOnUse",
    x1: 836.8583,
    y1: 496.2443,
    x2: 864.6199,
    y2: 496.2443,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000126287077777367834170000003377926909536681632_)",
      enableBackground: "new"
    },
    d: " M837.9,232.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C837.1,231.6,837.5,232.2,837.9,232.7z M845.1,236.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V237C845.7,236.9,845.5,236.8,845.1,236.8z M849.3,237.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C849.9,237.4,849.5,237.3,849.3,237.3z  M847.2,237.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C847.8,237.3,847.5,237.2,847.2,237.2z M839,233.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C839.6,234.3,839.2,234.1,839,233.8z M843,236.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C843.7,236.4,843.4,236.2,843,236.1z  M841,235.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C841.7,235.6,841.3,235.4,841,235.1z M851.3,237.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C852,237.3,851.6,237.3,851.3,237.4z M861.6,234.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C862.3,233.9,861.9,234.2,861.6,234.5z  M853.3,237.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C854,237.2,853.7,237.2,853.3,237.3z M863.6,232.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C864.4,231.4,864,232,863.6,232.6z M859.5,235.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5V235C860.2,235.3,859.8,235.4,859.5,235.6z  M857.5,236.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C858.2,236.2,857.8,236.2,857.5,236.4z M855.4,236.9v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C856,236.8,855.8,236.9,855.4,236.9z"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M860.8,223.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C846.1,220.2,855.2,220.2,860.8,223.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145761956678756507180000002997437664358649233_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.7814,
    y1: 502.7448,
    x2: 863.6323,
    y2: 502.7448,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145761956678756507180000002997437664358649233_)"
    },
    d: "M859.8,223.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C846.5,221.1,854.8,221.1,859.8,223.9z"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M841.8,224.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C837.3,229.7,838.3,226.7,841.8,224.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110466593772895775200000009439402206534510774_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.4422,
    y1: 334.5614,
    x2: 415.8542,
    y2: 334.5614,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110466593772895775200000009439402206534510774_)"
    },
    d: "M407.5,388.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C415.8,392.8,413,389.9,407.5,388.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000926461558574415010000013954990224071180182_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.7932,
    y1: 329.686,
    x2: 415.5551,
    y2: 329.686,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000000926461558574415010000013954990224071180182_)",
      enableBackground: "new"
    },
    d: " M388.9,399.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C388,398.2,388.3,398.7,388.9,399.4z M396,403.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C396.7,403.6,396.4,403.5,396,403.5z M400.2,404v3.3c0.3,0,0.7,0,0.9,0V404C400.8,404,400.5,404,400.2,404z M398.1,403.7v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C398.7,403.9,398.5,403.9,398.1,403.7z M389.8,400.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C390.5,400.9,390.2,400.8,389.8,400.5z M394,402.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C394.7,402.9,394.3,402.9,394,402.8z  M392,401.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C392.6,402.1,392.2,402,392,401.8z M402.3,404v3.3c0.3,0,0.7,0,0.9,0V404 C402.9,404,402.5,404,402.3,404z M412.6,401v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C413.2,400.6,412.8,400.8,412.6,401z M404.3,403.9 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C405,403.7,404.6,403.9,404.3,403.9z M414.6,399.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C415.4,398,415,398.6,414.6,399.1z M410.4,402.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C411.1,402,410.8,402.1,410.4,402.2z  M408.4,403.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C409,402.8,408.8,402.9,408.4,403.1z M406.3,403.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C407,403.5,406.7,403.5,406.3,403.6z"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M411.6,390.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C397.1,386.9,406.1,386.8,411.6,390.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163074563524458387920000005939275939336174983_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.7024,
    y1: 336.0769,
    x2: 414.5534,
    y2: 336.0769,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163074563524458387920000005939275939336174983_)"
    },
    d: "M410.8,390.6c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C397.5,387.8,405.6,387.6,410.8,390.6z"
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M392.8,391.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C388.2,396.4,389.1,393.4,392.8,391.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163754309991389696630000016546194851308597936_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.4899,
    y1: 339.7076,
    x2: 410.9018,
    y2: 339.7076,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163754309991389696630000016546194851308597936_)"
    },
    d: "M402.5,383.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C410.8,387.8,408.1,384.8,402.5,383.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137092704573933510430000010600501697847452826_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.8283,
    y1: 334.6968,
    x2: 410.5902,
    y2: 334.6968,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000137092704573933510430000010600501697847452826_)",
      enableBackground: "new"
    },
    d: " M383.8,394.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C383,393.2,383.4,393.7,383.8,394.3z M391,398.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C391.7,398.5,391.4,398.5,391,398.3z M395.2,399v3.3c0.3,0,0.7,0,0.9,0V399C395.9,399,395.5,399,395.2,399z M393.2,398.7v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C393.9,398.9,393.5,398.7,393.2,398.7z M384.9,395.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C385.6,395.9,385.2,395.6,384.9,395.5z M389,397.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3V398C389.7,397.9,389.4,397.9,389,397.8z  M387,396.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C387.6,397.1,387.2,397,387,396.8z M397.3,399v3.3c0.3,0,0.7,0,0.9,0V399 C397.9,399,397.7,399,397.3,399z M407.5,396v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C408.2,395.6,407.8,395.7,407.5,396z M399.3,398.9 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C400,398.7,399.7,398.9,399.3,398.9z M409.6,394.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C410.4,393,410,393.6,409.6,394.1z M405.5,397.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C406.2,396.8,405.8,397,405.5,397.2z  M403.5,397.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C404.2,397.8,403.8,397.9,403.5,397.9z M401.3,398.5v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C402,398.3,401.7,398.5,401.3,398.5z"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M406.7,385c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C392.1,381.8,401.2,381.8,406.7,385z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075130620488757903520000014627202647437636775_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.7514,
    y1: 341.1973,
    x2: 409.6024,
    y2: 341.1973,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075130620488757903520000014627202647437636775_)"
    },
    d: "M405.8,385.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C392.5,382.6,400.8,382.6,405.8,385.5z"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M387.8,386.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C383.3,391.3,384.3,388.3,387.8,386.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064356085841632763340000015683460823219140743_",
    gradientUnits: "userSpaceOnUse",
    x1: 652.2842,
    y1: 647.5162,
    x2: 680.6958,
    y2: 647.5162,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064356085841632763340000015683460823219140743_)"
    },
    d: "M672.4,75.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C680.6,79.8,677.8,77,672.4,75.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008136922420595201890000008423795087778647485_",
    gradientUnits: "userSpaceOnUse",
    x1: 652.6351,
    y1: 642.6409,
    x2: 680.3969,
    y2: 642.6409,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000008136922420595201890000008423795087778647485_)",
      enableBackground: "new"
    },
    d: " M653.7,86.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C652.9,85.2,653.2,85.9,653.7,86.4z M660.9,90.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C661.6,90.6,661.3,90.5,660.9,90.5z M665.1,91.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C665.6,91.1,665.3,91.1,665.1,91.1z M662.9,90.8v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C663.6,90.9,663.3,90.9,662.9,90.8z M654.6,87.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C655.3,87.9,655.1,87.8,654.6,87.5z M658.8,89.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C659.5,90.1,659.1,90,658.8,89.8z M656.8,88.9 V92c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C657.5,89.2,657.1,89,656.8,88.9z M667.1,91.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C667.8,91.1,667.4,91.1,667.1,91.1z M677.4,88.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C678.1,87.7,677.7,87.9,677.4,88.1z  M669.1,90.9V94c0.3,0,0.7-0.1,0.9-0.1v-3.1C669.8,90.9,669.4,90.9,669.1,90.9z M679.4,86.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C680.2,85.1,679.8,85.6,679.4,86.2z M675.2,89.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C675.9,89,675.6,89.2,675.2,89.3z M673.2,90.1 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C673.9,89.8,673.6,90,673.2,90.1z M671.2,90.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C671.8,90.5,671.6,90.5,671.2,90.6z"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M676.5,77.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C662,74,670.9,73.9,676.5,77.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000939112154336954050000004685789692941403533_",
    gradientUnits: "userSpaceOnUse",
    x1: 653.5469,
    y1: 649.0317,
    x2: 679.3979,
    y2: 649.0317,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000939112154336954050000004685789692941403533_)"
    },
    d: "M675.6,77.6c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C662.4,74.8,670.5,74.7,675.6,77.6z"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M657.6,78.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C653,83.5,654,80.5,657.6,78.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180343416444534744280000003601167001765945257_",
    gradientUnits: "userSpaceOnUse",
    x1: 651.7688,
    y1: 651.3082,
    x2: 680.1805,
    y2: 651.3082,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180343416444534744280000003601167001765945257_)"
    },
    d: "M671.8,71.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C680.1,76.2,677.3,73.2,671.8,71.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180354155084424537310000013494569991891921055_",
    gradientUnits: "userSpaceOnUse",
    x1: 652.1197,
    y1: 646.2974,
    x2: 679.8812,
    y2: 646.2974,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000180354155084424537310000013494569991891921055_)",
      enableBackground: "new"
    },
    d: " M653.2,82.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C652.3,81.6,652.8,82.1,653.2,82.7z M660.3,86.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3V87 C661,86.9,660.7,86.9,660.3,86.7z M664.5,87.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C665.2,87.4,664.8,87.4,664.5,87.3z M662.5,87.1v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C663,87.3,662.8,87.1,662.5,87.1z M654.2,83.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C654.8,84.3,654.5,84,654.2,83.7z M658.3,86.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C659,86.3,658.6,86.2,658.3,86.2z M656.3,85.2 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C656.9,85.5,656.5,85.4,656.3,85.2z M666.6,87.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C667.2,87.3,666.8,87.4,666.6,87.4z M676.9,84.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C677.5,83.9,677.1,84.1,676.9,84.4z  M668.6,87.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C669.3,87.1,669,87.3,668.6,87.3z M678.9,82.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C679.7,81.4,679.3,82,678.9,82.5z M674.8,85.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V85C675.5,85.2,675.1,85.4,674.8,85.5z M672.7,86.3 v3.1c0.3-0.1,0.7-0.3,0.9-0.3V86C673.3,86.2,673.1,86.2,672.7,86.3z M670.6,86.9V90c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C671.3,86.7,671,86.9,670.6,86.9z"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M676,73.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C661.4,70.2,670.4,70.2,676,73.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038395318646299150090000002578651518201539987_",
    gradientUnits: "userSpaceOnUse",
    x1: 653.0427,
    y1: 652.7979,
    x2: 678.8937,
    y2: 652.7979,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038395318646299150090000002578651518201539987_)"
    },
    d: "M675.1,73.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C661.8,71,670.1,71,675.1,73.9z"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M657.1,74.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C652.5,79.7,653.4,76.7,657.1,74.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122001645443084836500000002060818601968185729_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.6642,
    y1: 236.6307,
    x2: 904.0762,
    y2: 236.6307,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122001645443084836500000002060818601968185729_)"
    },
    d: "M895.7,486.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C904,490.8,901.3,487.9,895.7,486.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177475871182740124820000015377822054629633441_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.0228,
    y1: 231.6199,
    x2: 903.7844,
    y2: 231.6199,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000177475871182740124820000015377822054629633441_)",
      enableBackground: "new"
    },
    d: " M877,497.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C876.2,496.2,876.6,496.8,877,497.3z M884.3,501.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C884.9,501.5,884.6,501.5,884.3,501.4z M888.4,501.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C889.1,502.1,888.7,501.9,888.4,501.9z  M886.4,501.8v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C887,501.9,886.6,501.8,886.4,501.8z M878.1,498.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C878.8,499,878.4,498.7,878.1,498.4z M882.2,500.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V501C882.8,501,882.6,500.9,882.2,500.7z  M880.1,499.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C880.8,500.2,880.5,500,880.1,499.8z M890.4,502.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C891.1,501.9,890.8,502.1,890.4,502.1z M900.7,499.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C901.4,498.6,901.1,498.8,900.7,499.1z  M892.5,501.9v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C893.1,501.8,892.9,501.8,892.5,501.9z M902.7,497.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C903.6,496,903.2,496.7,902.7,497.2z M898.7,500.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C899.4,499.9,899,500,898.7,500.2z  M896.7,501v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C897.3,500.9,896.9,500.9,896.7,501z M894.6,501.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C895.3,501.4,894.9,501.5,894.6,501.5z"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M899.9,488c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C885.3,484.9,894.4,484.9,899.9,488z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013890354169750553260000003850135607519200677_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.9458,
    y1: 238.1204,
    x2: 902.7968,
    y2: 238.1204,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013890354169750553260000003850135607519200677_)"
    },
    d: "M899,488.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C885.8,485.7,893.9,485.7,899,488.5z"
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M880.9,489.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C876.5,494.4,877.4,491.4,880.9,489.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054233306289042366210000016689428773182558082_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.6201,
    y1: 241.3707,
    x2: 904.0319,
    y2: 241.3707,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054233306289042366210000016689428773182558082_)"
    },
    d: "M895.7,481.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C904,486.1,901.1,483.1,895.7,481.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168086902606797603630000004376418296175593914_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.971,
    y1: 236.3599,
    x2: 903.7327,
    y2: 236.3599,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000168086902606797603630000004376418296175593914_)",
      enableBackground: "new"
    },
    d: " M877,492.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C876.2,491.5,876.5,492.1,877,492.6z M884.2,496.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C884.9,496.8,884.6,496.8,884.2,496.7z M888.4,497.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C889.1,497.3,888.7,497.3,888.4,497.2z  M886.2,497.1v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C886.9,497.2,886.6,497.1,886.2,497.1z M878.1,493.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C878.6,494.2,878.4,493.9,878.1,493.7z M882.2,496.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C882.8,496.2,882.4,496.1,882.2,496.1z M880.1,495.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C880.8,495.4,880.4,495.3,880.1,495.2z  M890.4,497.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C891.1,497.3,890.7,497.3,890.4,497.3z M900.7,494.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C901.4,493.8,901,494.1,900.7,494.4z M892.5,497.2v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C893.1,497.1,892.9,497.2,892.5,497.2z  M902.7,492.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C903.6,491.4,903.2,491.9,902.7,492.5z M898.7,495.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5 v-3.1C899.4,495.2,899,495.3,898.7,495.4z M896.5,496.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V496C897.2,496.1,896.9,496.2,896.5,496.2z  M894.5,496.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C895.2,496.7,894.9,496.8,894.5,496.8z"
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M899.8,483.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C885.3,480.1,894.2,480.1,899.8,483.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073705551359190333300000015988997104357764267_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.8942,
    y1: 242.8604,
    x2: 902.7449,
    y2: 242.8604,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073705551359190333300000015988997104357764267_)"
    },
    d: "M899,483.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C885.7,480.9,893.8,480.9,899,483.8z"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M880.9,484.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C876.3,489.6,877.3,486.6,880.9,484.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137108857990618342680000015749106651178034827_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.6642,
    y1: 245.0271,
    x2: 904.0763,
    y2: 245.0271,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137108857990618342680000015749106651178034827_)"
    },
    d: "M895.7,478c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C904,482.3,901.1,479.5,895.7,478z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145015980735541885670000011322085413789218960_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.9969,
    y1: 240.1518,
    x2: 903.7584,
    y2: 240.1518,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000145015980735541885670000011322085413789218960_)",
      enableBackground: "new"
    },
    d: " M877,488.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C876.2,487.7,876.6,488.4,877,488.9z M884.2,493v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C884.9,493.1,884.6,493,884.2,493z M888.4,493.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C889.1,493.5,888.7,493.5,888.4,493.5z M886.4,493.3 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C886.9,493.4,886.6,493.4,886.4,493.3z M878.1,490v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C878.8,490.4,878.4,490.3,878.1,490z M882.2,492.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C882.8,492.6,882.6,492.5,882.2,492.3z  M880.1,491.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C880.8,491.6,880.4,491.5,880.1,491.4z M890.4,493.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C891.1,493.5,890.7,493.5,890.4,493.5z M900.7,490.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C901.4,490.2,901,490.4,900.7,490.6z  M892.5,493.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C893.1,493.4,892.9,493.4,892.5,493.4z M902.7,488.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C903.6,487.6,903.2,488.1,902.7,488.7z M898.7,491.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C899.4,491.5,899,491.6,898.7,491.8z  M896.7,492.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C897.3,492.3,896.9,492.5,896.7,492.6z M894.5,493.1v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C895.2,493,894.9,493,894.5,493.1z"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M899.9,479.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C885.3,476.5,894.4,476.3,899.9,479.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013154109888603451760000009146711266247559309_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.9199,
    y1: 246.5427,
    x2: 902.7708,
    y2: 246.5427,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013154109888603451760000009146711266247559309_)"
    },
    d: "M899,480.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C885.7,477.3,893.9,477.2,899,480.1z"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M880.9,480.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C876.5,486,877.4,483,880.9,480.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157994439729065864420000017042161385973556618_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.6642,
    y1: 248.8191,
    x2: 904.076,
    y2: 248.8191,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157994439729065864420000017042161385973556618_)"
    },
    d: "M895.7,474.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C904,478.6,901.3,475.7,895.7,474.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135660552062954360070000009995621082297555634_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.0228,
    y1: 243.8084,
    x2: 903.7844,
    y2: 243.8084,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000135660552062954360070000009995621082297555634_)",
      enableBackground: "new"
    },
    d: " M877,485.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C876.2,484.1,876.6,484.6,877,485.1z M884.3,489.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C884.9,489.3,884.6,489.3,884.3,489.2z M888.4,489.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C889.1,489.9,888.7,489.9,888.4,489.7z  M886.4,489.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C887,489.7,886.6,489.6,886.4,489.6z M878.1,486.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V487C878.8,486.8,878.4,486.5,878.1,486.2z M882.2,488.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C882.8,488.8,882.6,488.7,882.2,488.7 z M880.1,487.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C880.8,488,880.5,487.9,880.1,487.7z M890.4,489.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C891.1,489.7,890.8,489.9,890.4,489.9z M900.7,486.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C901.4,486.4,901.1,486.6,900.7,486.9z  M892.5,489.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C893.1,489.6,892.9,489.7,892.5,489.7z M902.7,485v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C903.6,483.9,903.2,484.5,902.7,485z M898.7,488v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C899.4,487.7,899,487.9,898.7,488z  M896.7,488.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C897.3,488.7,896.9,488.7,896.7,488.8z M894.6,489.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C895.3,489.2,894.9,489.3,894.6,489.3z"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M899.9,475.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C885.3,472.7,894.4,472.7,899.9,475.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019657124422281258190000010332722505770883506_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.9458,
    y1: 250.3088,
    x2: 902.7968,
    y2: 250.3088,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019657124422281258190000010332722505770883506_)"
    },
    d: "M899,476.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C885.8,473.5,893.9,473.5,899,476.3z"
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M880.9,477.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C876.5,482.2,877.4,479.2,880.9,477.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112614557377000501320000018116563968087783559_",
    gradientUnits: "userSpaceOnUse",
    x1: 886.3262,
    y1: 222.2754,
    x2: 914.738,
    y2: 222.2754,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112614557377000501320000018116563968087783559_)"
    },
    d: "M906.4,500.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C914.7,505.1,911.8,502.2,906.4,500.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010296380965037748290000006884635803499071403_",
    gradientUnits: "userSpaceOnUse",
    x1: 886.677,
    y1: 217.2647,
    x2: 914.4388,
    y2: 217.2647,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000010296380965037748290000006884635803499071403_)",
      enableBackground: "new"
    },
    d: " M887.7,511.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C886.9,510.6,887.3,511.1,887.7,511.7z M894.9,515.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V516C895.6,515.9,895.3,515.8,894.9,515.8z M899.1,516.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C899.8,516.4,899.4,516.3,899.1,516.3z  M896.9,516.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C897.6,516.3,897.3,516.2,896.9,516.2z M888.8,512.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C889.3,513.3,889.1,513,888.8,512.8z M892.9,515.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C893.5,515.3,893.1,515.2,892.9,515.1z  M890.8,514.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C891.5,514.5,891.1,514.4,890.8,514.1z M901.1,516.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C901.8,516.3,901.4,516.3,901.1,516.4z M911.4,513.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C912.1,512.9,911.7,513.2,911.4,513.4z  M903.2,516.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C903.8,516.2,903.6,516.2,903.2,516.3z M913.4,511.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C914.3,510.3,913.9,511,913.4,511.6z M909.4,514.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V514C910.1,514.3,909.7,514.4,909.4,514.5z  M907.2,515.3v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C907.9,515.2,907.6,515.2,907.2,515.3z M905.2,515.9v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C905.9,515.8,905.6,515.9,905.2,515.9z"
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M910.5,502.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C896,499.2,904.9,499.2,910.5,502.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102540353640526493810000008096186412610095520_",
    gradientUnits: "userSpaceOnUse",
    x1: 887.6002,
    y1: 223.7652,
    x2: 913.4512,
    y2: 223.7652,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102540353640526493810000008096186412610095520_)"
    },
    d: "M909.7,502.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C896.4,500,904.6,500,909.7,502.9z"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M891.6,503.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C887,508.7,888,505.7,891.6,503.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005963248550286031180000015044270683816470163_",
    gradientUnits: "userSpaceOnUse",
    x1: 885.8213,
    y1: 226.0673,
    x2: 914.2331,
    y2: 226.0673,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005963248550286031180000015044270683816470163_)"
    },
    d: "M905.9,496.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C914.1,501.4,911.4,498.6,905.9,496.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042007475546709634330000004071499152148962190_",
    gradientUnits: "userSpaceOnUse",
    x1: 886.1618,
    y1: 221.0566,
    x2: 913.9235,
    y2: 221.0566,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000042007475546709634330000004071499152148962190_)",
      enableBackground: "new"
    },
    d: " M887.2,507.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C886.4,506.8,886.8,507.4,887.2,507.9z M894.4,512v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C895,512.1,894.8,512.1,894.4,512z M898.6,512.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C899.2,512.6,898.8,512.6,898.6,512.6z  M896.5,512.4v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C897.2,512.5,896.8,512.5,896.5,512.4z M888.3,509.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C888.9,509.5,888.5,509.4,888.3,509.1z M892.3,511.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C893,511.6,892.7,511.6,892.3,511.4z  M890.3,510.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5V511C891,510.7,890.6,510.6,890.3,510.5z M900.6,512.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C901.3,512.6,901,512.6,900.6,512.6z M910.9,509.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C911.6,509.3,911.1,509.4,910.9,509.7z  M902.6,512.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C903.3,512.4,903,512.5,902.6,512.5z M912.9,507.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C913.7,506.7,913.3,507.2,912.9,507.8z M908.8,510.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C909.5,510.5,909.1,510.6,908.8,510.9z  M906.8,511.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C907.5,511.4,907.1,511.6,906.8,511.7z M904.6,512.2v3.1 c0.3-0.1,0.7-0.1,0.9-0.3V512C905.3,512.1,905.1,512.1,904.6,512.2z"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M910.1,498.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C895.4,495.4,904.5,495.4,910.1,498.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104694203648071924880000014500548238997551232_",
    gradientUnits: "userSpaceOnUse",
    x1: 887.085,
    y1: 227.4725,
    x2: 912.9358,
    y2: 227.4725,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104694203648071924880000014500548238997551232_)"
    },
    d: "M909.1,499.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C895.8,496.2,904.1,496.2,909.1,499.2z"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M891.1,499.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C886.6,505.1,887.6,501.9,891.1,499.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040567438576034369200000000837832554799228332_",
    gradientUnits: "userSpaceOnUse",
    x1: 778.9694,
    y1: 250.4442,
    x2: 807.3812,
    y2: 250.4442,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040567438576034369200000000837832554799228332_)"
    },
    d: "M799,472.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C807.3,476.9,804.6,474,799,472.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037661744851630530630000002431000449937892799_",
    gradientUnits: "userSpaceOnUse",
    x1: 779.3063,
    y1: 245.5689,
    x2: 807.0679,
    y2: 245.5689,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000037661744851630530630000002431000449937892799_)",
      enableBackground: "new"
    },
    d: " M780.3,483.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C779.5,482.3,779.9,482.8,780.3,483.4z M787.5,487.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C788.2,487.7,787.9,487.6,787.5,487.6z M791.7,488.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C792.4,488.1,792,488.1,791.7,488.1z  M789.7,487.9v3.1c0.3,0,0.7,0.1,0.9,0.1V488C790.3,488,789.9,488,789.7,487.9z M781.4,484.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C782.1,485,781.7,484.9,781.4,484.6z M785.5,486.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C786.1,487,785.9,487,785.5,486.9z  M783.4,486v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C784.1,486.2,783.7,486.1,783.4,486z M793.7,488.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C794.4,488.1,794.1,488.1,793.7,488.1z M804,485.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C804.7,484.7,804.3,484.9,804,485.1z  M795.8,488v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C796.4,487.9,796.2,488,795.8,488z M806.1,483.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C806.9,482.2,806.5,482.7,806.1,483.2z M802,486.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C802.7,486.1,802.3,486.2,802,486.4z  M800,487.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C800.6,486.9,800.2,487,800,487.2z M797.8,487.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C798.5,487.6,798.2,487.6,797.8,487.7z"
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M803.2,474.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C788.6,471.1,797.7,470.9,803.2,474.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048494768082354675090000001184553381570636945_",
    gradientUnits: "userSpaceOnUse",
    x1: 780.2294,
    y1: 251.9598,
    x2: 806.0804,
    y2: 251.9598,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048494768082354675090000001184553381570636945_)"
    },
    d: "M802.3,474.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C789,471.9,797.3,471.7,802.3,474.7z"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M784.3,475.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C779.8,480.5,780.7,477.6,784.3,475.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030447981465738637310000017556960417774333630_",
    gradientUnits: "userSpaceOnUse",
    x1: 809.5389,
    y1: 447.0842,
    x2: 837.9507,
    y2: 447.0842,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030447981465738637310000017556960417774333630_)"
    },
    d: "M829.6,275.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C837.9,280.4,835,277.5,829.6,275.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008127105622213674090000001742536148861138323_",
    gradientUnits: "userSpaceOnUse",
    x1: 809.89,
    y1: 442.0735,
    x2: 837.6516,
    y2: 442.0735,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000008127105622213674090000001742536148861138323_)",
      enableBackground: "new"
    },
    d: " M810.9,286.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C810.1,285.8,810.5,286.3,810.9,286.9z M818.1,291.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C818.8,291.2,818.5,291.1,818.1,291.1z M822.3,291.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C823,291.6,822.6,291.6,822.3,291.6z  M820.1,291.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C820.8,291.5,820.5,291.5,820.1,291.3z M812,288.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C812.6,288.5,812.3,288.4,812,288.1z M816.1,290.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C816.8,290.5,816.3,290.5,816.1,290.4z  M814,289.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5V290C814.7,289.7,814.3,289.6,814,289.5z M824.3,291.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C825,291.6,824.6,291.6,824.3,291.6z M834.6,288.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C835.3,288.2,834.9,288.4,834.6,288.6z  M826.4,291.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C827,291.3,826.8,291.5,826.4,291.5z M836.7,286.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C837.5,285.7,837.1,286.2,836.7,286.7z M832.6,289.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C833.3,289.6,832.9,289.7,832.6,289.9z  M830.4,290.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C831.1,290.4,830.8,290.5,830.4,290.7z M828.4,291.2v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C829.1,291.1,828.8,291.1,828.4,291.2z"
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M833.7,277.7c5.6,3.1,5.6,8.4,0,11.6s-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C819.2,274.6,828.1,274.4,833.7,277.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062887287281492983560000007775464339952752562_",
    gradientUnits: "userSpaceOnUse",
    x1: 810.8129,
    y1: 448.4644,
    x2: 836.6639,
    y2: 448.4644,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062887287281492983560000007775464339952752562_)"
    },
    d: "M832.9,278.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C819.6,275.4,827.9,275.2,832.9,278.2z"
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M814.9,278.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C810.3,284,811.2,281.1,814.9,278.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020381372359283121300000009686676023694641795_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.5753,
    y1: 57.7316,
    x2: 805.9871,
    y2: 57.7316,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020381372359283121300000009686676023694641795_)"
    },
    d: "M797.7,665.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C805.9,669.7,803.1,666.8,797.7,665.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180353916823744382850000002928667710184392334_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.9261,
    y1: 52.7209,
    x2: 805.6879,
    y2: 52.7209,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000180353916823744382850000002928667710184392334_)",
      enableBackground: "new"
    },
    d: " M779,676.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C778.2,675.1,778.4,675.7,779,676.2z M786.1,680.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C786.8,680.4,786.6,680.4,786.1,680.3z M790.3,681v3.3c0.3,0,0.7,0,0.9,0V681C791,681,790.6,681,790.3,681z M788.2,680.7v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C788.9,680.8,788.6,680.7,788.2,680.7z M780.1,677.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C780.6,677.9,780.3,677.6,780.1,677.5z M784.1,679.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3V680C784.8,679.9,784.4,679.9,784.1,679.8z  M782.1,678.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C782.8,679.1,782.4,678.9,782.1,678.8z M792.4,681v3.3c0.3,0,0.7,0,0.9,0V681 C793.1,681,792.6,681,792.4,681z M802.7,678v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C803.3,677.6,802.9,677.7,802.7,678z M794.4,680.8 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C795.1,680.7,794.8,680.8,794.4,680.8z M804.7,676.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C805.5,675,805.1,675.6,804.7,676.1z M800.6,679.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C801.3,678.8,800.9,678.9,800.6,679.2z  M798.5,679.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C799.1,679.8,798.9,679.9,798.5,679.9z M796.4,680.4v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C797.1,680.3,796.8,680.4,796.4,680.4z"
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M801.7,667c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C787.2,663.8,796.2,663.8,801.7,667z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076568875284124284940000002887691918975661460_",
    gradientUnits: "userSpaceOnUse",
    x1: 778.8493,
    y1: 59.2214,
    x2: 804.7002,
    y2: 59.2214,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076568875284124284940000002887691918975661460_)"
    },
    d: "M800.9,667.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C787.6,664.6,795.9,664.6,800.9,667.4z"
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M782.9,668.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C778.3,673.3,779.2,670.3,782.9,668.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182522858479728236000000009689560988424042149_",
    gradientUnits: "userSpaceOnUse",
    x1: 761.1651,
    y1: 9.5196,
    x2: 789.5771,
    y2: 9.5196,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182522858479728236000000009689560988424042149_)"
    },
    d: "M781.3,713.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C789.5,717.9,786.7,715,781.3,713.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049908675055825353220000010548028822538263215_",
    gradientUnits: "userSpaceOnUse",
    x1: 761.5161,
    y1: 4.5089,
    x2: 789.2778,
    y2: 4.5089,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000049908675055825353220000010548028822538263215_)",
      enableBackground: "new"
    },
    d: " M762.6,724.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C761.8,723.4,762,723.9,762.6,724.4z M769.8,728.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C770.4,728.6,770.2,728.6,769.8,728.5z M773.8,729v3.3c0.3,0,0.7,0,0.9,0V729C774.5,729.2,774.2,729,773.8,729z  M771.8,728.9v3.1c0.3,0,0.7,0.1,0.9,0.1V729C772.5,729,772.2,728.9,771.8,728.9z M763.5,725.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C764.2,726.1,763.9,725.8,763.5,725.5z M767.7,727.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C768.4,728.1,768,728,767.7,727.8z  M765.7,727v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C766.4,727.3,766,727.2,765.7,727z M776,729.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C776.7,729,776.3,729.2,776,729.2z M786.3,726.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C787,725.7,786.6,725.9,786.3,726.2z M778,729 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C778.7,728.9,778.3,728.9,778,729z M788.3,724.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C789.1,723.1,788.7,723.8,788.3,724.3z M784.1,727.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C784.8,727,784.5,727.2,784.1,727.3z  M782.1,728.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C782.8,728,782.5,728,782.1,728.1z M780.1,728.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C780.7,728.5,780.5,728.6,780.1,728.6z"
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M785.3,715.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 S779.8,712,785.3,715.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132783684025083571630000000976586010639075734_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.4301,
    y1: 11.0093,
    x2: 788.2811,
    y2: 11.0093,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132783684025083571630000000976586010639075734_)"
    },
    d: "M784.5,715.6c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C771.2,712.8,779.4,712.8,784.5,715.6z"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M766.5,716.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C761.9,721.5,762.9,718.5,766.5,716.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072988744336794665730000011637447933242421385_",
    gradientUnits: "userSpaceOnUse",
    x1: 850.5253,
    y1: 12.2282,
    x2: 878.9372,
    y2: 12.2282,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072988744336794665730000011637447933242421385_)"
    },
    d: "M870.7,710.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C878.8,715.2,876.1,712.3,870.7,710.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171685022004315215370000016168109489069692803_",
    gradientUnits: "userSpaceOnUse",
    x1: 850.881,
    y1: 7.2174,
    x2: 878.6437,
    y2: 7.2174,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000171685022004315215370000016168109489069692803_)",
      enableBackground: "new"
    },
    d: " M851.8,721.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C851.2,720.7,851.4,721.2,851.8,721.7z M859.1,725.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C859.8,725.9,859.4,725.9,859.1,725.8z M863.2,726.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C863.9,726.5,863.6,726.5,863.2,726.3z  M861.2,726.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C861.9,726.3,861.6,726.2,861.2,726.2z M852.9,722.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C853.6,723.4,853.2,723.1,852.9,722.8z M857.1,725.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C857.8,725.4,857.4,725.3,857.1,725.1z M854.9,724.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C855.6,724.6,855.4,724.4,854.9,724.3z  M865.4,726.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C865.9,726.3,865.6,726.5,865.4,726.5z M875.5,723.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C876.3,723,875.9,723.2,875.5,723.5z M867.4,726.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C868.1,726.2,867.7,726.3,867.4,726.3z  M877.7,721.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C878.4,720.4,878.1,721.1,877.7,721.6z M873.5,724.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5 V724C874.2,724.3,873.9,724.4,873.5,724.6z M871.5,725.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C872.1,725.3,871.9,725.3,871.5,725.4 z M869.4,725.9v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C870.1,725.8,869.7,725.9,869.4,725.9z"
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M874.7,712.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C860.2,709.3,869.2,709.3,874.7,712.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005239681910610672470000003566834716119494581_",
    gradientUnits: "userSpaceOnUse",
    x1: 851.812,
    y1: 13.7179,
    x2: 877.6628,
    y2: 13.7179,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005239681910610672470000003566834716119494581_)"
    },
    d: "M873.9,712.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C860.6,710.1,868.8,710.1,873.9,712.9z"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M855.8,713.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C851.3,718.8,852.2,715.8,855.8,713.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033326743206533133230000013156132303946410886_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.1145,
    y1: 502.3385,
    x2: 661.5265,
    y2: 502.3385,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033326743206533133230000013156132303946410886_)"
    },
    d: "M653.2,220.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C661.4,225.1,658.7,222.3,653.2,220.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183952796166340597430000010524553983010610093_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.4562,
    y1: 497.3277,
    x2: 661.2178,
    y2: 497.3277,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000183952796166340597430000010524553983010610093_)",
      enableBackground: "new"
    },
    d: " M634.5,231.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C633.7,230.5,634.1,231.1,634.5,231.6z M641.6,235.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V236C642.3,235.8,642.1,235.8,641.6,235.7z M645.8,236.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C646.5,236.4,646.1,236.4,645.8,236.4z  M643.8,236.1v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C644.5,236.2,644.1,236.2,643.8,236.1z M635.6,232.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C636.2,233.3,635.8,233.1,635.6,232.8z M639.6,235.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C640.3,235.3,640,235.3,639.6,235.1z  M637.6,234.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C638.3,234.5,637.9,234.3,637.6,234.2z M647.9,236.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C648.6,236.4,648.3,236.4,647.9,236.4z M658.2,233.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C658.8,233,658.4,233.1,658.2,233.4z  M649.9,236.2v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C650.6,236.1,650.3,236.2,649.9,236.2z M660.2,231.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C661,230.4,660.6,230.9,660.2,231.5z M656.1,234.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C656.8,234.2,656.4,234.5,656.1,234.6z  M654.1,235.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C654.8,235.1,654.4,235.3,654.1,235.4z M651.9,236v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C652.6,235.8,652.3,235.8,651.9,236z"
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M657.4,222.4c5.6,3.1,5.6,8.4,0,11.6s-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C642.7,219.3,651.8,219.2,657.4,222.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083769695773439701330000004223671130962769577_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.3794,
    y1: 503.7435,
    x2: 660.2302,
    y2: 503.7435,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083769695773439701330000004223671130962769577_)"
    },
    d: "M656.4,223c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C643.1,220,651.4,220,656.4,223z"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M638.4,223.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C633.9,228.8,634.9,225.7,638.4,223.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035499287806310599240000015154740786947578783_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.3989,
    y1: 19.4058,
    x2: 469.8108,
    y2: 19.4058,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035499287806310599240000015154740786947578783_)"
    },
    d: "M461.5,703.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C469.7,708.1,466.9,705.1,461.5,703.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124840973477865754610000017064878767873074304_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.7561,
    y1: 14.3951,
    x2: 469.5187,
    y2: 14.3951,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000124840973477865754610000017064878767873074304_)",
      enableBackground: "new"
    },
    d: " M442.7,714.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C442,713.5,442.3,714,442.7,714.6z M450,718.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C450.7,718.8,450.3,718.6,450,718.6z M454.1,719.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C454.8,719.3,454.5,719.2,454.1,719.2z M452,719 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C452.7,719.2,452.5,719,452,719z M443.8,715.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C444.5,716.2,444.1,715.9,443.8,715.6z M448,717.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C448.7,718.2,448.3,718.1,448,717.9z  M445.8,717v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C446.5,717.4,446.2,717.3,445.8,717z M456.2,719.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C456.8,719.2,456.5,719.2,456.2,719.3z M466.4,716.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C467.2,715.8,466.8,716,466.4,716.3z  M458.3,719.2v3.1c0.3,0,0.7-0.1,0.9-0.1V719C459,719,458.5,719,458.3,719.2z M468.6,714.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C469.2,713.2,469,713.9,468.6,714.4z M464.4,717.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C465,717.1,464.8,717.3,464.4,717.4z  M462.3,718.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C463,718.1,462.7,718.1,462.3,718.2z M460.3,718.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C461,718.6,460.6,718.8,460.3,718.8z"
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M465.6,705.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C451.1,702.1,460,702.1,465.6,705.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178200163370709687640000013705621079900864678_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.687,
    y1: 20.8955,
    x2: 468.538,
    y2: 20.8955,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178200163370709687640000013705621079900864678_)"
    },
    d: "M464.8,705.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C451.5,702.9,459.6,702.9,464.8,705.8z"
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M446.6,706.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C442.2,711.6,443.1,708.6,446.6,706.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179626885592055446600000012153859900369354160_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.8738,
    y1: -3.4814,
    x2: 430.2858,
    y2: -3.4814,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179626885592055446600000012153859900369354160_)"
    },
    d: "M422,726.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C430.2,730.8,427.4,728,422,726.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095338192815223910450000012280361265623320252_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.2249,
    y1: -8.4921,
    x2: 429.9865,
    y2: -8.4921,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000095338192815223910450000012280361265623320252_)",
      enableBackground: "new"
    },
    d: " M403.3,737.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C402.5,736.4,402.8,736.9,403.3,737.4z M410.5,741.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C411.1,741.6,410.7,741.5,410.5,741.5z M414.5,742v3.3c0.3,0,0.7,0,0.9,0V742C415.2,742.2,414.9,742,414.5,742z  M412.5,741.9v3.1c0.3,0,0.7,0.1,0.9,0.1V742C413.2,742,412.9,741.9,412.5,741.9z M404.2,738.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C404.9,739.1,404.6,738.8,404.2,738.5z M408.4,740.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C409.1,741.1,408.7,741,408.4,740.8z  M406.4,739.9v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C407.1,740.3,406.7,740.2,406.4,739.9z M416.7,742.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C417.4,742,417,742,416.7,742.2z M427,739.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C427.7,738.7,427.3,738.9,427,739.2z M418.7,742 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C419.4,741.9,419,741.9,418.7,742z M429,737.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C429.7,736.1,429.4,736.8,429,737.3z M424.8,740.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C425.5,740,425.2,740.2,424.8,740.3z  M422.8,741.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C423.5,741,423.2,741,422.8,741.1z M420.8,741.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C421.4,741.5,421.2,741.6,420.8,741.6z"
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M426,728.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C411.6,725,420.5,725,426,728.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008115694720869973450000004753016537536544935_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.1423,
    y1: -1.9917,
    x2: 428.9933,
    y2: -1.9917,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008115694720869973450000004753016537536544935_)"
    },
    d: "M425.2,728.6c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C412,725.8,420.1,725.8,425.2,728.6z"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M407.2,729.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C402.6,734.5,403.6,731.5,407.2,729.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069370393870994886530000004574412877594172066_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.2067,
    y1: 649.4122,
    x2: 364.6184,
    y2: 649.4122,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069370393870994886530000004574412877594172066_)"
    },
    d: "M356.3,73.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C364.6,78.1,361.7,75.2,356.3,73.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162327255772293784780000009055388370034187193_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.5577,
    y1: 644.4014,
    x2: 364.3193,
    y2: 644.4014,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000162327255772293784780000009055388370034187193_)",
      enableBackground: "new"
    },
    d: " M337.6,84.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C336.8,83.5,337.1,84,337.6,84.6z M344.8,88.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C345.5,88.7,345.2,88.7,344.8,88.6z M349,89.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C349.5,89.3,349.3,89.3,349,89.3z M346.8,89v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C347.5,89.2,347.2,89.2,346.8,89z M338.6,85.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C339.2,86.2,339,86,338.6,85.8z M342.8,88.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C343.4,88.2,343,88.2,342.8,88.1z M340.7,87.1v3.1 c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C341.4,87.4,341,87.3,340.7,87.1z M351,89.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C351.7,89.3,351.3,89.3,351,89.3z M361.3,86.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C362,85.9,361.6,86,361.3,86.3z M353.1,89.2v3.1 c0.3,0,0.7-0.1,0.9-0.1V89C353.7,89,353.3,89.2,353.1,89.2z M363.3,84.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C364.2,83.3,363.8,83.9,363.3,84.4z M359.1,87.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V87C360,87.1,359.6,87.4,359.1,87.5z M357.1,88.3 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C357.8,88.1,357.5,88.2,357.1,88.3z M355.1,88.9V92c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C355.8,88.7,355.5,88.7,355.1,88.9z"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M360.4,75.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C345.9,72.2,354.8,72.1,360.4,75.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091718560723650173330000001482700618350684822_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.4603,
    y1: 650.8173,
    x2: 363.3111,
    y2: 650.8173,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091718560723650173330000001482700618350684822_)"
    },
    d: "M359.6,75.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C346.3,72.9,354.4,72.9,359.6,75.9z"
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M341.5,76.6c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C336.9,81.7,337.9,78.6,341.5,76.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173883826554791555580000000011879515270542768_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.0786,
    y1: 631.265,
    x2: 361.4905,
    y2: 631.265,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173883826554791555580000000011879515270542768_)"
    },
    d: "M353.2,91.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C361.4,96.2,358.6,93.4,353.2,91.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178911694945905552970000018397020232130053563_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.4295,
    y1: 626.2542,
    x2: 361.191,
    y2: 626.2542,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000178911694945905552970000018397020232130053563_)",
      enableBackground: "new"
    },
    d: " M334.5,102.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C333.7,101.6,334,102.2,334.5,102.7z M341.7,106.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V107C342.4,106.9,341.9,106.9,341.7,106.8z M345.7,107.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C346.4,107.4,346.1,107.4,345.7,107.4z  M343.7,107.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C344.4,107.3,344.1,107.3,343.7,107.2z M335.4,103.9v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C336.1,104.3,335.9,104.2,335.4,103.9z M339.6,106.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C340.3,106.4,339.9,106.4,339.6,106.2z M337.6,105.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C338.3,105.5,337.9,105.4,337.6,105.3z  M347.9,107.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C348.6,107.4,348.2,107.4,347.9,107.4z M358.2,104.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C358.9,104.1,358.5,104.2,358.2,104.5z M349.9,107.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C350.6,107.2,350.2,107.3,349.9,107.3z  M360.2,102.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C360.9,101.5,360.6,102,360.2,102.6z M356,105.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1 C356.7,105.3,356.4,105.5,356,105.7z M354,106.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C354.7,106.2,354.4,106.4,354,106.5z M352,107 v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C352.6,106.9,352.4,106.9,352,107z"
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M357.2,93.5c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C342.8,90.4,351.7,90.2,357.2,93.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018230962134196482350000014085796161947223212_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.3455,
    y1: 632.67,
    x2: 360.1964,
    y2: 632.67,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018230962134196482350000014085796161947223212_)"
    },
    d: "M356.4,94c5,2.8,5.1,7.6,0,10.6 c-5.1,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C343.2,91.1,351.3,91.1,356.4,94z"
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M338.4,94.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C333.8,99.9,334.8,96.7,338.4,94.7z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x33__2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1042.4,613.1c-0.7-1.5-1.6-3-2.7-4.2c-0.9-1.1-1.9-1.9-3-2.6c-16-9.2-82.5-47.7-95.9-55.4 c-1.9-1.1-3.7-1.2-4.9-0.5l-4.5,2.8c1.2-0.7,3-0.7,4.9,0.5c13.4,7.7,79.9,46,95.9,55.4c1.1,0.7,2,1.5,3,2.6 c1.1,1.2,2,2.7,2.7,4.2c0.8,1.8,1.2,3.5,1.2,5.1l4.5-2.8C1043.6,616.6,1043.1,614.7,1042.4,613.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1039.7,608.9l-4.5,2.8c1.1,1.2,2,2.7,2.7,4.2l4.5-2.8C1041.7,611.6,1040.7,610.1,1039.7,608.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.2,609.2c-16-9.2-82.5-47.7-95.9-55.4c-3.8-2.2-6.9-0.4-6.9,3.9v6.2c0,4.3,3,9.6,6.8,11.8 c16.1,9.3,82.6,47.7,96,55.4l6.9-3.9V621C1039.1,616.6,1036,611.4,1032.2,609.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M977.9,656.3v6.2c0,2.2-0.8,3.7-2,4.5l58.4-33.9c1.2-0.7,2-2.3,2-4.5v-6.2L977.9,656.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1035.1,617.3c-0.7-1.5-1.6-3-2.7-4.2c-0.9-1.1-1.9-1.9-3-2.6c-16-9.2-94.5-54.6-107.8-62.3 c-1.9-1.1-3.7-1.2-4.9-0.5l-58.4,33.9c1.2-0.7,3-0.7,4.9,0.5c13.4,7.7,91.8,53.1,107.8,62.3c1.1,0.7,2,1.5,3,2.6 c1.1,1.2,2,2.7,2.7,4.2c0.8,1.8,1.2,3.5,1.2,5.1l58.4-33.9C1036.3,620.7,1035.9,618.9,1035.1,617.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1032.5,613.1L974.1,647c1.1,1.2,2,2.7,2.7,4.2l58.4-33.9C1034.4,615.8,1033.6,614.3,1032.5,613.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.1,644.5c3.8,2.2,6.8,7.4,6.8,11.8v6.2c0,4.3-3.1,6.1-6.9,3.9c-13.4-7.7-91.8-53.1-107.8-62.3 c-3.8-2.2-6.8-7.4-6.8-11.8v-6.2c0-4.3,3.1-6.1,6.9-3.9C876.6,590,955.2,635.3,971.1,644.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "965.3,579.7 918.6,606.6 883.4,586.2 930.1,559.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "930.1,561.8 963.2,580.9 965.3,579.7 930.1,559.2 883.4,586.2 885.6,587.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M979.8,594.3l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C981,593.2,980.6,593.8,979.8,594.3 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M979.8,590.8c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L979.8,590.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M963.7,603.6l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C964.9,602.6,964.5,603.1,963.7,603.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M963.7,600.1c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L963.7,600.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M947.6,613l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C948.8,611.9,948.4,612.4,947.6,613 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M947.6,609.5c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L947.6,609.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M991,600.8l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8V599C992.3,599.7,991.9,600.3,991,600.8z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M991,597.3c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L991,597.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M974.9,610.1l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C976.2,608.9,975.7,609.6,974.9,610.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M974.9,606.6c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L974.9,606.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M958.8,619.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C960,618.4,959.6,618.9,958.8,619.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M958.8,616c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L958.8,616z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M1002.3,607.3l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C1003.5,606.2,1003.1,606.8,1002.3,607.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1002.3,603.8c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L1002.3,603.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M986.2,616.6l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C987.4,615.4,987,616.1,986.2,616.6 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M986.2,613.1c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L986.2,613.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M970.1,626l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C971.3,624.9,970.9,625.4,970.1,626 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M970.1,622.5c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L970.1,622.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M1013.5,613.8l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8V612 C1014.7,612.6,1014.3,613.3,1013.5,613.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1013.5,610.3c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L1013.5,610.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M997.4,623l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C998.6,621.9,998.2,622.6,997.4,623 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M997.4,619.6c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L997.4,619.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M981.3,632.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C982.5,631.3,982.1,631.9,981.3,632.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M981.3,629c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L981.3,629z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M931.9,605.8c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L931.9,605.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M932.5,607.8v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C932.3,608.5,932.5,608.2,932.5,607.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M944.5,598.6c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L944.5,598.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M945,600.7v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5C944.9,601.3,945,600.9,945,600.7 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M956.9,591.5c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L956.9,591.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M957.6,593.5v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C957.3,594,957.6,593.8,957.6,593.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M969.4,584.1c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L969.4,584.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M970.1,586.2v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C969.9,586.9,970.1,586.6,970.1,586.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1030.1,629.1 985.6,654.7 985.6,657.4 1030.1,631.8  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1030.3,635.7l-37.5,21.8c-1.9,1.1-5,1.1-7,0v0.9c1.9,1.1,5.1,1.1,7,0l37.5-21.8c0.9-0.5,1.5-1.2,1.5-2 v-0.9C1031.7,634.4,1031.3,635.2,1030.3,635.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1030.2,631.7c1.9,1.1,1.9,3,0,4.1l-37.5,21.8c-1.9,1.1-5,1.1-7,0L1030.2,631.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1034.4,623.6v6.2c0,2.2-0.8,3.7-2,4.5l9.2-5.3c1.2-0.7,2-2.3,2-4.5v-6.2L1034.4,623.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x39__1_"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube_5_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_left_308_",
    points: "887,209.6 910.9,223.4 910.9,343.6 887,329.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_right_314_",
    className: "st1",
    points: "955,318.2 910.9,343.6 910.9,223.4 955,197.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_top_308_",
    className: "st1",
    points: "910.9,223.4 887,209.6 931.2,184.1 955,197.8  "
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_left_240_",
    className: "st192",
    points: "910.9,343.6 921.2,349.6 921.2,274.4 910.9,268.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_right_246_",
    className: "st193",
    points: "969.5,321.7 921.2,349.6 921.2,274.4 969.5,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_top_240_",
    className: "st194",
    points: "921.2,274.4 910.9,268.3 959.2,240.4 969.5,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st195",
    points: "968.3,245.7 959.2,240.4 910.9,268.3 919.9,273.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x34__2_"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x35__1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st193",
    points: "914.3,191 962.5,163.1 969.4,243 921.2,271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "904.2,185.2 952.3,157.3 962.5,163.1 914.3,191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "911.1,265.2 921.2,271 914.3,191 904.2,185.2 904.2,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "958.4,170.1 919.9,192.5 923.1,230 961.7,207.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "958.4,170.1 957.6,170.5 960.7,207.1 923.1,229.1 923.1,230 961.7,207.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "960.7,207.1 923.1,229.1 923.1,230 961.7,207.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M927.1,200.6c1.6-0.9,3.3-1.5,3.5,0.8v0.3c0.1,0.8-0.3,1.6-0.8,2.3c0.8-0.1,1.4,0.3,1.4,1.2v0.3 c0.1,2.3-1.5,3.8-3.1,4.7l-3.4,2l-0.8-9.6L927.1,200.6z M926,203.1l0.1,2.2l1.2-0.7c0.5-0.3,1.1-0.8,1.1-1.6v-0.1 c0-0.8-0.7-0.7-1.2-0.3L926,203.1z M926.4,206.8l0.1,2.3l1.4-0.8c0.5-0.3,1.2-0.9,1.1-1.8v-0.1c-0.1-0.8-0.7-0.7-1.4-0.4 L926.4,206.8z M936.7,195.1l3.3,8.1l-2.2,1.4l-0.7-1.8l-2.4,1.5l-0.3,2.3l-2.3,1.4l1.8-11.1L936.7,195.1z M935,202.2l1.6-0.9 l-1.1-3.1L935,202.2z M948.4,198.4l-2.2,1.2l-3.8-4.1l0.3,1.9l0.3,4.1l-2,1.1l-0.8-9.6l2.2-1.2l3.8,4.1l-0.3-1.9l-0.3-4.1 l2-1.1L948.4,198.4z M951.4,190.6l2.2-5.1l2.6-1.5l-2.4,5.4l3.3,4.1l-2.3,1.4l-2.2-2.8l-0.8,1.6l0.3,2.7l-2,1.2l-0.8-9.6l2-1.2 L951.4,190.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005269037205382322000000005519788101033036201_",
    gradientUnits: "userSpaceOnUse",
    x1: 937.7853,
    y1: 507.5036,
    x2: 952.8769,
    y2: 481.3641,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4D8D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#D2D5D4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000005269037205382322000000005519788101033036201_)"
    },
    points: "928.8,229.7 961.8,210.6  961.8,245.3 928.9,264.5  "
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "926,228.2 959.1,209 961.8,210.6 928.8,229.7  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "928.8,229.7 928.9,264.5 926,228.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "946.8,244.9 930.5,254.2 930.5,257 946.8,247.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033332591956604490800000005921989329579074995_",
    points: "947.4,244.5 947.4,248.4 930.5,258.3  930.5,254.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151523832996003797190000007258952032490635392_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033332591956604490800000005921989329579074995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151523832996003797190000007258952032490635392_)"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "947.4,244.5 945.3,243.1 945.3,247.2 947.4,248.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "947.4,248.4 930.5,258.3 928.3,257 945.3,247.2  "
  })))))))), /*#__PURE__*/React.createElement("g", null, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "959.5,226.5 948.5,232.8 948.7,235.6 959.5,229.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096757481335299975490000011119695686703913372_",
    points: "960.2,226.1 960.3,230 948.7,236.8  948.5,232.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151532840458491614190000013060166944234682269_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096757481335299975490000011119695686703913372_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151532840458491614190000013060166944234682269_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008113121833184426580000018158120581946826148_",
    gradientUnits: "userSpaceOnUse",
    x1: 960.0391,
    y1: 505.9869,
    x2: 958.3583,
    y2: 503.0761,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#858E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#858E8D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008113121833184426580000018158120581946826148_)"
    },
    points: "960.2,226.1  958.1,224.9 958.1,228.8 960.3,230  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166657188460645206610000005954836136939253438_",
    gradientUnits: "userSpaceOnUse",
    x1: 952.8655,
    y1: 500.1483,
    x2: 953.9116,
    y2: 498.3364,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#497775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000166657188460645206610000005954836136939253438_)"
    },
    points: "960.3,230 948.7,236.8  946.5,235.6 958.1,228.8  "
  }))))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000125588115805090098450000012379253338942211714_",
    points: "960.2,226.1 960.3,230 948.7,236.8  948.5,232.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011716745641649435660000001267024442025764532_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125588115805090098450000012379253338942211714_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011716745641649435660000001267024442025764532_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137126833100582498990000017982186474961402260_",
    points: "960.3,230 948.7,236.8 946.5,235.6  958.1,228.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166635973634360087280000000245910750327010204_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137126833100582498990000017982186474961402260_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000166635973634360087280000000245910750327010204_)",
      fill: "#858E8D",
      enableBackground: "new"
    },
    d: " M960.3,228.1l-13.4,7.7v-0.1L960.3,228.1L960.3,228.1z M960.7,228.2l-13.4,7.7v0.1L960.7,228.2L960.7,228.2z M961.3,228.5 l-13.4,7.7v0.1L961.3,228.5L961.3,228.5z M961.7,228.9l-13.4,7.7v0.1L961.7,228.9L961.7,228.9z"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M948.5,224.4c0-1.9,1.4-4.1,2.8-5l6.4-3.7c0.4-0.3,0.8-0.4,1.1-0.4c0.8,0,1.2,0.7,1.2,1.8v4.9 l-11.6,6.8L948.5,224.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "959,220.2 949.9,225.5 949.9,224.9 959,219.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "958.8,220.1 958.8,219.7 949.9,224.9 949.9,225.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M959.1,217c0,0.3-0.3,0.7-0.5,0.9c-0.3,0.1-0.5,0.1-0.5-0.3c0-0.3,0.3-0.7,0.5-0.9 C958.8,216.6,959.1,216.7,959.1,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M959,217c0,0.3-0.3,0.5-0.4,0.7c-0.3,0.1-0.4,0-0.4-0.1c0-0.3,0.3-0.5,0.4-0.7S959,216.7,959,217z"
  })))))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M913.7,303.8v-42.3l-2.8-1.6V303C911.8,303.3,912.8,303.5,913.7,303.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31__5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M631.8,382.9l-12.1-6.9c-2.2-1.2-5.7-1.2-7.9,0L575,397.3c-1.1,0.7-1.6,1.5-1.6,2.4c0,0.3,0,1.2,0,1.8 c0,0.8,0.4,1.8,1.6,2.4l12.1,6.9c2.2,1.2,5.7,1.2,7.9,0l36.8-21.3c1.1-0.7,1.6-1.5,1.6-2.3c0-0.3,0-1.5,0-1.8 C633.5,384.4,633,383.4,631.8,382.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M594.9,385.7L575,397.3c-1.1,0.7-1.6,1.5-1.6,2.4c0,0.3,0,1.2,0,1.8c0,0.8,0.4,1.8,1.6,2.4l12.1,6.9 c2.2,1.2,5.7,1.2,7.9,0l0,0V385.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M587.1,390.2l-12.1,6.9c-1.1,0.7-1.6,1.5-1.6,2.4c0,0.3,0,1.2,0,1.8c0,0.8,0.4,1.8,1.6,2.4l12.1,6.9l0,0 V390.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.8,387.4l-36.8,21.3c-2.2,1.2-5.7,1.2-7.9,0l-12.1-6.9c-2.2-1.2-2.2-3.3,0-4.5l36.8-21.3 c2.2-1.2,5.7-1.2,7.9,0l12.1,6.9C633.9,384.1,633.9,386.1,631.8,387.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "601.3,382.1 576.9,396.2 594.9,396.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "612,386.3 594.9,396.2 594.9,361.8 612,351.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "594.9,396.2 589.4,392.9 589.4,358.5 594.9,361.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "528.6,413.4 525.9,411.7 525.6,316.8 528.3,318.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "528.3,318.4 525.6,316.8 666.3,235.6 669,237.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "669,237.2 669.3,332.1 528.6,413.4 528.3,318.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "530.2,319.5 667.1,240.4 667.1,327.4 530.2,406.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "590.9,284.4 530.2,319.5 530.2,406.5 590.9,371.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "667.1,322.9 530.2,402 530.2,406.5 667.1,327.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "667.1,240.3 530.2,319.4 530.2,323.7 667.1,244.8  "
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M675.1,395.4l-21.7-12.5c-0.5-0.3-1.5-0.3-2.2,0l-67.6,39c-0.3,0.1-0.4,0.4-0.4,0.5v2.7 c0,0.3,0.1,0.4,0.4,0.7l21.7,12.5c0.5,0.3,1.5,0.3,2.2,0l67.6-39c0.3-0.1,0.4-0.4,0.4-0.7V396 C675.5,395.8,675.4,395.5,675.1,395.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M607.4,408.2l-23.7,13.7c-0.3,0.1-0.4,0.4-0.4,0.5v2.7c0,0.3,0.1,0.4,0.4,0.7l21.7,12.5 c0.5,0.3,1.5,0.3,2,0V408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M605.4,409.3l-21.7,12.5c-0.3,0.1-0.4,0.4-0.4,0.5v2.7c0,0.3,0.1,0.4,0.4,0.7l21.7,12.5V409.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M675.1,396.6l-67.6,39c-0.5,0.3-1.5,0.3-2.2,0l-21.7-12.5c-0.5-0.3-0.5-0.9,0-1.2l67.6-39 c0.5-0.3,1.5-0.3,2.2,0l21.7,12.5C675.6,395.6,675.6,396.2,675.1,396.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M592.6,422.8l-3,1.6c-0.3,0.1-0.7,0.1-1.1,0l-2.4-1.4c-0.3-0.1-0.3-0.4,0-0.5l3-1.6 c0.3-0.1,0.7-0.1,1.1,0l2.4,1.4C592.9,422.4,592.9,422.7,592.6,422.8z M597.4,419.6l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C597.6,420,597.6,419.7,597.4,419.6z M602.1,416.8l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C602.4,417.3,602.4,417,602.1,416.8z M606.7,414l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C607,414.5,607,414.3,606.7,414z M611.4,411.3L609,410c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C611.7,411.7,611.7,411.5,611.4,411.3z M616.2,408.6l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C616.5,409,616.5,408.8,616.2,408.6z M620.9,405.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C621.2,406.3,621.2,406.1,620.9,405.9z M625.7,403.2l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C625.9,403.6,625.9,403.3,625.7,403.2z M630.4,400.5l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C630.7,400.9,630.7,400.6,630.4,400.5z M636.6,396.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6C636.9,397.3,636.9,397,636.6,396.8z M656.8,400.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C657.1,400.5,657.1,400.2,656.8,400.1z M661.6,397.4l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C661.8,397.8,661.8,397.5,661.6,397.4z M666.3,394.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C666.6,395.1,666.6,394.8,666.3,394.7z M661.1,402.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C661.4,403.1,661.4,402.8,661.1,402.7z M665.9,399.8l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C666.2,400.4,666.2,400.1,665.9,399.8z M670.6,397.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C670.9,397.5,670.9,397.3,670.6,397.1z M598.6,423.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6C598.9,424.3,598.9,424.1,598.6,423.8z M603.2,421.1l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C603.5,421.5,603.5,421.2,603.2,421.1z M607.9,418.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C608.2,418.8,608.2,418.5,607.9,418.4z M612.7,415.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C612.9,416.1,612.9,415.8,612.7,415.7z M617.4,413l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C617.7,413.4,617.7,413.1,617.4,413z M622.1,410.3l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C622.4,410.7,622.4,410.4,622.1,410.3z M626.9,407.5l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C627.2,408,627.2,407.7,626.9,407.5z M631.5,404.8l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C631.8,405.2,631.8,405,631.5,404.8z M636.2,402l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C636.5,402.5,636.5,402.3,636.2,402z M641,399.3l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C641.2,399.8,641.2,399.6,641,399.3z M601.2,427.2l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C601.4,427.6,601.4,427.3,601.2,427.2z M605.9,424.5l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C606.2,424.9,606.2,424.6,605.9,424.5z M610.6,421.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C610.9,422.2,610.9,421.9,610.6,421.8z M615.4,419.1l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C615.6,419.5,615.6,419.2,615.4,419.1z M609.7,432.2l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C610,432.6,610,432.3,609.7,432.2z M614.4,429.5l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C614.7,429.9,614.7,429.6,614.4,429.5z M619.2,426.6l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C619.4,427.2,619.4,426.9,619.2,426.6z M623.9,423.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C624.2,424.5,624.2,424.2,623.9,423.9z M653.7,406.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6C654,407.1,654,407,653.7,406.7z M620,416.3l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C620.4,416.8,620.4,416.5,620,416.3z M624.7,413.6l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C625,414,625,413.8,624.7,413.6z M629.5,410.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C629.7,411.3,629.7,411.1,629.5,410.9z M634.2,408.1l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-2.8,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C634.5,408.6,634.5,408.4,634.2,408.1z M638.9,405.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C639.2,405.8,639.2,405.6,638.9,405.4z M645.2,401.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6C645.4,402.3,645.4,402,645.2,401.9z M607.1,428.8l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6 C607.4,429.2,607.4,428.9,607.1,428.8z M611.9,426.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C612.1,426.5,612.1,426.2,611.9,426.1z M616.5,423.4L614,422c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C616.9,423.8,616.9,423.5,616.5,423.4z M621.2,420.7l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C621.5,421.1,621.5,420.8,621.2,420.7z M625.9,417.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C626.2,418.4,626.2,418.1,625.9,417.8z M647.6,410.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-21.8,12.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l21.8-12.6C647.9,410.8,647.9,410.5,647.6,410.4z M630.7,415.1l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C630.9,415.7,630.9,415.4,630.7,415.1z M635.4,412.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C635.7,412.8,635.7,412.6,635.4,412.4z M640.2,409.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C640.4,410.1,640.4,409.8,640.2,409.7z M644.9,407l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C645.2,407.4,645.2,407.1,644.9,407z M649.5,404.3l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C649.8,404.7,649.8,404.4,649.5,404.3z M643.9,392.6l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C644.2,393.1,644.2,392.8,643.9,392.6z M648.7,389.9l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C649,390.3,649,390.1,648.7,389.9z  M653.4,387.2l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C653.7,387.6,653.7,387.4,653.4,387.2z M657.6,389.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C657.9,390.1,657.9,389.8,657.6,389.7z M661.8,392l-2.4-1.4c-0.3-0.1-0.7-0.1-0.8,0l-4.1,2.3 c-0.1,0.1-0.5,0.1-0.7,0l-3.3-1.9c-0.4-0.3-0.9-0.3-1.2,0l-7.4,4.3c-0.4,0.3-0.4,0.5,0,0.7l6.5,3.8c0.4,0.3,0.9,0.3,1.2,0 l12.3-7C662.2,392.5,662.2,392.2,661.8,392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M592.6,422.4l-3,1.6c-0.3,0.1-0.7,0.1-1.1,0l-2.4-1.4c-0.3-0.1-0.3-0.4,0-0.5l3-1.6c0.3-0.1,0.7-0.1,1.1,0 l2.4,1.4C592.9,422,592.9,422.3,592.6,422.4z M597.4,419.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5 l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C597.6,419.6,597.6,419.3,597.4,419.1z M602.1,416.3l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0 l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C602.4,416.8,602.4,416.5,602.1,416.3z M606.7,413.6 l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C607,414,607,413.8,606.7,413.6z M611.4,410.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C611.7,411.3,611.7,411.1,611.4,410.9z M616.2,408.2l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C616.5,408.6,616.5,408.4,616.2,408.2z M620.9,405.5l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C621.2,405.9,621.2,405.6,620.9,405.5z M625.7,402.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C625.9,403.2,625.9,402.9,625.7,402.8z M630.4,400.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C630.7,400.5,630.7,400.2,630.4,400.1z M636.6,396.4l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6 C636.9,396.8,636.9,396.6,636.6,396.4z M656.8,399.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C657.1,400.1,657.1,399.8,656.8,399.7z M661.6,397l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C661.8,397.4,661.8,397.1,661.6,397z M666.3,394.3l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C666.6,394.7,666.6,394.4,666.3,394.3z M661.1,402.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C661.4,402.7,661.4,402.4,661.1,402.1z M665.9,399.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C666.2,399.8,666.2,399.6,665.9,399.4z M670.6,396.7l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C670.9,397.1,670.9,396.8,670.6,396.7z M598.6,423.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6C598.9,423.8,598.9,423.5,598.6,423.4z M603.2,420.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C603.5,421.1,603.5,420.8,603.2,420.7z M607.9,418l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C608.2,418.4,608.2,418.1,607.9,418z M612.7,415.3l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C612.9,415.7,612.9,415.4,612.7,415.3z M617.4,412.6l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C617.7,413,617.7,412.7,617.4,412.6z M622.1,409.8l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C622.4,410.3,622.4,410,622.1,409.8z M626.9,407.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C627.2,407.5,627.2,407.3,626.9,407.1z M631.5,404.3l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C631.8,404.8,631.8,404.6,631.5,404.3z M636.2,401.6l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C636.5,402,636.5,401.7,636.2,401.6z M641,398.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C641.2,399.3,641.2,399,641,398.9z M601.2,426.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C601.4,427.2,601.4,426.9,601.2,426.8z M605.9,424.1l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C606.2,424.5,606.2,424.2,605.9,424.1z M610.6,421.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C610.9,421.8,610.9,421.5,610.6,421.4z M615.4,418.6l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C615.6,419.1,615.6,418.8,615.4,418.6z M609.7,431.8l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C610,432.2,610,431.9,609.7,431.8z  M614.4,428.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C614.7,429.5,614.7,429.2,614.4,428.9z M619.2,426.2l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C619.4,426.6,619.4,426.5,619.2,426.2z M623.9,423.5l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C624.2,423.9,624.2,423.7,623.9,423.5z M653.7,406.3l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6 C654,406.7,654,406.5,653.7,406.3z M620,415.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C620.4,416.3,620.4,416.1,620,415.9z M624.7,413.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C625,413.6,625,413.4,624.7,413.1z M629.5,410.4L627,409 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C629.7,410.9,629.7,410.7,629.5,410.4z M634.2,407.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C634.5,408.1,634.5,407.8,634.2,407.7z M638.9,405l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C639.2,405.4,639.2,405.1,638.9,405z M645.2,401.5l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6 C645.4,401.9,645.4,401.6,645.2,401.5z M607.1,428.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-4.5,2.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l4.5-2.6C607.4,428.8,607.4,428.5,607.1,428.4z M611.9,425.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C612.1,426.1,612.1,425.8,611.9,425.7z M616.5,423l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C616.9,423.4,616.9,423.1,616.5,423z M621.2,420.1l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C621.5,420.7,621.5,420.4,621.2,420.1z M625.9,417.4l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C626.2,417.8,626.2,417.7,625.9,417.4z M647.6,410l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-21.8,12.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l21.8-12.6 C647.9,410.4,647.9,410.1,647.6,410z M630.7,414.7l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C630.9,415.1,630.9,414.9,630.7,414.7z M635.4,412l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C635.7,412.4,635.7,412.1,635.4,412z M640.2,409.3l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C640.4,409.7,640.4,409.4,640.2,409.3z M644.9,406.6l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C645.2,407,645.2,406.7,644.9,406.6z M649.5,403.9l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C649.8,404.3,649.8,404,649.5,403.9z M643.9,392.2l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C644.2,392.6,644.2,392.4,643.9,392.2z M648.7,389.5l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4 c0.3,0.1,0.7,0.1,1.1,0l3-1.6C649,389.9,649,389.7,648.7,389.5z M653.4,386.8l-2.4-1.4c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6 c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6C653.7,387.2,653.7,387,653.4,386.8z M657.6,389.3l-2.4-1.4 c-0.3-0.1-0.7-0.1-1.1,0l-3,1.6c-0.3,0.1-0.3,0.4,0,0.5l2.4,1.4c0.3,0.1,0.7,0.1,1.1,0l3-1.6 C657.9,389.7,657.9,389.4,657.6,389.3z M661.8,391.6l-2.4-1.4c-0.3-0.1-0.7-0.1-0.8,0l-4.1,2.3c-0.1,0.1-0.5,0.1-0.7,0 l-3.3-1.9c-0.4-0.3-0.9-0.3-1.2,0l-7.4,4.3c-0.4,0.3-0.4,0.5,0,0.7l6.5,3.8c0.4,0.3,0.9,0.3,1.2,0l12.3-7 C662.2,392.1,662.2,391.7,661.8,391.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "555.5,357.6 555.5,315.9 577,303.3 577,345.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "555.5,348.9 555.4,327.5 577,315 577,339.2 567.6,344.7 567.6,341.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M575.3,327.1l-7.7-9.5l0.1-0.1L575.3,327.1L575.3,327.1z M576.6,326.3l-7.7-9.5l-0.1,0.1L576.6,326.3 L576.6,326.3z M574.2,327.8l-7.7-9.5l-0.1,0.1L574.2,327.8L574.2,327.8z M573,328.5l-7.7-9.5l-0.1,0.1L573,328.5L573,328.5z  M577,324.8l-7-8.5l-0.1,0.1l7.2,8.7V324.8z M571.8,329.1l-7.7-9.5l-0.1,0.1L571.8,329.1L571.8,329.1z M577,320.3l-4.6-5.6 l-0.1,0.1l4.7,5.7V320.3z M577,313.8l-0.9-1.1l-0.1,0.1l1.1,1.2V313.8z M577,316l-2.2-2.6l-0.1,0.1l2.3,2.7L577,316z  M577,318.2l-3.4-4.1l-0.1,0.1l3.5,4.2V318.2z M577,322.6l-5.8-7l-0.1,0.1l6,7.2L577,322.6z M570.5,329.8l-7.7-9.5l-0.1,0.1 L570.5,329.8L570.5,329.8z M557.1,337.5l-1.8-2.2v0.3L557.1,337.5L557.1,337.5z M559.6,336.2l-4.2-5.1v0.3L559.6,336.2 L559.6,336.2z M560.8,335.5l-5.4-6.6v0.3L560.8,335.5L560.8,335.5z M556.1,338.2l-0.5-0.7v0.3L556.1,338.2L556.1,338.2z  M558.4,336.9l-3-3.7v0.3L558.4,336.9L558.4,336.9z M562,334.7l-6.6-8.1v0.3L562,334.7L562,334.7z M566.9,332l-7.7-9.5 l-0.1,0.1L566.9,332L566.9,332z M568.1,331.3l-7.7-9.5l-0.1,0.1L568.1,331.3L568.1,331.3z M569.3,330.5l-7.7-9.5l-0.1,0.1 L569.3,330.5L569.3,330.5z M564.5,333.3l-7.7-9.5l-0.1,0.1L564.5,333.3L564.5,333.3z M565.7,332.7l-7.7-9.5l-0.1,0.1 L565.7,332.7L565.7,332.7z M563.2,334l-7.7-9.5h-0.1l0,0L563.2,334L563.2,334z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "567.6,348.8 567.6,334.4 577,328.9 577,343.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "555.4,356.4 555.4,341.5 558.5,339.6 558.5,353.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M573.3,331L573.3,331c0-3.9-3.3-5.3-7.2-3.1c-3.9,2.3-7.2,7.3-7.2,11.2l0,0L573.3,331z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "555.4,341.6 555.4,341.1 577,328.6 577,329.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "573,312.6 573,306.7 576.1,304.9 576.1,310.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M573.9,333.7c0-0.4-0.1-0.8-0.4-0.8l0,0l1.4-0.7c0.1-0.1,0.3,0,0.3,0.1v1.9l0.5-0.1V334v-2.4l0,0 l-2.4,1.4l-0.1,0.3c0.4,0.1,0.5,0.3,0.5,0.7c0,0.5-0.4,1.2-1.4,1.8c-0.8,0.4-1.4,0.4-1.4-0.1c0-0.5,0.4-0.9,0.8-1.4 c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1-0.1-0.3-0.4-0.1c-0.4,0.1-0.8,0.9-0.8,2c0,1.2,0.7,1.4,1.6,0.8 C573.5,335.6,573.9,334.7,573.9,333.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M575.8,336.6c0-1.2-1.1-1.1-2.6-0.1c-1.5,0.8-2.6,1.9-2.6,3.1s1.1,1.1,2.6,0.1 C574.7,338.9,575.8,337.8,575.8,336.6z M571,339.4c0-0.7,1.1-1.5,2.3-2.3c1.2-0.7,2.3-1.1,2.3-0.4c0,0.7-1.1,1.5-2.3,2.3 C572,339.7,571,340.1,571,339.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M575.8,340.5c0-1.2-1.1-1.1-2.6-0.1c-1.5,0.8-2.6,1.9-2.6,3.1s1.1,1.1,2.6,0.1 C574.7,342.8,575.8,341.7,575.8,340.5z M571,343.4c0-0.7,1.1-1.5,2.3-2.3c1.2-0.7,2.3-1.1,2.3-0.4c0,0.7-1.1,1.5-2.3,2.3 C572,343.6,571,344,571,343.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M559.3,316.3c0-0.3-0.1-0.5-0.3-0.5l0,0l0.9-0.4c0.1,0,0.1,0,0.1,0v1.2l0.4-0.1l0,0v-1.8l0,0l-1.8,0.9 v0.1c0.3,0.1,0.4,0.3,0.4,0.5c0,0.3-0.3,0.8-0.9,1.2c-0.5,0.3-0.9,0.3-0.9-0.1s0.3-0.7,0.5-0.9c0.1-0.1,0.1-0.1,0.1-0.3 c0-0.1-0.1-0.3-0.3-0.1c-0.3,0.1-0.5,0.7-0.5,1.4c0,0.8,0.5,0.9,1.2,0.5C559,317.6,559.3,316.9,559.3,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M560.7,318.3c0-0.8-0.8-0.7-1.8-0.1c-1.1,0.5-1.8,1.4-1.8,2.2s0.8,0.7,1.8,0.1 C559.8,319.8,560.7,319.1,560.7,318.3z M557.3,320.2c0-0.5,0.8-1.1,1.6-1.5s1.6-0.8,1.6-0.3s-0.8,1.1-1.6,1.5 S557.3,320.7,557.3,320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M560.7,321c0-0.8-0.8-0.7-1.8-0.1c-1.1,0.5-1.8,1.4-1.8,2.2s0.8,0.7,1.8,0.1 C559.8,322.5,560.7,321.8,560.7,321z M557.3,322.9c0-0.5,0.8-1.1,1.6-1.5c0.8-0.5,1.6-0.8,1.6-0.3c0,0.5-0.8,1.1-1.6,1.5 S557.3,323.4,557.3,322.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M571.6,347.1l-0.8-1.1l0.1-0.1l0.8,1.1L571.6,347.1z M571.1,347.4l-0.8-1.1l-0.1,0.1l0.8,1.1 L571.1,347.4z M570.3,347.8l-0.8-1.1l-0.1,0.1l0.8,1.1L570.3,347.8z M569.6,348.2l-0.8-1.1l-0.1,0.1l0.8,1.1L569.6,348.2z  M568.9,348.8l-0.8-1.1l-0.1,0.1l0.8,1.1L568.9,348.8z M568.1,349.2l-0.8-1.1l-0.1,0.1l0.8,1.1L568.1,349.2z M567.4,349.6 l-0.8-1.1l-0.1,0.1l0.8,1.1L567.4,349.6z M566.6,350l-0.8-1.1l-0.1,0.1l0.8,1.1L566.6,350z M565.9,350.4l-0.8-1.1l-0.1,0.1 l0.8,1.1L565.9,350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M575.8,307.9c0-0.7-0.5-0.9-1.4-0.5c-0.7,0.4-1.4,1.4-1.4,2c0,0.7,0.5,0.9,1.4,0.5 C575.3,309.5,575.8,308.5,575.8,307.9z M573.4,309.4c0-0.7,0.5-1.4,1.1-1.8c0.7-0.4,1.1-0.1,1.1,0.5c0,0.7-0.5,1.4-1.1,1.8 C573.9,310.2,573.4,309.9,573.4,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M576,327.4l-0.7,0.7l-0.1,0.8l-0.5-0.3l-0.7,0.5l0.3-0.8l-0.3-0.4l0.7-0.3l0.5-0.8l0.1,0.7L576,327.4z  M574.2,323.7l-0.1-0.7l-0.5,0.8l-0.7,0.3l0.3,0.4l-0.3,0.8l0.7-0.5l0.5,0.3l0.1-0.8l0.7-0.7L574.2,323.7z M571,322.4v-0.7 l-0.5,0.8l-0.7,0.3l0.3,0.4l-0.3,0.8l0.7-0.5l0.5,0.3l0.1-0.8l0.7-0.7L571,322.4z M566.5,323.7l-0.1-0.7l-0.5,0.8l-0.7,0.3 l0.3,0.4l-0.3,0.8l0.7-0.5l0.5,0.3l0.1-0.8l0.7-0.7L566.5,323.7z M562,327.5l-0.1-0.7l-0.5,0.8l-0.7,0.3l0.3,0.4l-0.3,0.8 l0.7-0.5l0.5,0.3l0.1-0.8l0.7-0.7L562,327.5z M558.9,332.5l-0.1-0.7l-0.5,0.8l-0.7,0.3l0.3,0.4l-0.3,0.8l0.7-0.5l0.5,0.3 l0.1-0.8l0.7-0.7L558.9,332.5z M557.7,337.7l-0.1-0.7l-0.5,0.8l-0.7,0.3l0.3,0.4l-0.3,0.8l0.7-0.5l0.5,0.3l0.1-0.8l0.7-0.7 L557.7,337.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "559.2,317.1 542.9,326.6 542.9,367.9 559.2,358.4  "
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M543.3,326.8c0,0,0-0.1,0.1-0.1l15.2-8.7h0.1v40.1c0,0,0,0.1-0.1,0.1l-15.2,8.7h-0.1V326.8z  M556.9,320.7c0-0.5-0.4-0.7-0.9-0.4l-9.8,5.6c-0.5,0.3-0.9,0.9-0.9,1.5v36.8c0,0.5,0.4,0.7,0.9,0.4l9.8-5.6 c0.5-0.3,0.9-0.9,0.9-1.5V320.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M558.6,358.1l-15.2,8.7v-40.1l15.2-8.7V358.1L558.6,358.1z M545.2,327.4v36.8c0,0.5,0.4,0.8,0.9,0.4 l9.8-5.6c0.5-0.3,0.9-1.1,0.9-1.6v-36.8c0-0.5-0.4-0.8-0.9-0.4l-9.8,5.6C545.6,326.2,545.2,326.8,545.2,327.4L545.2,327.4z  M558.8,358v-40.1c0-0.1-0.1-0.1-0.1-0.1l-15.2,8.7c-0.1,0-0.1,0.1-0.1,0.3v40.1c0,0.1,0.1,0.1,0.1,0.1l15.2-8.7 C558.8,358.2,558.8,358.1,558.8,358L558.8,358z M545.4,327.4c0-0.5,0.4-1.1,0.8-1.4l9.8-5.6c0.4-0.3,0.8-0.1,0.8,0.4v36.8 c0,0.5-0.4,1.1-0.8,1.4l-9.8,5.6c-0.4,0.3-0.8,0.1-0.8-0.4V327.4L545.4,327.4z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M557.4,353L557.4,353l1.2-0.8c0.1,0,0.1-0.1,0.1-0.3v-0.1v-0.1c0,0,0,0-0.1-0.1v-0.1 c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.3l0,0l-0.7,0.4l0,0c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.1,0.3v0.9c0,0.1,0.1,0.1,0.1,0.1l0.1-0.1C557.3,353.2,557.4,353.1,557.4,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M558.2,355.5c0.1-0.1,0.3-0.3,0.3-0.4c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3,0-0.3c0-0.1,0-0.3,0-0.3 c0-0.1-0.1-0.1-0.1-0.1h-0.1l0.1-0.1c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3,0-0.3c0-0.1,0-0.3,0-0.3c0-0.1-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0-0.3,0s-0.3,0.1-0.4,0.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.3-0.3,0.4c-0.1,0.1-0.1,0.3-0.1,0.4 s0,0.3,0,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.1h0.1l-0.1,0.1c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0,0.3 c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.3,0s0.3-0.1,0.4-0.1C558,355.7,558.1,355.5,558.2,355.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M557.1,352.8v0.3l-0.1,0.1v-0.9l0.1-0.1v0.3l1.1-0.5v-0.1l0.1-0.1c0,0.1,0,0.1,0,0.3 c0,0.1,0,0.1,0.1,0.1v0.1L557.1,352.8z M558.2,353.9c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0-0.3c0-0.1,0.1-0.1,0.1-0.3s0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.3 c0,0.1-0.1,0.1-0.1,0.3C558.4,353.8,558.4,353.9,558.2,353.9z M557.8,353.8c0.1-0.1,0.3-0.1,0.3-0.3c0.1,0,0.1-0.1,0.1-0.1 l0.1-0.1c0,0,0,0,0-0.1l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1s-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0.1-0.1,0.1l-0.1,0.1l0,0l0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1C557.5,353.9,557.7,353.9,557.8,353.8z  M557.8,355.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0-0.3 s0.1-0.1,0.1-0.3s0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0,0.1,0.1 c0,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.3c0,0.1-0.1,0.1-0.1,0.3c0,0.1-0.1,0.1-0.3,0.3C558.1,355.4,558,355.5,557.8,355.5z  M557.8,355.1c0.1-0.1,0.3-0.1,0.3-0.1c0.1,0,0.1-0.1,0.1-0.1l0.1-0.1c0,0,0,0,0-0.1l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.1,0.1l-0.1,0.1l0,0l0,0c0,0,0,0,0.1,0 c0,0,0.1,0,0.1-0.1C557.5,355.3,557.7,355.3,557.8,355.1z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M547.3,354.6L547.3,354.6l3-1.8c0.3-0.1,0.4-0.4,0.4-0.7v-0.3c0-0.1,0-0.1-0.1-0.3 c-0.1,0-0.1-0.1-0.1-0.3s-0.1-0.3-0.1-0.5s-0.1-0.3-0.4-0.1l-0.4,0.3c-0.3,0.1-0.4,0.4-0.4,0.7l0,0l-1.6,0.9v-0.1 c0-0.3-0.1-0.3-0.4-0.1l-0.4,0.3c-0.3,0.1-0.4,0.4-0.4,0.7v2.2c0,0.3,0.1,0.3,0.4,0.1l0.4-0.3 C547,355.1,547.3,354.9,547.3,354.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M549.3,360.6c0.3-0.3,0.5-0.5,0.8-0.8c0.3-0.3,0.4-0.5,0.4-0.9c0.1-0.3,0.1-0.5,0.1-0.8 c0-0.3,0-0.5-0.1-0.7s-0.3-0.3-0.4-0.4c-0.1,0-0.3,0-0.4,0c0.1-0.1,0.3-0.3,0.4-0.4c0.3-0.3,0.4-0.5,0.4-0.9 c0.1-0.3,0.1-0.5,0.1-0.8c0-0.3,0-0.5-0.1-0.7s-0.3-0.3-0.4-0.4c-0.1,0-0.4,0-0.8,0c-0.3,0.1-0.7,0.3-1.1,0.5 c-0.4,0.3-0.8,0.5-1.1,0.7c-0.3,0.3-0.5,0.5-0.8,0.8c-0.3,0.3-0.4,0.5-0.4,0.9c-0.1,0.3-0.1,0.5-0.1,0.8 c0,0.3,0,0.5,0.1,0.7c0.1,0.3,0.3,0.3,0.4,0.4c0.1,0,0.3,0,0.4,0c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.3-0.4,0.5-0.4,0.9 c-0.1,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.5,0.1,0.7c0.1,0.3,0.3,0.4,0.4,0.4s0.4,0,0.8,0c0.3-0.1,0.7-0.3,1.1-0.5 C548.7,361.1,549,360.8,549.3,360.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M546.8,354.3v0.5l-0.4,0.3V353l0.4-0.3v0.5l2.6-1.5v-0.4l0.4-0.3c0,0.3,0,0.4,0.1,0.5 c0,0.1,0.1,0.3,0.3,0.4v0.3L546.8,354.3z M549.3,356.9c-0.3,0.3-0.5,0.4-0.9,0.7s-0.7,0.4-0.9,0.4c-0.3,0.1-0.4,0.1-0.5,0 c-0.1,0-0.3-0.1-0.3-0.3c0-0.1-0.1-0.3-0.1-0.5c0-0.3,0-0.4,0.1-0.7c0-0.3,0.1-0.4,0.3-0.7c0.1-0.3,0.4-0.4,0.5-0.7 c0.3-0.3,0.5-0.4,0.9-0.7s0.7-0.4,0.9-0.4c0.3-0.1,0.4-0.1,0.5,0c0.1,0,0.3,0.1,0.3,0.3c0,0.1,0.1,0.3,0.1,0.5 c0,0.3,0,0.4-0.1,0.7c0,0.3-0.1,0.4-0.3,0.7S549.6,356.6,549.3,356.9z M548.3,356.5c0.3-0.1,0.5-0.4,0.8-0.5 c0.1-0.1,0.4-0.3,0.4-0.3c0.1-0.1,0.1-0.1,0.1-0.3v-0.1v-0.1h-0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.4,0.3-0.8,0.4 c-0.3,0.1-0.5,0.4-0.8,0.5c-0.1,0.1-0.4,0.3-0.4,0.3c-0.1,0.1-0.1,0.1-0.1,0.3v0.1v0.1c0,0,0.1,0,0.3,0 c0.1,0,0.3-0.1,0.4-0.1C547.8,356.8,548.1,356.6,548.3,356.5z M548.3,360.8c-0.4,0.3-0.7,0.4-0.9,0.4 c-0.3,0.1-0.4,0.1-0.5,0c-0.1,0-0.3-0.1-0.3-0.3c0-0.1-0.1-0.3-0.1-0.5s0-0.4,0.1-0.7c0-0.3,0.1-0.4,0.3-0.7 c0.1-0.3,0.4-0.4,0.5-0.7c0.3-0.3,0.5-0.4,0.9-0.7s0.7-0.4,0.9-0.4c0.3-0.1,0.4-0.1,0.5,0c0.1,0,0.3,0.1,0.3,0.3 c0,0.1,0.1,0.3,0.1,0.5s0,0.4-0.1,0.7c0,0.3-0.1,0.4-0.3,0.7c-0.1,0.3-0.4,0.4-0.5,0.7C549,360.4,548.7,360.6,548.3,360.8z  M548.3,359.7c0.3-0.1,0.5-0.4,0.8-0.5c0.1-0.1,0.4-0.3,0.4-0.3c0.1-0.1,0.1-0.1,0.1-0.3v-0.1v-0.1h-0.1 c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.4,0.3-0.8,0.4c-0.3,0.1-0.5,0.4-0.8,0.5c-0.1,0.1-0.4,0.3-0.4,0.3 c-0.1,0.1-0.1,0.1-0.1,0.3v0.1v0.1c0,0,0.1,0,0.3,0c0.1,0,0.3-0.1,0.4-0.1C547.8,360,548.1,359.9,548.3,359.7z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M557.3,322.6L557.3,322.6l1.2-0.8c0.1,0,0.1-0.1,0.1-0.3v-0.1v-0.1c0,0,0,0-0.1-0.1V321 c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.3l0,0l-0.7,0.4l0,0c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.1,0.3v0.9c0,0.1,0.1,0.1,0.1,0.1l0.1-0.1C557.3,322.9,557.3,322.8,557.3,322.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M558.2,325.1c0.1-0.1,0.3-0.3,0.3-0.4c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.3 c0-0.1,0-0.3,0-0.3c0-0.1-0.1-0.1-0.1-0.1h-0.1l0.1-0.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.3v-0.3 c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.3,0s-0.3,0.1-0.4,0.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.3-0.3,0.4 c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0,0.3c0,0.1,0,0.1,0,0.3s0.1,0.1,0.1,0.1h0.1l-0.1,0.1c-0.1,0.1-0.1,0.3-0.1,0.4 s0,0.3,0,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.3,0s0.3-0.1,0.4-0.1S558.1,325.2,558.2,325.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M557.1,322.5v0.3l-0.1,0.1V322l0.1-0.1v0.3l1.1-0.5v-0.1l0.1-0.1c0,0.1,0,0.1,0,0.3 c0,0.1,0,0.1,0.1,0.1v0.1L557.1,322.5z M558.2,323.6c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0-0.3s0.1-0.1,0.1-0.3c0-0.1,0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.3 c0,0.1-0.1,0.1-0.1,0.3C558.4,323.4,558.4,323.6,558.2,323.6z M557.8,323.4c0.1-0.1,0.3-0.1,0.3-0.3c0.1,0,0.1-0.1,0.1-0.1 l0.1-0.1c0,0,0,0,0-0.1l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0.1-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0.1-0.1,0.1l-0.1,0.1l0,0l0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1C557.5,323.6,557.7,323.4,557.8,323.4z  M557.8,325.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.3s0-0.1,0-0.3 c0-0.1,0.1-0.1,0.1-0.3c0-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0 c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.3c0,0.1-0.1,0.1-0.1,0.3c0,0.1-0.1,0.1-0.3,0.3S558,325.2,557.8,325.2 z M557.8,324.8c0.1-0.1,0.3-0.1,0.3-0.3c0.1,0,0.1-0.1,0.1-0.1l0.1-0.1c0,0,0,0,0-0.1l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.1,0.1l-0.1,0.1l0,0l0,0c0,0,0,0,0.1,0 c0,0,0.1,0,0.1-0.1C557.5,324.9,557.7,324.8,557.8,324.8z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M544,330.4L544,330.4l1.2-0.8c0.1,0,0.1-0.1,0.1-0.3v-0.1V329c0,0,0,0-0.1-0.1v-0.1 c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.3l0,0l-0.7,0.4l0,0c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.1,0.3v0.9c0,0.1,0.1,0.1,0.1,0.1l0.1-0.1C543.9,330.6,544,330.5,544,330.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M544.8,332.8c0.1-0.1,0.3-0.3,0.3-0.4c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.3 c0-0.1,0-0.3,0-0.3c0-0.1-0.1-0.1-0.1-0.1H545l0.1-0.1c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3,0-0.3c0-0.1,0-0.3,0-0.3 c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.3,0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.3-0.3,0.4 c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.1h0.1l-0.1,0.1 c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0,0.3c0,0.1,0,0.1,0,0.3s0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.3,0s0.3-0.1,0.4-0.1 C544.5,333.1,544.7,332.9,544.8,332.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M543.7,330.2v0.3l-0.1,0.1v-0.9l0.1-0.1v0.3l1.1-0.5v-0.1l0.1-0.1c0,0.1,0,0.1,0,0.3 c0,0.1,0,0.1,0.1,0.1v0.1L543.7,330.2z M544.8,331.3c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0-0.3c0-0.1,0.1-0.1,0.1-0.3s0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1s0.1,0,0.3,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.3 s-0.1,0.1-0.1,0.3C545,331.2,545,331.3,544.8,331.3z M544.4,331.2c0.1-0.1,0.3-0.1,0.3-0.3c0.1,0,0.1-0.1,0.1-0.1l0.1-0.1 c0,0,0,0,0-0.1l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.1l-0.3,0.3l-0.1,0.1 l0,0l0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1C544.1,331.3,544.3,331.2,544.4,331.2z M544.4,332.9c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.3c0-0.1,0-0.1,0-0.3c0-0.1,0.1-0.1,0.1-0.3s0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1s0.1,0,0.3,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.3 s-0.1,0.1-0.1,0.3c0,0.1-0.1,0.1-0.3,0.3C544.7,332.8,544.5,332.9,544.4,332.9z M544.4,332.5c0.1-0.1,0.3-0.1,0.3-0.3 c0.1,0,0.1-0.1,0.1-0.1l0.1-0.1c0,0,0,0,0-0.1l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1 c-0.1,0.1-0.3,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.1,0.1l-0.1,0.1l0,0l0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1 C544.1,332.7,544.3,332.5,544.4,332.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013168190855531057340000016433269315798521752_",
    gradientUnits: "userSpaceOnUse",
    x1: 714.7411,
    y1: 334.2498,
    x2: 714.7411,
    y2: 342.5354,
    gradientTransform: "matrix(-2.730000e-02 1.0154 0.9996 -0.5499 231.5165 -184.1064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B9BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8446,
    style: {
      stopColor: "#728680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000013168190855531057340000016433269315798521752_)",
      enableBackground: "new"
    },
    d: " M553.6,355.3c-0.8,0.5-1.5,0.1-1.5-0.7s0.7-2,1.5-2.4c0.8-0.5,1.5-0.1,1.5,0.7C555.1,353.8,554.4,354.9,553.6,355.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109019199364599009780000001139684556412676014_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.6879,
    y1: 322.1001,
    x2: 688.6879,
    y2: 340.3015,
    gradientTransform: "matrix(-2.730000e-02 1.0154 0.9996 -0.5499 231.5165 -184.1064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B9BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8446,
    style: {
      stopColor: "#728680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109019199364599009780000001139684556412676014_)"
    },
    d: "M551,332.5 c-1.9,1.1-3.4,0.4-3.4-1.5c0-1.9,1.5-4.3,3.4-5.4c1.9-1.1,3.4-0.4,3.4,1.5C554.4,329,552.9,331.4,551,332.5z"
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M547.7,331c0-1.9,1.5-4.3,3.4-5.4c1.9-1.1,3.4-0.4,3.4,1.5c0,1.9-1.5,4.3-3.4,5.4 C549.1,333.6,547.7,332.9,547.7,331z"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M555.2,321.7L555.2,321.7l1.1-0.3v0.1l-1.1,0.9v-0.4l0.1-0.1v-0.3H555.2z M555.8,321.7h-0.3v0.3 L555.8,321.7z M556.2,322.8v-0.3l-0.3,0.1l0,0c0,0.1,0,0.3-0.1,0.3c0,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.3,0 c0,0-0.1-0.1-0.1-0.3s0-0.1,0-0.1s0-0.1,0.1-0.3h0.1c0,0,0,0.1-0.1,0.1v0.1l0,0l0,0c0,0,0,0,0.1,0h0.1c0,0,0.1,0,0.1-0.1 c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0,0l0,0l0.5-0.3L556.2,322.8L556.2,322.8z M555.2,323.9l0.3-0.1v-0.4l0.1-0.1 h0.7v0.3l-0.7,0.4v0.1h-0.1v-0.1l-0.3,0.1V323.9z M555.5,323.6l0.5-0.3h-0.5V323.6z M556.2,324.5v-0.3l-0.3,0.1l0,0 c0,0.1,0,0.3-0.1,0.3c0,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.3,0c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1,0-0.1s0-0.1,0.1-0.3 h0.1c0,0,0,0.1-0.1,0.1v0.1l0,0l0,0c0,0,0,0,0.1,0h0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0,0 l0,0l0.5-0.3L556.2,324.5L556.2,324.5z M556.3,325.1L556.3,325.1c0,0.1,0,0.3,0,0.3s0,0.1-0.1,0.1l-0.1,0.1c0,0,0,0-0.1,0 l0,0l0,0l0,0c0,0.1,0,0.1-0.1,0.3l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0c0,0-0.1-0.1-0.1-0.3v-0.1v-0.1c0,0,0-0.1,0.1-0.1l0.1-0.1 c0.1,0,0.1-0.1,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0-0.1,0.1-0.1l0.1-0.1h0.1C556.2,325.1,556.2,325.1,556.3,325.1 C556.2,324.8,556.2,324.9,556.3,325.1C556.3,324.9,556.3,324.9,556.3,325.1z M555.8,325.3L555.8,325.3c-0.1,0-0.1,0-0.3,0 c-0.1,0-0.1,0.1-0.1,0.1s0,0,0,0.1l0,0l0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0C555.7,325.5,555.7,325.5,555.8,325.3L555.8,325.3z  M556.2,325.1L556.2,325.1h-0.1c-0.1,0-0.1,0.1-0.1,0.1s0,0,0.1,0C556.1,325.2,556.1,325.2,556.2,325.1 C556.2,325.2,556.2,325.1,556.2,325.1z M555.8,326.2c0.1,0,0.1-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0s0.1,0,0.1,0.1v0.1v0.1 c0,0,0,0.1-0.1,0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1-0.1v-0.1v-0.1 c0,0,0-0.1,0.1-0.1l0.1-0.1C555.5,326.3,555.7,326.3,555.8,326.2z M555.8,326.6c-0.1,0-0.1,0.1-0.3,0.1c0,0-0.1,0-0.1,0.1 l0,0l0,0l0,0l0,0h0.1c0,0,0.1,0,0.3-0.1c0.1,0,0.1-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1l0,0l0,0l0,0l0,0h-0.1 C555.9,326.4,555.8,326.4,555.8,326.6z M555.8,327.1c0.1,0,0.1-0.1,0.3-0.1h0.1c0,0,0.1,0,0.1,0.1v0.1v0.1 c0,0,0,0.1-0.1,0.1l-0.1,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1-0.1 c0-0.1,0-0.1,0-0.1v-0.1c0,0,0-0.1,0.1-0.1l0.1-0.1C555.5,327.2,555.7,327.1,555.8,327.1z M555.8,327.4 c-0.1,0-0.1,0.1-0.3,0.1c0,0-0.1,0-0.1,0.1l0,0l0,0l0,0l0,0h0.1c0,0,0.1,0,0.3-0.1c0.1,0,0.1-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1 l0,0l0,0l0,0l0,0h-0.1C555.9,327.4,555.8,327.4,555.8,327.4z M555.8,328c0.1,0,0.1-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0 s0.1,0,0.1,0.1v0.1v0.1c0,0,0,0.1-0.1,0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0 s-0.1,0-0.1-0.1v-0.1v-0.1c0,0,0-0.1,0.1-0.1l0.1-0.1C555.5,328,555.7,328,555.8,328z M555.8,328.3c-0.1,0-0.1,0.1-0.3,0.1 c0,0-0.1,0-0.1,0.1l0,0l0,0l0,0l0,0h0.1c0,0,0.1,0,0.3-0.1c0.1,0,0.1-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1l0,0l0,0l0,0l0,0h-0.1 C555.9,328.2,555.8,328.2,555.8,328.3z M556.2,329.4v-0.3l-0.3,0.1l0,0c0,0.1,0,0.3-0.1,0.3c0,0.1-0.1,0.1-0.3,0.3 c-0.1,0.1-0.3,0.1-0.3,0c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1,0-0.1s0-0.1,0.1-0.3h0.1c0,0,0,0.1-0.1,0.1v0.1l0,0l0,0 c0,0,0,0,0.1,0h0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0-0.1,0,0,0-0.1l0,0l0,0l0.5-0.3L556.2,329.4 L556.2,329.4z M555.8,330.2c0.1,0,0.1-0.1,0.3-0.1h0.1c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.1v0.1c0,0,0,0.1-0.1,0.1l-0.1,0.1 c0,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1-0.1v-0.1v-0.1c0,0,0-0.1,0.1-0.1l0.1-0.1 C555.5,330.2,555.7,330.2,555.8,330.2z M555.8,330.5c-0.1,0-0.1,0.1-0.3,0.1c0,0-0.1,0-0.1,0.1l0,0l0,0l0,0l0,0h0.1 c0,0,0.1,0,0.3-0.1c0.1,0,0.1-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1l0,0l0,0l0,0l0,0h-0.1C555.9,330.4,555.8,330.4,555.8,330.5z  M555.8,331c0.1,0,0.1-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0s0.1,0,0.1,0.1v0.1v0.1c0,0,0,0.1-0.1,0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1-0.1v-0.1v-0.1c0,0,0-0.1,0.1-0.1l0.1-0.1 C555.5,331.2,555.7,331.2,555.8,331z M555.8,331.3c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.1,0.1l0,0l0,0l0,0l0,0h0.1 c0,0,0.1,0,0.3-0.1c0.1,0,0.1-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1l0,0l0,0l0,0l0,0h-0.1C555.9,331.3,555.8,331.3,555.8,331.3z  M556.2,332.4L556.2,332.4h-0.3c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1 h-0.1c0,0,0,0-0.1-0.1v-0.1v-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1h0.1v0.1v0.1c0,0,0,0,0,0.1l0,0c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1-0.1c0,0,0,0,0-0.1v-0.1l0,0L556.2,332.4l-0.1-0.5h0.1V332.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161611419850401287100000018020754637794896825_",
    gradientUnits: "userSpaceOnUse",
    x1: 701.4199,
    y1: 347.2082,
    x2: 701.4199,
    y2: 331.4095,
    gradientTransform: "matrix(-2.730000e-02 1.0154 0.9996 -0.5499 231.5165 -184.1064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B9BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#9EA0A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161611419850401287100000018020754637794896825_)"
    },
    d: "M551.2,346.5 c-3.8,2.2-6.8,1.8-6.8-0.8s3-6.5,6.8-8.7c3.8-2.2,6.8-1.8,6.8,0.8C558,340.4,554.8,344.3,551.2,346.5z"
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M544.3,345.7c0-2.7,3.1-6.6,6.8-8.8c3.8-2.2,6.8-1.8,6.8,0.9c0,2.7-3.1,6.6-6.8,8.8 S544.3,348.4,544.3,345.7z M557.8,337.8c0-2.6-3-3-6.6-0.8s-6.6,6-6.6,8.5s3,3,6.6,0.8 C554.8,344.3,557.8,340.4,557.8,337.8z"
  })))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M555.4,338.7l0.5-0.3v0.3l-0.5,0.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4l0.5-0.3v0.3l-0.5,0.3 c-0.1,0.7-0.3,1.2-0.5,1.6s-0.5,0.8-0.9,0.9c-0.3,0.1-0.4,0.1-0.5,0.1c-0.1,0-0.1-0.1-0.1-0.3s0-0.3,0.1-0.5 c0.1-0.1,0.3-0.3,0.4-0.4c0.3-0.1,0.4-0.1,0.5,0c0,0.1,0.1,0.1,0.1,0.1s0.1-0.1,0.3-0.4c0.1-0.3,0.3-0.5,0.3-0.9l-3,1.8 c-0.5,1.5-1.2,2.6-2.3,3.1c-0.4,0.3-0.9,0.4-1.4,0.3c-0.4-0.1-0.7-0.4-0.8-0.8l-1.4,0.7v-0.3l1.2-0.7c0-0.3-0.1-0.5,0-0.8 l-1.2,0.7V344l1.2-0.7c0.1-0.8,0.4-1.4,0.7-1.9c0.4-0.5,0.7-0.9,1.1-1.1c0.1-0.1,0.4-0.1,0.5-0.1s0.3,0.1,0.3,0.4 c0,0.1,0,0.3-0.1,0.5c-0.1,0.3-0.3,0.4-0.4,0.4c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.1-0.1-0.1-0.3c0,0,0,0,0-0.1v-0.1 c0,0,0,0-0.1,0s-0.3,0.3-0.5,0.7c-0.3,0.4-0.4,0.8-0.4,1.4l3.5-2c0.4-1.4,1.1-2.3,2-2.8C554.4,337.5,555,337.7,555.4,338.7z  M552.7,340.2l2.3-1.4c-0.3-0.5-0.7-0.7-1.2-0.4C553.3,338.7,552.9,339.4,552.7,340.2z M555.1,339.2l-2.6,1.5 c-0.1,0.3-0.1,0.5-0.3,1.1l2.8-1.6v-0.4c0,0,0-0.1,0-0.3C555.1,339.2,555.1,339.2,555.1,339.2z M547.9,344l3-1.8l0.4-1.1 l-3.4,1.9c0,0.1,0,0.1,0,0.3C547.8,343.6,547.9,343.8,547.9,344z M550.8,342.7l-2.8,1.6c0.3,0.7,0.7,0.8,1.4,0.4 S550.5,343.6,550.8,342.7z"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M581.9,365l-41.4,23.8c-2.3,1.4-4.1,0.5-4.1-1.8v-32.9c0-2.3,1.8-5.1,4.1-6.4l41.4-23.8 c1.8-0.9,3.1-0.4,3.1,1.4v34.8C585,361.9,583.5,364.1,581.9,365z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M585,349.6v-11c-0.1,0-0.1,0.1-0.3,0.1L566.9,349c-3,1.8-5.6,5.7-5.6,8.7c0,3,2.4,4.1,5.6,2.3l17.9-10.3 C584.8,349.7,584.9,349.7,585,349.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M585.2,348.2l-17.9,10.3c-3,1.8-5.6,0.7-5.6-2.3l0,0c0-3,2.4-6.9,5.6-8.7l17.9-10.3 c0.9-0.5,1.8-0.3,1.8,0.8v7.4C586.9,346.3,586.1,347.7,585.2,348.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M569.3,352c0,1.4-1.2,3.3-2.6,4.1s-2.6,0.3-2.6-1.1c0-1.4,1.2-3.3,2.6-4.1 C568.2,350.1,569.3,350.7,569.3,352z"
  })))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "667.1,329.7 664.8,330.9 664.8,332.2 667.1,330.9  "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M596.1,301v-0.8c0-5.3,1.9-8.7,5.8-10.8c3.9-2.3,5.8-1.2,5.8,4.2v0.8c0,5.3-1.9,8.7-5.8,11 C598,307.5,596.1,306.4,596.1,301z M602.1,302.3c2-1.1,2.6-3.1,2.6-6.2v-0.8c0-3.1-0.5-4.5-2.6-3.4L602,292 c-2,1.1-2.6,3.1-2.6,6.2v0.8c0,3.1,0.5,4.5,2.6,3.3H602.1z M620.9,294.1l-3.4,1.9l-5-6.6l0.1,3v6.4l-3,1.8v-15.3l3.4-1.9l4.9,6.6 l-0.1-3v-6.4l3-1.8v15.3H620.9z M623.1,292.7v-15.3l3.1-1.9v12.6l5.7-3.3v2.7L623.1,292.7z M636.6,284.8l-3.3,1.9v-15.3l3.3-1.9 V284.8z M650.2,277.1l-3.4,1.9l-5-6.6l0.1,3v6.4l-3,1.8v-15.2l3.4-1.9l4.9,6.6l-0.1-3v-6.4l3-1.8v15.2H650.2z M661.7,255.1v2.7 l-6.2,3.5v3.5l5.1-3v2.7l-5.1,3v3.7l6.2-3.5v2.7l-9.3,5.4v-15.3L661.7,255.1z M604.1,309.2l-2,11.8l-3.7,2.2l-2.3-12.6l3-1.8 l1.4,9.2l1.9-11.1l3.5-2l1.9,8.9l1.4-10.8l3-1.8l-2.3,15.3l-3.7,2.2L604.1,309.2z M619.6,297l3.5,11.9l-3.1,1.8l-0.7-2.6l-3.4,2 l-0.7,3.4l-3.1,1.8l3.5-16L619.6,297z M616.5,307.2l2.3-1.4l-1.1-4.5L616.5,307.2z M624.3,308.1v-13.8l2.8-1.6v11.4l5.1-3v2.4 L624.3,308.1z M633.5,302.9v-13.9l2.8-1.6v11.4l5.1-3v2.4L633.5,302.9z M651.4,278.6v2.4l-5.7,3.3v3.1l4.7-2.7v2.4l-4.7,2.7v3.4 l5.7-3.3v2.4l-8.5,4.9v-13.8L651.4,278.6z M658.6,288.4l-2.8,1.6v-11.4l-3.3,1.9v-2.4l9.3-5.4v2.4l-3.3,1.9V288.4z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M599.3,330.2V327l0.7-0.4v2.7l1.2-0.7v0.5L599.3,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M601.4,327.9L601.4,327.9c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C601.7,328.9,601.4,328.7,601.4,327.9z M602.2,328.2c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C601.8,328,602,328.3,602.2,328.2L602.2,328.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M603.9,327.5l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L603.9,327.5L603.9,327.5z M604.1,326.2c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L604.1,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M606.7,323.7v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L606.7,323.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M608.3,325.1l-0.5,0.3l-0.4-1.2v0.4v0.9l-0.5,0.3v-2.3l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L608.3,325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M615.5,320.9l-0.5,0.3v-2.3l0.5-0.3V320.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M616.3,320.3l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.7-0.4,0.9-0.8,1.2l-0.3,0.1 L616.3,320.3L616.3,320.3z M616.6,319c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L616.6,319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M617.5,318L617.5,318c0-0.4,0.3-0.8,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3 l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C617.8,318.4,617.5,318.4,617.5,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M619.4,317.9v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C619.7,318.4,619.4,318.3,619.4,317.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M622.8,316.7l-0.5,0.3l-0.4-1.2v0.4v0.9l-0.5,0.3V315l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L622.8,316.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M630.3,312.3l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C631.2,311.5,630.9,311.9,630.3,312.3z  M630.3,311.9c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L630.3,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.5,310.6L631.5,310.6c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C631.8,311.5,631.5,311.4,631.5,310.6z M632.3,310.7c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C631.9,310.7,632,311,632.3,310.7L632.3,310.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M633.5,310.4v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L633.5,310.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M635,308.5L635,308.5c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C635.3,309.5,635,309.4,635,308.5z M635.8,308.7c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C635.4,308.7,635.6,309,635.8,308.7L635.8,308.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M637.4,308.1l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L637.4,308.1L637.4,308.1z M637.7,306.8c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L637.7,306.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M644.4,302.6L644.4,302.6c0-0.4,0.3-0.9,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3 c0-0.3-0.1-0.4-0.3-0.3l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C644.5,303,644.4,303,644.4,302.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M646.7,302.9l-0.5,0.3v-2.3l0.5-0.3V302.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M648,302.2l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H648z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M655.3,295.5l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L655.3,295.5z M654.8,297.2 l0.4-0.3l-0.1-0.7L654.8,297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M657.5,296.6l-0.5,0.3l-0.4-1.2v0.4v0.9l-0.5,0.3V295l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L657.5,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M660.1,292.8v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L660.1,292.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M661.3,294.5l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H661.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M662.8,293.4c0,0.5-0.3,0.9-0.7,1.2v-0.3c0.1-0.1,0.3-0.3,0.4-0.5l-0.4,0.3v-0.8l0.7-0.4V293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M600.1,334.4L600.1,334.4c0.3-0.1,0.4-0.4,0.4-0.5l0.5-0.3l0,0c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.4-0.8,0.1-0.8-0.7V334c0-0.8,0.3-1.2,0.8-1.6c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C599.7,334.4,599.8,334.7,600.1,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M601.2,333.2L601.2,333.2c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C601.4,334.1,601.2,333.9,601.2,333.2z M602,333.3c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C601.6,333.3,601.7,333.5,602,333.3L602,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M604.8,332.1l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3v-2.3l0.5-0.3l0.7,0.9V331v-0.9l0.4-0.3V332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M605.1,330.4L605.1,330.4c0-0.4,0.3-0.8,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3 c0-0.3-0.1-0.4-0.3-0.3l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C605.4,330.8,605.1,330.8,605.1,330.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M608.5,327.8v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.4L608.5,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M609.6,329L609.6,329c0.3-0.1,0.4-0.4,0.4-0.5l0.5-0.3l0,0c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.4-0.8,0.1-0.8-0.7v-0.1c0-0.8,0.3-1.2,0.8-1.6c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C609.1,329,609.1,329.1,609.6,329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M611.4,328.2l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H611.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M613.6,324.7v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L613.6,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M614.8,326.3l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H614.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M615.5,325.2v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C615.8,325.9,615.5,325.6,615.5,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M617.9,324.5l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L617.9,324.5L617.9,324.5z M618.2,323c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L618.2,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M625.8,317.6l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3v0.5l-0.5,0.3l0.5-2.6L625.8,317.6z M625.4,319.4l0.4-0.3 l-0.1-0.7L625.4,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M627.3,319.1l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C628.2,318.2,628,318.7,627.3,319.1z  M627.3,318.7c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L627.3,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M629.1,318l-0.5,0.3V316l0.5-0.3V318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M629.9,317.6l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.7-0.4,0.9-0.8,1.2l-0.3,0.1 L629.9,317.6L629.9,317.6z M630.1,316.1c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L630.1,316.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.8,316.5l-0.5,0.3v-2.3l0.5-0.3V316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M632,314.8L632,314.8c0-0.4,0.3-0.9,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3 l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C632.3,315.2,632,315.2,632,314.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M634.5,315l-0.5,0.3V313l0.5-0.3V315z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M635.6,314L635.6,314c0.3-0.1,0.4-0.4,0.4-0.5l0.5-0.3l0,0c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.4-0.8,0.1-0.8-0.7v-0.1c0-0.8,0.3-1.2,0.8-1.6c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C635.1,314,635.3,314.1,635.6,314z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M637.2,313.4l-0.5,0.3v-2.3l0.5-0.3V313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M639.2,312.2l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3v-2.3l0.5-0.3l0.7,0.9v-0.4v-0.9l0.4-0.3V312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M639.5,311L639.5,311c0-0.9,0.3-1.4,0.8-1.8c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3,0-0.4-0.3-0.3 l0,0c-0.3,0.1-0.4,0.5-0.4,0.9v0.1c0,0.4,0.1,0.7,0.4,0.5l0,0c0.1-0.1,0.3-0.1,0.3-0.3v-0.4l-0.3,0.1v-0.4l0.8-0.4v0.9 c-0.1,0.3-0.4,0.5-0.8,0.7C639.8,311.9,639.5,311.8,639.5,311z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M642.9,307.7v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L642.9,307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M643.1,309.9v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L643.1,309.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M645.2,308.8l-0.5,0.3v-2.3l0.5-0.3V308.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M646.4,308l-0.5,0.3v-1.9l-0.4,0.4v-0.4l1.5-0.9v0.4l-0.5,0.3L646.4,308L646.4,308z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M648,307.1c0,0.5-0.3,0.9-0.7,1.2V308c0.1-0.1,0.3-0.3,0.4-0.5l-0.4,0.3v-0.7l0.7-0.4V307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M648.3,305.4L648.3,305.4c0-0.4,0.3-0.8,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3 c0-0.3-0.1-0.4-0.3-0.3l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C648.6,305.8,648.3,305.8,648.3,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M651.5,302.7v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L651.5,302.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M652.6,304.5l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C653.6,303.7,653.3,304.1,652.6,304.5z  M652.5,304.1c0.4-0.3,0.5-0.5,0.5-0.9V303c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L652.5,304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M659.9,300.3l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C660.9,299.5,660.6,299.9,659.9,300.3z  M659.9,299.9c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L659.9,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M661.1,298.5L661.1,298.5c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C661.4,299.5,661.1,299.3,661.1,298.5z M662,298.7c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C661.6,298.7,661.7,298.9,662,298.7L662,298.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M600.6,337.3v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L600.6,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M601.4,339.2l-0.5,0.3v-2.3l0.5-0.3V339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M601.7,338.2v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C602,338.9,601.7,338.7,601.7,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M603.7,336.2L603.7,336.2c0-0.4,0.3-0.8,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3 c0-0.3-0.1-0.4-0.3-0.3l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C603.9,336.6,603.7,336.6,603.7,336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M607,335.9l-0.5,0.3L606,335v0.4v0.9l-0.5,0.3v-2.3l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L607,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M608.1,334.1L608.1,334.1c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C608.3,335.1,608.1,335,608.1,334.1z M609,334.4c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C608.6,334.3,608.6,334.5,609,334.4L609,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M610.8,333.7l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C611.9,332.8,611.4,333.3,610.8,333.7z  M610.8,333.3c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L610.8,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M615.2,331.2l-0.5,0.3v-1.9l-0.4,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3L615.2,331.2L615.2,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M617.4,327.5v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L617.4,327.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M619,328.9l-0.5,0.3l-0.4-1.2v0.4v0.9l-0.5,0.3v-2.3l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L619,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M620.8,327.9l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.7-0.4,0.9-0.8,1.2l-0.3,0.1 L620.8,327.9L620.8,327.9z M621.1,326.6c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L621.1,326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M622,326.2L622,326.2c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C622.3,327.1,622,327,622,326.2z M622.8,326.3c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C622.4,326.3,622.6,326.6,622.8,326.3L622.8,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M624.4,325.7l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L624.4,325.7L624.4,325.7z M624.9,324.4c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L624.9,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M628.6,323.3l-0.5,0.3v-2.3l0.5-0.3V323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M630.7,322.2l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3v-2.3l0.5-0.3l0.7,0.9v-0.4v-0.9l0.4-0.3V322.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.9,321.1L631.9,321.1c0.3-0.1,0.4-0.4,0.4-0.5l0.5-0.3l0,0c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.4-0.8,0.1-0.8-0.7v-0.1c0-0.8,0.3-1.2,0.8-1.6c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C631.5,321.1,631.5,321.3,631.9,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M633.4,320.6l-0.5,0.3v-2.3l0.5-0.3V320.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M634.5,320.1l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C635.4,319.1,635.1,319.7,634.5,320.1z  M634.5,319.7c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L634.5,319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M636.2,319l-0.5,0.3v-2.3l0.5-0.3V319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M637.3,318.4l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C638.3,317.5,638,318,637.3,318.4z  M637.2,318c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L637.2,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M638.5,316.9v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C638.7,317.6,638.5,317.5,638.5,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M642.2,315.6l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3v-2.3l0.5-0.3l0.7,0.9v-0.4v-0.9l0.4-0.3V315.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M643.4,314.9l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H643.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M646.4,312.3v-1.5l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C646.7,313,646.4,312.9,646.4,312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M649.2,311.4l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H649.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M652.3,309.6v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L652.3,309.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M655.1,305.8l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L655.1,305.8z M654.5,307.6 l0.4-0.3l-0.1-0.7L654.5,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M656.5,305c0.4-0.3,0.7-0.3,0.7,0.3l0,0c0,0.3-0.1,0.4-0.3,0.5c0.1,0,0.3,0,0.3,0.3l0,0 c0,0.5-0.4,0.9-0.8,1.1l-0.8,0.4v-2.2L656.5,305z M656.3,305.6v0.5l0.3-0.1c0.1-0.1,0.3-0.1,0.3-0.4l0,0c0-0.1-0.1-0.1-0.3-0.1 L656.3,305.6z M656.3,306.5v0.5l0.3-0.1c0.1-0.1,0.3-0.3,0.3-0.4l0,0c0-0.3-0.1-0.1-0.3-0.1L656.3,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M657.6,305.6L657.6,305.6c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C657.9,306.5,657.6,306.4,657.6,305.6z M658.4,305.8c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C658,305.7,658.2,306,658.4,305.8L658.4,305.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M660.1,305.2l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L660.1,305.2L660.1,305.2z M660.5,303.8c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L660.5,303.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M662.9,301.4v0.4l-0.9,0.5v0.4l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8V302L662.9,301.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M600.6,342.3v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L600.6,342.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M601.8,343.9l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H601.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M603.3,343.1l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C604.3,342.3,604,342.7,603.3,343.1z  M603.2,342.7c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L603.2,342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M604.4,341.3L604.4,341.3c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C604.8,342.3,604.4,342.1,604.4,341.3z M605.4,341.5c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C604.9,341.5,605.1,341.7,605.4,341.5L605.4,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M606.4,341.2v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L606.4,341.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M607.9,339.3L607.9,339.3c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C608.2,340.2,607.9,340.1,607.9,339.3z M608.9,339.6c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C608.5,339.4,608.5,339.7,608.9,339.6L608.9,339.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M610.5,338.9l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L610.5,338.9L610.5,338.9z M610.8,337.5c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L610.8,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M613.2,335.1v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L613.2,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M617.7,334.8l-0.5,0.3l-0.4-1.2v0.4v0.9l-0.5,0.3v-2.3l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L617.7,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M620,331.2l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L620,331.2z M619.4,332.8l0.4-0.3 l-0.1-0.7L619.4,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M620.7,332L620.7,332c0-0.9,0.3-1.4,0.8-1.8c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3,0-0.4-0.3-0.3 l0,0c-0.3,0.1-0.4,0.5-0.4,0.9v0.1c0,0.4,0.1,0.7,0.4,0.5l0,0c0.1-0.1,0.3-0.1,0.3-0.3v-0.4l-0.3,0.1v-0.4l0.8-0.4v0.9 c-0.1,0.3-0.4,0.5-0.8,0.7C620.9,332.9,620.7,332.8,620.7,332z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M624.4,330.9l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3v-2.3l0.5-0.3l0.7,0.9v-0.4v-0.9l0.4-0.3V330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M625.8,327.8l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L625.8,327.8z M625.3,329.4 l0.4-0.3l-0.1-0.7L625.3,329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M630.5,325.1l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L630.5,325.1z M630,326.7 l0.4-0.3l-0.1-0.7L630,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.4,326.8v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L631.4,326.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M633.4,325.7l-0.5,0.3v-2.3l0.5-0.3V325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M633.7,324.4L633.7,324.4c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.5-0.1,0.9-0.4,1.4 l0.1,0.3l-0.4,0.3l-0.1-0.3c0,0-0.1,0-0.1,0.1C633.9,325.5,633.7,325.2,633.7,324.4z M634.7,324.4c0.1-0.1,0.1-0.4,0.1-0.7v-0.1 c0-0.4-0.1-0.7-0.4-0.5l0,0c-0.3,0.1-0.4,0.5-0.4,0.9v0.1c0,0.4,0.1,0.7,0.4,0.5l-0.1-0.3l0.4-0.3V324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M635.7,323.7v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C635.8,324.3,635.7,324.1,635.7,323.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M638.7,320.3l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L638.7,320.3z M638.3,322 l0.4-0.3l-0.1-0.7L638.3,322z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M643.4,317.6l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3v0.5l-0.5,0.3l0.5-2.6L643.4,317.6z M642.9,319.2l0.4-0.3 l-0.1-0.7L642.9,319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M644.2,319.4v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L644.2,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M646.3,318.3l-0.5,0.3v-2.3l0.5-0.3V318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M646.5,317.1L646.5,317.1c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.5-0.1,0.9-0.4,1.4 l0.1,0.3l-0.4,0.3l-0.1-0.3c0,0-0.1,0-0.1,0.1C646.8,318,646.5,317.8,646.5,317.1z M647.7,316.9c0.1-0.1,0.1-0.4,0.1-0.7v-0.1 c0-0.4-0.1-0.7-0.4-0.5l0,0c-0.3,0.1-0.4,0.5-0.4,0.9v0.1c0,0.4,0.1,0.7,0.4,0.5l-0.1-0.3l0.4-0.3V316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M648.6,316.3v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5V314l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C648.7,316.8,648.6,316.7,648.6,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M651,315.5l-0.5,0.3v-2.2l0.5-0.3V315.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M651.8,315l-0.5,0.3V313l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.7-0.4,0.9-0.8,1.2l-0.3,0.1L651.8,315 L651.8,315z M652.1,313.7c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L652.1,313.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M654.5,311.1v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L654.5,311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M655.3,311.8l-0.5-0.8l0.5-0.3l0.4,0.5l0.4-0.9l0.5-0.3l-0.5,1.4l0.5,0.9l-0.5,0.3l-0.4-0.7l-0.4,1.1 l-0.5,0.3L655.3,311.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M661,307.5v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L661,307.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M662.4,306.7l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L662.4,306.7z M661.8,308.4 l0.4-0.3l-0.1-0.7L661.8,308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M599.3,350.5v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L599.3,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M600.7,348.9v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C600.9,349.6,600.7,349.4,600.7,348.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M603.2,348.2l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.7-0.4,0.9-0.8,1.2l-0.3,0.1 L603.2,348.2L603.2,348.2z M603.5,346.7c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L603.5,346.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M605.4,346.9l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H605.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M607.1,343.6l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L607.1,343.6z M606.6,345.4 l0.4-0.3l-0.1-0.7L606.6,345.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M608.6,345.1l-0.5,0.3v-1.9l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H608.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M610.8,341.6v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L610.8,341.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M613.5,342.3l-0.5-2l0.5-0.3l0.4,1.5l0.4-2l0.5-0.3l-0.5,2.6L613.5,342.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M616.3,338.3v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L616.3,338.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M616.6,340.5v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L616.6,340.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M618.6,339.3l-0.5,0.3v-2.3l0.5-0.3V339.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M619.8,338.6l-0.5,0.3V337l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H619.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M623.9,333.9v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L623.9,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M624.2,334.4L624.2,334.4c0-0.4,0.3-0.8,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3 c0-0.3-0.1-0.4-0.3-0.3l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C624.4,335,624.2,334.8,624.2,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M626.1,333.3L626.1,333.3c0-0.4,0.3-0.8,0.8-1.2c0.5-0.3,0.8-0.3,0.8,0.3l0,0l-0.5,0.3 c0-0.3-0.1-0.4-0.3-0.3l0,0c-0.1,0.1-0.3,0.3-0.3,0.4l0,0c0,0.1,0,0.3,0.4,0c0.5-0.3,0.8-0.1,0.8,0.3l0,0c0,0.4-0.3,0.8-0.8,1.2 c-0.5,0.3-0.8,0.3-0.8-0.3l0,0l0.5-0.3c0,0.3,0.1,0.4,0.4,0.3l0,0c0.3-0.1,0.3-0.3,0.3-0.4l0,0c0-0.1-0.1-0.3-0.4,0 C626.2,333.9,626.1,333.9,626.1,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M629.3,330.8v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L629.3,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M632.3,331L632.3,331c0.3-0.1,0.4-0.4,0.4-0.5l0.5-0.3l0,0c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.4-0.8,0.1-0.8-0.7v-0.1c0-0.8,0.3-1.2,0.8-1.6c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3c0-0.3-0.1-0.4-0.3-0.3l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C632,330.9,632,331.2,632.3,331z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M633.9,330.5l-0.5,0.3v-2.3l0.5-0.3V330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M634.3,330.2v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L634.3,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M635.8,329.4v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L635.8,329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M637.3,327.8v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C637.4,328.5,637.3,328.3,637.3,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M640.7,326.6l-0.5,0.3l-0.4-1.2v0.4v0.9l-0.5,0.3v-2.3l0.7-0.4l0.4,1.2l0.4-1.8l0.7-0.4v2.3l-0.5,0.3v-0.9 v-0.4L640.7,326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M644.2,324.5l-0.5,0.3v-2.3l0.5-0.3V324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M646.3,323.3l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3V322l0.5-0.3l0.7,0.9v-0.4v-0.9l0.4-0.3V323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M649.2,321.5l-0.7,0.4v-2.3l0.7-0.4c0.7-0.4,0.9-0.3,0.9,0.5v0.1C650.3,320.7,649.9,321.1,649.2,321.5z  M649.2,321.1c0.4-0.3,0.5-0.5,0.5-0.9v-0.1c0-0.4-0.1-0.7-0.5-0.4l-0.1,0.1v1.5L649.2,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M650.4,319.8L650.4,319.8c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C650.7,320.7,650.4,320.6,650.4,319.8z M651.4,320.1c0.3-0.1,0.4-0.4,0.4-0.9V319c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C651,319.9,651,320.2,651.4,320.1L651.4,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M652.5,319.7v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L652.5,319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M654,317.8L654,317.8c0-0.9,0.3-1.4,0.8-1.8c0.5-0.4,0.8-0.1,0.8,0.7v0.1c0,0.8-0.3,1.4-0.8,1.6 C654.2,318.7,654,318.6,654,317.8z M654.8,318c0.3-0.1,0.4-0.4,0.4-0.9v-0.1c0-0.4-0.1-0.7-0.4-0.5l0,0 c-0.3,0.1-0.4,0.5-0.4,0.9v0.1C654.4,318,654.5,318.2,654.8,318L654.8,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M656.4,317.5l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L656.4,317.5L656.4,317.5z M656.8,316c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L656.8,316z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M659.3,313.6v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L659.3,313.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M660.9,312.6v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.5l0.9-0.5v0.4l-1.4,0.8v-2.3L660.9,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M661.1,314v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C661.4,314.6,661.1,314.5,661.1,314z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M600.6,352.4v0.4l-0.9,0.5v0.5l0.8-0.4v0.4l-0.8,0.4v0.9l-0.5,0.3v-2.3L600.6,352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M600.9,353.9v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1s0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C601,354.6,600.9,354.3,600.9,353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M602.8,352.4L602.8,352.4c0-0.9,0.3-1.4,0.8-1.8c0.5-0.3,0.8-0.3,0.8,0.3v0.1l-0.5,0.3 c0-0.3,0-0.4-0.3-0.3l0,0c-0.3,0.1-0.4,0.5-0.4,0.9v0.1c0,0.4,0.1,0.7,0.4,0.5l0,0c0.1-0.1,0.3-0.1,0.3-0.3V352l-0.3,0.1v-0.4 l0.8-0.4v0.9c-0.1,0.3-0.4,0.5-0.8,0.7C603,353.4,602.8,353.2,602.8,352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M605.2,352l-0.5,0.3V350l0.5-0.3V352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M606.7,348.9l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L606.7,348.9z M606.2,350.5 l0.4-0.3l-0.1-0.7L606.2,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M608.2,350.3l-0.5,0.3v-1.8l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v1.9H608.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M611.6,348.5l-0.5,0.3l-0.7-0.9v0.4v0.9l-0.4,0.3v-2.3l0.5-0.3l0.7,0.9v-0.4v-0.9l0.4-0.3V348.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M611.9,347.6v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.5l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C612,348.2,611.9,348,611.9,347.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M613.7,347.1v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L613.7,347.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M615.4,346.2v-2.3l0.5-0.3v1.9l0.8-0.5v0.4L615.4,346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M617.9,342.4l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L617.9,342.4z M617.5,344 l0.4-0.3l-0.1-0.7L617.5,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M620.1,343.5l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.7-0.4,0.9-0.8,1.2l-0.3,0.1 L620.1,343.5L620.1,343.5z M620.4,342.1c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L620.4,342.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M622.4,339.8l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L622.4,339.8z M621.9,341.5 l0.4-0.3l-0.1-0.7L621.9,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M623.8,341.5l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L623.8,341.5L623.8,341.5z M624,340c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7L624,340 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M625.5,340.4l-0.4,0.3v-2.3l0.5-0.3v2.3H625.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M627,337.1l0.5,2l-0.5,0.3l-0.1-0.4l-0.5,0.3l-0.1,0.5l-0.5,0.3l0.5-2.6L627,337.1z M626.5,338.9l0.4-0.3 l-0.1-0.7L626.5,338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M628.5,338.6l-0.5,0.3V337l-0.5,0.3v-0.4l1.5-0.9v0.4l-0.5,0.3v2H628.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M629.3,337.4v-1.6l0.5-0.3v1.5c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.3,0.4-0.5v-1.4l0.5-0.3v1.6 c0,0.5-0.3,0.9-0.8,1.2C629.5,338.1,629.3,337.9,629.3,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.8,336.7l-0.5,0.3v-2.3l0.8-0.4c0.4-0.3,0.8-0.4,0.8,0.3l0,0c0,0.4-0.1,0.7-0.4,0.8l0.4,0.7l-0.5,0.3 l-0.3-0.7l-0.3,0.1L631.8,336.7L631.8,336.7z M632,335.4c0.1-0.1,0.3-0.3,0.3-0.5l0,0c0-0.3-0.1-0.3-0.3-0.1l-0.3,0.1v0.7 L632,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M633.8,335.5l-0.7,0.4v-0.7l0.7-0.4V335.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_1_"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube_2_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_left_478_",
    className: "st218",
    points: "380.7,536.3 324.5,503.8 324.5,506.1 380.7,538.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_right_484_",
    className: "st190",
    points: "507.6,465.2 380.7,538.5 380.7,536.3 507.6,463.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_top_478_",
    className: "st190",
    points: "380.7,536.3 324.5,503.8 451.4,430.7 507.6,463.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st219",
    points: "375.1,533.1 381.1,533.1 447,449.3 393.8,463.9 324.5,503.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "329.4,503.3 329.4,496.2 451.1,433 502.8,455.8 502.8,462.8 380.9,533.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st220",
    points: "329.4,503.3 329.4,496.2 451.1,433 393.4,479.6 380.8,507.5 380.9,533.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "329.4,496.2 451.1,426 502.8,455.8 380.9,526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "492.1,456 381.1,520.1 340.2,496.5 451.2,432.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M492.7,456l-111.7,64.5l-41.4-24l111.7-64.5L492.7,456z M381.1,519.8L491.6,456l-40.4-23.3 l-110.5,63.8L381.1,519.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M429.8,462.4l-56.7,32.8c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l56.7-32.8 c0.1-0.1,0.4-0.1,0.7,0C430,462.1,430,462.3,429.8,462.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M437.8,466.9l-72.7,42c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l72.7-42c0.1-0.1,0.4-0.1,0.7,0 C438,466.6,438,466.7,437.8,466.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M486.2,455.2L438,483.1c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l48.2-27.9 c0.1-0.1,0.4-0.1,0.7,0C486.4,454.9,486.4,455.1,486.2,455.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M421,491.2l-43.2,24.9c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l43.2-24.9 c0.1-0.1,0.4-0.1,0.7,0C421.3,491,421.3,491.2,421,491.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M456.5,438.3L413,463.3c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l43.5-25.1 c0.1-0.1,0.4-0.1,0.7,0C456.7,438,456.7,438.2,456.5,438.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M473.4,447.5L443,465.1l-11.1-6.4l30.5-17.6L473.4,447.5z M442.8,464.4l29.3-16.9l-9.9-5.7L433,458.7 L442.8,464.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.3,467.3l0.8-0.5c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.3,0.4,0.3c0,0.1,0.1,0.1,0.1,0.3c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 l-0.8,0.5L402.3,467.3z M403.3,467.1l1.1,0.5l0.1-0.1c0.1-0.1,0.1-0.1,0.3-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1L403.3,467.1z M407,466.5l-0.7,0.4l0.3,0.3l-0.5,0.4l-1.2-1.5l0.7-0.4l2.6,0.7 l-0.5,0.4L407,466.5z M406.4,466.2l-0.9-0.3l0.4,0.5L406.4,466.2z M406,465.1l1.8-1.1l0.4,0.3l-0.5,0.4l1.4,0.8l-0.5,0.3 l-1.4-0.8l-0.5,0.4L406,465.1z M408,464l1.5-0.9l0.4,0.3l-0.9,0.5l0.3,0.1l0.9-0.5l0.4,0.3l-0.9,0.5l0.4,0.3l0.9-0.5 l0.4,0.3l-1.6,0.9L408,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.9,502.2l0.9-0.5c0.3-0.1,0.4-0.1,0.7-0.1s0.4,0,0.5,0.1c0.1,0.1,0.3,0.3,0.3,0.4 c0,0.1-0.1,0.3-0.4,0.4l-0.3,0.1l0.7,0.4l-0.5,0.3L352.9,502.2z M354.3,502.3l0.1-0.1c0.1,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.1 c0,0-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1L354.3,502.3z M357.2,501.4l-0.7,0.4l0.3,0.3l-0.5,0.4l-1.2-1.5l0.7-0.4l2.6,0.7 l-0.5,0.4L357.2,501.4z M356.7,501.3l-0.9-0.3l0.4,0.5L356.7,501.3z M356.2,500.3l0.7-0.4l0.9,0.1l-0.3-0.5l0.7-0.4l0.4,1.1 l0.8,0.4l-0.5,0.3l-0.8-0.4L356.2,500.3z M359.1,498.6l1.8-1.1l0.4,0.3l-0.5,0.4l1.4,0.8l-0.5,0.3l-1.4-0.8l-0.5,0.4 L359.1,498.6z M362,498c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5c0.3-0.1,0.7-0.3,0.9-0.3s0.7,0.1,0.9,0.3 c0.3,0.1,0.4,0.3,0.4,0.4s0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4s-0.4,0.3-0.7,0.3s-0.4,0-0.7,0 C362.4,498.3,362.3,498.1,362,498z M362.5,497.7c0.1,0.1,0.4,0.1,0.5,0.1s0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3 c0-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3 C362.3,497.5,362.4,497.6,362.5,497.7z M364,495.7l1.8-1.1l0.4,0.3l-0.5,0.4l1.4,0.8l-0.5,0.3l-1.4-0.8l-0.5,0.4L364,495.7z  M366.1,494.6l0.5-0.3l0.7,0.4l0.7-0.4l-0.7-0.4l0.5-0.3l1.9,1.1l-0.5,0.3l-0.8-0.4l-0.7,0.4l0.8,0.4l-0.5,0.3L366.1,494.6z  M368.2,493.3l1.5-0.9l0.4,0.3l-0.9,0.5l0.3,0.1l0.9-0.5l0.4,0.3l-0.9,0.5l0.4,0.3l0.9-0.5l0.4,0.3l-1.6,0.9L368.2,493.3z  M356.4,504.2c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5c0.3-0.1,0.7-0.3,0.9-0.3c0.3,0,0.7,0.1,0.9,0.3 c0.3,0.1,0.4,0.3,0.4,0.4c0,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4c-0.3,0.1-0.4,0.3-0.7,0.3s-0.4,0-0.7,0 C357,504.5,356.7,504.4,356.4,504.2z M357.1,504c0.1,0.1,0.4,0.1,0.5,0.1s0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3 c0-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3C356.7,503.7,356.8,503.8,357.1,504 z M359.7,503.6l-1.9-1.1l0.9-0.5c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.3,0.1 c0,0.1,0,0.1,0,0.3c0,0,0,0.1-0.1,0.1c0.1,0,0.1,0,0.3,0h0.1c0.1,0,0.1,0,0.1,0l0.8,0.1l-0.7,0.4l-0.9-0.1 c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0l0,0l0.8,0.4L359.7,503.6z M359.1,502.5l0.3-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1 c0,0,0,0-0.1-0.1h-0.1c-0.1,0-0.1,0-0.3,0.1l-0.3,0.1L359.1,502.5z M359.8,501.3l0.8-0.5c0.1-0.1,0.3-0.1,0.5-0.1 c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.3,0.4,0.3c0.1,0,0.1,0.1,0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3l-0.8,0.5L359.8,501.3z M360.9,501.1l1.1,0.5l0.1-0.1 c0.1-0.1,0.1-0.1,0.3-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1L360.9,501.1z M361.9,500 l1.5-0.9l0.4,0.3l-0.9,0.5l0.3,0.1l0.9-0.5l0.4,0.3l-0.9,0.5l0.4,0.3l0.9-0.5l0.4,0.3l-1.6,0.9L361.9,500z M365.6,500 l-1.9-1.1l0.9-0.5c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.3,0.1c0,0.1,0,0.1,0,0.3 c0,0,0,0.1-0.1,0.1c0.1,0,0.1,0,0.3,0h0.1c0.1,0,0.1,0,0.1,0l0.8,0.1l-0.7,0.4l-0.9-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0 l0,0l0.8,0.4L365.6,500z M365.1,499.1l0.3-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1h-0.1c-0.1,0-0.1,0-0.3,0.1 l-0.3,0.1L365.1,499.1z M367.5,497.9c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5c0.3-0.1,0.7-0.3,0.9-0.3 s0.7,0.1,0.9,0.3c0.3,0.1,0.4,0.3,0.4,0.4c0,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 s-0.4,0-0.7,0C367.9,498.1,367.8,498,367.5,497.9z M368.1,497.6c0.1,0.1,0.4,0.1,0.5,0.1s0.3,0,0.4-0.1 c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3 C367.8,497.3,367.9,497.5,368.1,497.6z M368.9,496l1.5-0.8l0.4,0.3L370,496l0.3,0.1l0.7-0.4l0.4,0.3l-0.7,0.4l0.8,0.4 l-0.5,0.3L368.9,496z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,465.8l0.8-0.5c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.3,0.4,0.3c0,0.1,0.1,0.1,0.1,0.3c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 l-0.8,0.5L443.9,465.8z M445,465.8l1.1,0.5l0.1-0.1c0.1-0.1,0.1-0.1,0.3-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1c-0.1,0-0.3,0-0.4,0.1L445,465.8z M446.9,465.2c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5 c0.3-0.1,0.7-0.3,0.9-0.3c0.3,0,0.7,0.1,0.9,0.3c0.3,0.1,0.4,0.3,0.4,0.4s0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4 c-0.3,0.1-0.4,0.3-0.7,0.3c-0.3,0-0.4,0-0.7,0C447.3,465.4,447,465.4,446.9,465.2z M447.4,464.8c0.1,0.1,0.4,0.1,0.5,0.1 c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1 c-0.1,0-0.1,0.1-0.1,0.3C447.2,464.7,447.3,464.8,447.4,464.8z M448.3,463.3l0.5-0.3l1.4,0.8l0.9-0.5l0.4,0.3l-1.5,0.8 L448.3,463.3z M450,462.4l0.5-0.3l1.4,0.8l0.9-0.5l0.4,0.3l-1.5,0.8L450,462.4z M454.5,461.6l-0.7,0.4l0.3,0.3l-0.5,0.4 l-1.2-1.5l0.7-0.4l2.6,0.7l-0.5,0.4L454.5,461.6z M453.9,461.4l-0.9-0.3l0.4,0.5L453.9,461.4z M455.6,461.3l-1.9-1.1 l0.9-0.5c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.3,0.1c0,0.1,0,0.1,0,0.3 c0,0,0,0.1-0.1,0.1c0.1,0,0.1,0,0.3,0h0.1c0.1,0,0.1,0,0.1,0l0.8,0.1l-0.7,0.4l-0.9-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0 l0,0l0.8,0.4L455.6,461.3z M455.2,460.2l0.3-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1h-0.1 c-0.1,0-0.1,0-0.3,0.1l-0.3,0.1L455.2,460.2z M456.9,459.8l0.5-0.4c0.1,0,0.1,0.1,0.3,0.1s0.3,0,0.4-0.1 c0.1,0,0.1-0.1,0.1-0.1v-0.1h-0.1c-0.1,0-0.3,0-0.4,0.1c-0.3,0.1-0.5,0.1-0.8,0.1s-0.4,0-0.5-0.1c-0.1,0-0.1-0.1-0.1-0.3 c0-0.1,0-0.1,0-0.3c0-0.1,0.1-0.1,0.4-0.3c0.3-0.1,0.4-0.3,0.7-0.3c0.3,0,0.4,0,0.7,0.1l-0.5,0.3c-0.1,0-0.1,0-0.3,0 s-0.1,0-0.3,0.1l-0.1,0.1c0,0,0,0,0,0.1h0.1c0,0,0.1,0,0.3-0.1c0.3-0.1,0.5-0.1,0.7-0.3c0.1,0,0.3,0,0.4,0 c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.1,0.3,0.3c0,0.1,0,0.1,0,0.3c0,0.1-0.1,0.1-0.4,0.3c-0.3,0.1-0.5,0.3-0.8,0.3 C457.3,460,457.2,459.8,456.9,459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.4,436.1c0.1,0,0.1,0.1,0.1,0.1s0,0.1-0.1,0.1l-0.9,0.5c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-3-1.8 c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1l0.8-0.5c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.8,0.4l-0.3,0.1l-0.7-0.4l-0.8,0.4l1.4,0.7 l0.8-0.5c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0L445.4,436.1z M445,436.3l-1.4-0.8l-0.8,0.4l1.4,0.8L445,436.3z M447.3,435 c0.1,0,0.1,0.1,0.1,0.1s0,0.1-0.1,0.1l-0.8,0.5c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-0.8-0.4l0.3-0.1l0.7,0.4l0.8-0.4l-1.4-0.7 l-0.8,0.5c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-1.5-0.8c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1l0.9-0.5c0.1,0,0.1,0,0.3,0 s0.1,0,0.3,0L447.3,435z M445.4,434.2l-1.4-0.8l-0.8,0.4l1.4,0.8L445.4,434.2z M448.7,434.5l-0.3,0.1l-2.4-2.3l-0.7,0.4 l0.5,0.3l-0.3,0.1l-0.8-0.4l1.4-0.8l0.1,0.1L448.7,434.5z M451,432.9c0.1,0,0.1,0.1,0.1,0.1s0,0.1-0.1,0.1l-0.9,0.5 c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-1.1-0.7c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.3l-0.5,0.1c-0.1,0-0.3,0-0.3,0l-0.9-0.5 c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1l0.9-0.5c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.9,0.5c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.3h0.5 c0.1,0,0.3,0,0.4,0L451,432.9z M450.6,433l-1.2-0.7l-0.7,0.1l-0.1,0.4l1.2,0.7L450.6,433z M448.7,431.9l-0.9-0.5l-0.8,0.4 l0.9,0.5l0.7-0.1L448.7,431.9z M382.3,518.1C382.4,518.1,382.4,518.2,382.3,518.1c0.1,0.1,0,0.3,0,0.3l-0.8,0.5 c0,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0c0.1,0,0.1,0,0.3,0 L382.3,518.1z M382,518.2l-2.7-1.6l-0.8,0.4l2.7,1.6L382,518.2z M384.2,517C384.2,517,384.2,517.1,384.2,517 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L384.2,517z M383.8,517.1l-2.7-1.6l-0.8,0.4l2.7,1.6L383.8,517.1z M386,515.9C386.1,516,386.1,516,386,515.9 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L386,515.9z M385.7,516l-2.7-1.6l-0.8,0.4l2.7,1.6L385.7,516z M387.9,514.8C387.9,514.9,388,514.9,387.9,514.8 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L387.9,514.8z M387.6,515.1l-2.7-1.6l-0.8,0.4l2.7,1.6L387.6,515.1z M389.6,513.9 C389.8,513.9,389.8,513.9,389.6,513.9c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c-0.1,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0l-1.1-0.7 c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.3h-0.5c-0.1,0-0.3,0-0.3,0l-0.9-0.5l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 c0.1,0,0.1,0,0.3,0l0.9,0.5c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.3h0.5c0.1,0,0.3,0,0.3,0L389.6,513.9z M389.3,514l-1.1-0.7 l-0.7,0.1l-0.1,0.4l1.1,0.7L389.3,514z M387.6,512.9l-0.9-0.5l-0.7,0.4l0.9,0.5l0.5-0.1L387.6,512.9z M390.8,512.4l-0.3,0.1 l0.8,0.5l-0.3,0.1l-0.8-0.5l-0.9,0.5l-0.1-0.1l-1.5-1.8l0.3-0.1l0,0l1.4,1.6l0.5-0.4l-1.2-0.7l0.3-0.1l1.2,0.7l0.3-0.1 L390.8,512.4z M393.1,511.8C393.1,511.8,393.3,512,393.1,511.8c0.1,0.1,0.1,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0 s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.7,0.4l-0.3,0.1l-0.7-0.4 l-0.7,0.4l1.2,0.7l0.8-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0L393.1,511.8z M392.9,512l-1.2-0.7l-0.7,0.4l1.2,0.7L392.9,512z  M394.9,510.7C395,510.7,395,510.9,394.9,510.7c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c-0.1,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0 l-1.1-0.7c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.3h-0.5c-0.1,0-0.3,0-0.3,0l-0.9-0.5l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5 c0,0,0.1,0,0.3,0s0.1,0,0.3,0l0.9,0.5c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.3h0.5c0.1,0,0.3,0,0.3,0L394.9,510.7z M394.6,510.9 l-1.1-0.7l-0.7,0.1l-0.1,0.4l1.1,0.7L394.6,510.9z M392.9,509.9l-0.9-0.5l-0.7,0.4l0.9,0.5l0.5-0.1L392.9,509.9z  M396.7,509.8C396.8,509.8,396.8,509.8,396.7,509.8c0.1,0.1,0.1,0.3,0,0.3l-0.8,0.4c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0 l-0.8-0.5l0.3-0.1l0.8,0.4l0.7-0.4l-1.5-0.9l-0.9,0.5l-1.5-0.8l1.2-0.7l0.3,0.1l-0.9,0.5l0.9,0.5l0.7-0.4c0.1,0,0.1,0,0.3,0 s0.1,0,0.3,0L396.7,509.8z M398.6,508.7C398.6,508.7,398.7,508.7,398.6,508.7c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0 s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L398.6,508.7z M398.3,508.8 l-2.7-1.6l-0.8,0.4l2.7,1.6L398.3,508.8z M400.5,507.6C400.5,507.6,400.5,507.8,400.5,507.6c0.1,0.1,0,0.3,0,0.3l-0.8,0.5 c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L400.5,507.6z  M400,507.8l-2.7-1.6l-0.8,0.4l2.7,1.6L400,507.8z M402.2,506.5C402.3,506.5,402.3,506.7,402.2,506.5c0.1,0.1,0,0.3,0,0.3 l-0.8,0.5c0,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0 L402.2,506.5z M401.9,506.7l-2.7-1.6l-0.8,0.4l2.7,1.6L401.9,506.7z M408.3,503C408.3,503.2,408.3,503.2,408.3,503 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L408.3,503z M407.9,503.3l-2.7-1.6l-0.8,0.4l2.7,1.6L407.9,503.3z M410.1,502.1 C410.2,502.1,410.2,502.1,410.1,502.1c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L410.1,502.1z M409.8,502.2l-2.7-1.6l-0.8,0.4l2.7,1.6L409.8,502.2z  M412,501C412,501,412.1,501,412,501c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L412,501z M411.7,501.1l-2.7-1.6l-0.8,0.4l2.7,1.6L411.7,501.1z  M413.9,499.9L413.9,499.9c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L413.9,499.9z M413.5,500l-2.7-1.6l-0.8,0.4l2.7,1.6L413.5,500z  M419,496.9C419,496.9,419.1,496.9,419,496.9c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L419,496.9z M418.6,497.1l-2.7-1.6l-0.8,0.4l2.7,1.6L418.6,497.1z  M420.8,495.8C420.9,495.8,420.9,495.8,420.8,495.8c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6 l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L420.8,495.8z M420.5,496l-2.7-1.6l-0.8,0.4l2.7,1.6 L420.5,496z M422.7,494.8C422.8,494.8,422.8,494.9,422.7,494.8c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0 l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L422.7,494.8z M422.4,494.9l-2.7-1.6l-0.8,0.4 l2.7,1.6L422.4,494.9z M424.6,493.7C424.6,493.7,424.6,493.8,424.6,493.7c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0 s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L424.6,493.7z M424.2,493.8 l-2.7-1.6l-0.8,0.4l2.7,1.6L424.2,493.8z M426.5,492.9l-1.4,0.8l-0.1-0.1l-1.1-1.8l-0.8-0.4l-0.7,0.4l0.7,0.4l-0.3,0.1 l-0.8-0.4l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.7,0.4c0.1,0,0.1,0.1,0.3,0.3l0.9,1.5 l0.9-0.5H426.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477,451.6c-2.8,2.8-5.1,5.8-6.9,8.9c-0.8,0.8-1.5,1.6-2.3,2.4h-0.1c-0.5,0.4-1.1,0.9-1.5,1.4 c-1.4,1.2-2.6,2.4-3.5,4.2c0.1-1.8,0.7-3,1.6-4.5c0,0,0-0.1-0.1-0.1s-0.3,0-0.3,0c-1.9,1.5-3.7,4.1-4.3,5.7 c0-0.9,0.3-2.3,1.4-3.8c0,0,0-0.1-0.1-0.1s-0.3,0-0.3,0l-5.6,5l-0.1,0.1c0.4-0.5,0.8-1.4,1.1-2h0.1c0.1,0,0.5,0,0.8-0.3 c0.5-0.4,0.7-1.4,0.4-1.6c-0.1-0.1-0.3-0.3-0.5-0.3c0.1-0.5,0.3-0.9,0.3-1.5c0,0,0-0.1-0.1-0.1s-0.1,0-0.3,0 c-0.5,0.5-1.1,1.2-1.5,1.9c-0.1,0-0.1,0-0.3,0.1c-0.1-0.1-0.1-0.3-0.3-0.4c-0.5-0.8-0.8-1.5-1.6-1.5c-0.5,0-0.8,0.5-0.5,3 c0,0,0,0-0.1,0c-0.8,0.5-1.6,0.9-1.9,1.4c-0.3,0.3-0.5,0.7-0.8,0.9c-0.4,0.8,0.4,1.5,1.4,1.6c0.5,0.1,1.2,0.1,1.9,0 c0,0,0,0,0,0.1c0.1,0.8,0.1,1.8-0.4,2.7c-0.5,0.8-1.9,1.5-3.5,1.8s-3.4,0.1-4.6-0.4c-0.1,0-0.3,0-0.3,0c-0.1,0,0,0.1,0,0.1 c1.4,0.5,3.1,0.8,5,0.5c1.8-0.3,3.3-0.9,3.8-1.9c0.5-0.9,0.5-1.9,0.4-2.7c0,0,0-0.1,0-0.3c0.1-0.1,0.3-0.1,0.4-0.3 c0.1,0,0.1,0,0.1,0l5.8-5.3c-0.8,1.5-0.9,3-0.5,3.7c0,0,0.1,0.1,0.3,0.1s0.1,0,0.1-0.1c0.3-1.2,1.8-3.8,3.5-5.6 c-0.8,1.5-1.1,2.8-1.2,4.9l0.1,0.1c0.1,0,0.3,0,0.3-0.1c0.5-1.6,1.6-2.8,2.7-4.1c-0.1,0.4-0.3,0.8-0.4,1.1 c0,0,0,0.1,0.1,0.1c0.1,0,0.3,0,0.3-0.1c1.2-1.8,2.6-3.5,4.2-5.3c-0.5,1.1-1.1,2.3-1.5,3.4c0,0.1-1.6,4.3-0.3,5 c0.1,0.1,0.4,0.1,0.8,0c0.1,0,0.1,0,0.3-0.1c0.7-0.4,0.9-1.8,1.2-3.9c0.3-2.3,0.7-5.1,2.2-7c0,0,0-0.1-0.1-0.1s-0.3,0-0.3,0 c-0.1,0.1-0.4,0.4-0.5,0.5c1.6-2.7,3.8-5.3,6.2-7.7c0,0,0-0.1-0.1-0.1C477.1,451.6,477,451.6,477,451.6z M456.8,467.1 c0.1,0.3,0.1,1.1-0.4,1.4c-0.1,0.1-0.3,0.1-0.4,0.1h-0.1c0.3-0.5,0.4-1.1,0.5-1.5l0,0C456.7,467.1,456.7,467.1,456.8,467.1z  M456.4,465.9c0,0.3-0.1,0.5-0.3,0.9c-0.1,0-0.4,0.1-0.5,0.1C455.7,466.6,456,466.2,456.4,465.9z M455.3,467.4 c0.3-0.1,0.5-0.1,0.8-0.3c-0.1,0.4-0.3,0.8-0.5,1.2c-0.1-0.1-0.4-0.3-0.5-0.5C455,467.7,455.2,467.5,455.3,467.4z  M452.9,465.8L452.9,465.8c0.4,0,0.8,0.7,1.1,1.4c0.1,0.1,0.1,0.3,0.3,0.4c-0.5,0.3-1.1,0.5-1.5,0.8 C452.6,466.7,452.7,465.9,452.9,465.8z M452.9,472.3c-0.5,0.1-1.2,0.1-1.6,0c-0.8-0.1-1.5-0.7-1.2-1.4 c0.1-0.3,0.4-0.7,0.7-0.9c0.3-0.3,0.9-0.7,1.6-1.2c0.1,0.8,0.3,1.8,0.4,3C452.9,472,452.9,472.1,452.9,472.3z M453.5,471.9 c-0.1,0.1-0.1,0.1-0.3,0.1c0-0.1,0-0.1,0-0.3c-0.3-1.4-0.4-2.4-0.4-3.3c0.5-0.3,1.1-0.5,1.6-0.8l0.1,0.1 C453.8,469.2,453.4,470.7,453.5,471.9z M454.8,468.2c0.1,0.3,0.4,0.4,0.5,0.5c-0.4,0.9-0.9,1.9-1.5,2.6 C453.9,470.4,454.4,469.3,454.8,468.2z M466,465.1c0.1-0.1,0.3-0.4,0.4-0.5l0,0C466.3,464.7,466.1,464.8,466,465.1z  M469.4,466c-0.3,1.9-0.5,3.7-1.2,3.8c-0.3,0-0.3,0-0.4,0c-0.8-0.4-0.3-3,0.4-4.7c0.5-1.5,1.4-3.1,2.2-4.6 c0.1-0.1,0.3-0.3,0.5-0.4C469.9,461.9,469.7,464.2,469.4,466z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M450.4,427.7l-118.6,68.5l49.3,28.4l119.4-68.9l-48.5-28l-0.8-0.4L450.4,427.7z M497.4,455.8 l-116.5,67.2l-46.2-26.7l116.5-67.2L497.4,455.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M407.1,537.6c-0.4-0.3-0.8-0.3-1.1,0c-1.1,0.9-0.1,2.8,0.9,3.5c0.5,0.3,0.9,0.3,1.2,0.1 c0.4-0.1,0.5-0.5,0.5-1.1C408.6,539.2,407.9,538,407.1,537.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027576187698337415580000018319790648523205048_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.2327,
    y1: 236.7037,
    x2: 474.7295,
    y2: 225.4509,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4559,
    style: {
      stopColor: "#485654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4776,
    style: {
      stopColor: "#485654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    style: {
      stopColor: "#485654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#4E5453"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    style: {
      stopColor: "#454748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    style: {
      stopColor: "#2A292A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027576187698337415580000018319790648523205048_)"
    },
    d: "M535.3,468.6L535.3,468.6 C535.3,468.6,535.3,468.5,535.3,468.6C535.3,468.5,535.3,468.5,535.3,468.6c0-0.1,0-0.3,0-0.4c0-0.5-0.1-1.1-0.3-1.6 c0-0.1,0-0.1-0.1-0.3c-0.1-0.5-0.4-0.9-0.5-1.4c0-0.1-0.1-0.3-0.1-0.3c-0.3-0.4-0.4-0.7-0.7-1.1c-0.1-0.1-0.1-0.3-0.3-0.3 c-0.3-0.4-0.7-0.7-0.9-0.9c-0.1-0.1-0.1-0.1-0.3-0.3c-0.5-0.4-0.9-0.7-0.9-0.7c-0.5-0.3-2.2-1.1-3.8-0.3h-0.1l0,0 c-0.7,0.4-62.4,36-97.5,59c-11.8,7.7-17.1,11.6-20.3,14.4c0,0-0.3,0.3-0.4,0.4c-0.3,0.3-0.4,0.7-0.4,1.1c0,1.2,0.8,2.6,1.9,3.3 c0.3,0.1,0.7,0.3,1.2,0.1l0,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0.5-0.3,1.2-0.5,2.2-0.8c2.8-1.1,7.4-3.3,16.7-8 c8.7-4.5,21.3-11.4,40-21.9c27.4-15.4,62.2-36,62.7-36.4l0,0l0.1-0.1c0.5-0.3,0.8-0.8,1.1-1.2c0.1-0.1,0.1-0.3,0.3-0.5 c0-0.1,0-0.1,0-0.3c0-0.3,0.1-0.5,0.1-0.7s0-0.3,0-0.4C535.3,468.9,535.3,468.8,535.3,468.6L535.3,468.6z"
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M410.3,535.1c-0.5-0.3-1.1-0.3-1.4,0l-3,2.4c0.3-0.3,0.7-0.3,1.1,0c0.8,0.4,1.5,1.6,1.5,2.6 c0,0.5-0.1,0.9-0.5,1.1l3.7-1.5c0.4-0.1,0.7-0.7,0.7-1.4C412.2,537.1,411.4,535.7,410.3,535.1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M406.7,538.1c-0.4-0.3-0.7-0.1-0.9,0c-0.7,0.7-2.6,2.4-3,2.8c0.1-0.1,0.3-0.1,0.4,0 c0.3,0.1,0.5,0.5,0.5,0.9c0,0.1-0.1,0.3-0.1,0.4c0.5-0.1,3-0.9,3.9-1.2c0.3-0.1,0.4-0.4,0.4-0.8 C407.9,539.3,407.4,538.5,406.7,538.1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M403.2,540.9c-0.1-0.1-0.3-0.1-0.4,0c-0.3,0.3-0.5,0.5-0.5,0.7c-0.1,0.4,0.3,0.5,0.3,0.7 c0.3,0.1,0.7,0,1.1-0.1c0.1,0,0.1-0.1,0.1-0.4C403.7,541.5,403.4,541.1,403.2,540.9z"
  }))), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "528.3,466.7 488.5,489.7 485.2,487.9 525,464.8  "
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "520.3,468.2 517.6,466.7 525.2,465.1 527.8,466.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "488.2,487.4 485.5,486 485.5,485.3 488.2,486.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "488.2,486.8 485.5,485.3 517.6,466.7 520.3,468.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "520.3,468.2 527.8,466.6 518.5,471.9 516.9,470.9 488.2,487.4 488.2,486.8  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M584.5,613.3l10.4-6c0.5-0.3,0.9,0,0.9,0.5v0.3c0,0.5-0.4,1.2-0.9,1.5l-10.4,6c-0.5,0.3-0.9,0-0.9-0.5 v-0.3C583.5,614.2,584,613.5,584.5,613.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M583,613.9c0-0.1,0.1-0.4,0.3-0.5c0.1-0.1,0.3-0.4,0.5-0.4l10.4-6c0.3-0.1,0.4-0.1,0.7,0l0.7,0.4 c-0.1-0.1-0.4-0.1-0.7,0l-10.4,6c-0.1,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.3,0.4-0.3,0.5c0,0.1-0.1,0.4-0.1,0.5v0.3 c0,0.3,0.1,0.5,0.3,0.5l-0.7-0.4c-0.1-0.1-0.3-0.3-0.3-0.5v-0.3C583,614.2,583,614.1,583,613.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M572.8,619.4c0.1-0.1,0.3-0.4,0.5-0.4l4.9-2.8c0.3-0.1,0.4-0.1,0.7,0l0.7,0.4c-0.1-0.1-0.4-0.1-0.7,0 l-4.9,2.8c-0.1,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.3,0.4-0.3,0.5s-0.1,0.4-0.1,0.5v0.3c0,0.3,0.1,0.5,0.3,0.5l-0.7-0.4 c-0.1-0.1-0.3-0.3-0.3-0.5v-0.3c0-0.1,0-0.3,0.1-0.5C572.7,619.8,572.7,619.5,572.8,619.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M574.1,619.2l4.9-2.8c0.5-0.3,0.9,0,0.9,0.5v0.3c0,0.5-0.4,1.2-0.9,1.5l-4.9,2.8 c-0.5,0.3-0.9,0-0.9-0.5v-0.3C573.1,620.2,573.5,619.5,574.1,619.2z"
  }))), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "602.6,608.4 494.4,671.1 490.8,668.9 602.6,604.2 690.4,654.7 686.7,656.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147216875471523287950000001405833023483753093_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.4174,
    y1: 93.7552,
    x2: 763.2864,
    y2: 93.7552,
    gradientTransform: "matrix(-1 0 0 -1 1329.5864 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0ACB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B9BB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147216875471523287950000001405833023483753093_)"
    },
    points: "602.6,607.6 492.7,671.2  490.8,670 602.6,605.3 690.4,655.6 688.5,656.9  "
  }), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "690.5,655.5 572.4,723.6 484.6,673 602.6,604.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101814543987015048840000013362269047609182600_",
    gradientUnits: "userSpaceOnUse",
    x1: 562.8216,
    y1: 42.039,
    x2: 582.6575,
    y2: 42.039,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#B2B3B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5565,
    style: {
      stopColor: "#D4D8D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101814543987015048840000013362269047609182600_)"
    },
    d: "M483.3,673.5c0,1.2,0.8,2.3,2.3,3.3 l79.2,45.6c3.1,1.8,8.1,1.8,11.1,0l115.7-67c1.5-0.9,2.3-2,2.3-3.3v4.1c0,1.2-0.8,2.3-2.3,3.3l-115.7,67c-3.1,1.8-8,1.8-11.1,0 l-79.2-45.6c-1.5-0.9-2.3-2-2.3-3.3V673.5z"
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M485.6,676.8l79.2,45.6c3.1,1.8,8.1,1.8,11.1,0l115.7-67c3.1-1.8,3-4.7,0-6.5l-79.2-45.5 c-3.1-1.8-8.1-1.8-11.1,0l-115.7,67C482.5,672.2,482.5,675,485.6,676.8z M490.8,668.9l112-64.7l87.6,50.5l-112,64.7 L490.8,668.9z"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M523.4,694l1.9-1.1c0.9-0.5,2.6-0.5,3.5,0.1l6.8,3.9c0.4,0.3,0.7,0.4,0.8,0.7c0.4,0.7,0.1,1.4-0.5,1.8 l-1.9,1.1c-0.9,0.5-2.6,0.5-3.5-0.1l-6.8-3.9c-0.4-0.3-0.7-0.4-0.8-0.7C522.6,695.1,522.7,694.4,523.4,694z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M523.4,694.7l1.9-1.1c0.9-0.5,2.6-0.5,3.5,0.1l6.8,3.9c0.4,0.3,0.7,0.4,0.8,0.7c0,0.1,0.1,0.3,0.1,0.3 c-0.1,0.3-0.3,0.5-0.7,0.8l-1.9,1.1c-0.9,0.5-2.6,0.5-3.5-0.1l-6.8-3.9c-0.4-0.3-0.7-0.4-0.8-0.7c0-0.1-0.1-0.3-0.1-0.3 C522.9,695.1,523.1,694.8,523.4,694.7z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M647.2,628.3c0.9,0.5,2.4,0.5,3.4,0s0.9-1.4,0-1.9s-2.4-0.5-3.4,0S646.3,627.7,647.2,628.3z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M647.7,627.9c0.5,0.4,1.5,0.3,2.2,0s0.5-0.9,0-1.2c-0.5-0.4-1.5-0.4-2.2,0 C647.2,627.1,647.2,627.6,647.7,627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M648.1,627.6c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7s-0.8-0.1-1.2,0 C647.9,627.1,647.9,627.3,648.1,627.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M648.7,627.3c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0.1-0.1,0-0.3c-0.1-0.1-0.3-0.1-0.4,0 C648.6,627.1,648.6,627.2,648.7,627.3z"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "683.8,655.2 578.8,715.8 504.9,673.1 609.8,612.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M552.3,673.4l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C554.6,669.9,554.6,672,552.3,673.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M563.8,679.9l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C566.1,676.5,566.1,678.5,563.8,679.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M575.2,686.5l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C577.5,683,577.5,685.2,575.2,686.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M586.5,693.2L563,706.7l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C588.8,689.6,588.8,691.8,586.5,693.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M598,699.7l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0C600.3,696.3,600.3,698.4,598,699.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "609.8,612.6 504.9,673.1 497.8,669.1 602.8,608.5  "
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M560,657.1l-0.7-0.4c-4.5-2.6-4.7-4.6-1.5-6.5c3.4-1.9,6.8-1.8,11.2,0.8l0.7,0.4c4.5,2.6,4.7,4.6,1.4,6.5 C568,659.8,564.5,659.7,560,657.1z M569.1,656.6c1.6-0.9,0.7-2-1.9-3.5l-0.7-0.4c-2.6-1.5-4.5-2-6.1-1.1l-0.1,0.1 c-1.6,0.9-0.7,2,1.9,3.5l0.7,0.4c2.6,1.5,4.5,2,6.2,1.1V656.6z M587.1,648.6l-2.8,1.6l-12.2-2.2l2.7,1.5l5.4,3.1l-2.6,1.5 l-12.9-7.4l2.8-1.6l12.2,2.2l-2.7-1.5l-5.4-3.1l2.6-1.5L587.1,648.6z M589,647.5l-12.9-7.4l2.7-1.5l10.6,6.1l4.7-2.7l2.3,1.4 L589,647.5z M600.3,640.9l-2.7,1.5l-12.9-7.4l2.7-1.5L600.3,640.9z M611.7,634.4l-2.8,1.6l-12.2-2.2l2.7,1.5l5.4,3.1l-2.6,1.5 l-12.9-7.4l2.8-1.6l12.2,2.2l-2.7-1.5l-5.4-3.1l2.6-1.5L611.7,634.4z M608.6,621.2l2.3,1.4l-5.3,3l2.8,1.6l4.3-2.6l2.3,1.4 l-4.3,2.6l3.1,1.8l5.3-3l2.3,1.4l-7.9,4.6l-12.9-7.4L608.6,621.2z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "578.7,627.1 530.9,654.7 529.2,653.8 577,626.1  "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M584.1,662.3l-0.3-0.1c-1.1-0.7-2.3-0.7-3.4-0.5c0.3-0.5,0.1-1.1-0.8-1.6l-0.3-0.1 c-2.4-1.4-4.6-0.7-6.2,0.3l-3.4,2l10.4,6l3.5-2C585.3,665.1,586.7,663.8,584.1,662.3z M577.2,662.6l-1.2,0.7l-2.3-1.4l1.2-0.7 c0.5-0.3,1.4-0.5,2.2-0.1l0.1,0.1C578.1,661.7,577.7,662.3,577.2,662.6z M581.8,665l-1.5,0.8l-2.6-1.5l1.5-0.8 c0.5-0.4,1.5-0.5,2.4,0l0.1,0.1C582.7,664,582.3,664.6,581.8,665z M583,654.4l-3,1.8l7.9,7.6l2.3-1.4l-1.8-1.6l2.6-1.5l2.7,0.9 l2.3-1.4L583,654.4z M586.9,659.4l-3-2.7l4.7,1.8L586.9,659.4z M604.5,654l-2.3,1.4l-9.9-1.8l2.2,1.2l4.3,2.6l-2,1.2l-10.4-6 l2.3-1.4l9.8,1.8l-2.2-1.2l-4.3-2.6l2-1.2L604.5,654z M602,648.2l-1.5-3.8l2.6-1.5l1.2,4.1l9.2,1.9l-2.4,1.4l-6.1-1.4l0.4,1.2 l3,1.8l-2.2,1.2l-10.4-6l2.2-1.2L602,648.2z M616.6,647l-2.2,1.2l-10.4-6l2.2-1.2L616.6,647z M625.8,641.7l-2.3,1.4l-9.9-1.8 l2.2,1.2l4.3,2.6l-2,1.2l-10.4-6l2.3-1.4l9.8,1.8l-2.2-1.2l-4.3-2.6l2-1.2L625.8,641.7z M622.1,638l-0.5-0.3 c-3.7-2-3.8-3.7-1.1-5.3c2.4-1.5,4.9-1.6,7.4-0.1l0.5,0.3l-2.2,1.2c-1.5-0.8-2.6-1.1-3.8-0.4l-0.1,0.1c-1.5,0.8-0.7,1.8,1.5,2.8 l0.5,0.3c2,1.2,3.7,1.6,5.1,0.8l0.1-0.1c0.7-0.4,0.9-0.7,0.9-1.1l-1.6-0.9l-1.4,0.8l-1.9-1.1l3.5-2l4.6,2.7 c-0.1,0.8-0.7,1.8-2.4,2.8C628.5,640.3,625.8,640.2,622.1,638z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M635.4,644.4l-42.1,24.4l-0.5-0.4l42.1-24.4L635.4,644.4z M637,645.4l-49.3,28.4l0.5,0.4l49.3-28.4 L637,645.4z M639.2,646.6L589.9,675l0.5,0.4l49.3-28.4L639.2,646.6z M641.4,647.8l-49.3,28.4l0.5,0.4l49.3-28.4L641.4,647.8z  M643.5,649l-49.3,28.4l0.5,0.4l49.3-28.4L643.5,649z M645.7,650.4l-49.3,28.4l0.5,0.4l49.3-28.4L645.7,650.4z M647.9,651.6 L598.6,680l0.5,0.4l49.3-28.4L647.9,651.6z M650,652.8l-49.3,28.4l0.5,0.4l49.3-28.4L650,652.8z M652.3,654.2l-49.4,28.4l0.5,0.4 l49.3-28.4L652.3,654.2z M654.5,655.4l-49.3,28.4l0.5,0.4l49.3-28.4L654.5,655.4z M656.7,656.6L607.4,685l0.5,0.4l49.3-28.4 L656.7,656.6z M658.8,657.8l-49.3,28.4l0.5,0.4l49.3-28.4L658.8,657.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "429.9,124.9 565.7,203.5 625.7,168.8 625.7,137.9 429.9,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "429.9,124.9 565.7,203.5 565.7,172.5 429.9,94.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M565.7,192.9l60-34.7v1.1L566,193.9l-0.3,0.1l-136-78.5v-0.9L565.7,192.9z M429.9,111v1.1l136,78.5l0.3-0.1 l59.7-34.5v-1.1l-60,34.7L429.9,111z M429.9,117.9v1.1l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7L429.9,117.9z M429.9,122.5 l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7l-136-78.5L429.9,122.5L429.9,122.5z M429.9,107.6v1.1l136,78.5l0.3-0.1l59.7-34.5 v-1.1l-60,34.7L429.9,107.6z M429.9,97.2v1.1l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7L429.9,97.2z M429.9,100.7v1.1l136,78.5 l0.3-0.1l59.7-34.5v-1.1l-60,34.7L429.9,100.7z M429.9,104.1v1.1l136,78.5l0.3-0.1l59.7-34.5V148l-60,34.7L429.9,104.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st230",
    points: "572.8,106.4 572.8,109.4 569.1,106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "429.9,94.1 565.7,172.5 625.7,137.9 489.9,59.4  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M435.2,93.9c-0.1-0.1-0.1-0.3,0-0.4l53.9-31c0.1-0.1,0.4-0.1,0.7,0l24.9,14.4c0.1,0.1,0.1,0.3,0,0.4 l-53.8,31c-0.1,0.1-0.4,0.1-0.7,0L435.2,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M514.4,77.1l-53.8,31l-25.1-14.4l53.9-31L514.4,77.1L514.4,77.1z M515,76.7L489.4,62l-55.1,31.7 l26.3,15.2l0,0L515,77.4C515.4,77.3,515.4,77,515,76.7L515,76.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M520.4,143.1c-0.1-0.1-0.1-0.3,0-0.4l53.9-31c0.1-0.1,0.4-0.1,0.7,0l45.4,26.1c0.1,0.1,0.1,0.3,0,0.4 l-53.8,31c-0.1,0.1-0.4,0.1-0.7,0L520.4,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M619.9,138.1l-53.8,31L520.8,143l53.9-31L619.9,138.1L619.9,138.1z M620.6,137.7l-45.9-26.5L519.4,143 l46.6,26.8l0,0l54.4-31.4C620.9,138.2,620.9,137.9,620.6,137.7L620.6,137.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "600.8,146.7 565.7,166.9 528.9,145.7 564,125.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,134.7 572.6,133.7 574.4,132.7 576,133.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,135.6 574.4,134.7 576,133.7 577.8,134.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "586.5,141.7 584.8,140.7 586.5,139.7 588.2,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "570.9,134.7 569.1,133.7 570.9,132.7 572.6,133.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,137.7 574.4,136.7 576,135.6 577.8,136.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "579.6,139.7 577.8,138.8 579.6,137.7 581.3,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,140.7 579.6,139.7 581.3,138.8 583.1,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "584.8,142.7 583.1,141.7 584.8,140.7 586.5,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "586.5,143.8 584.8,142.7 586.5,141.7 588.2,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.1,135.6 567.4,134.7 569.1,133.7 570.9,134.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,138.8 572.6,137.7 574.4,136.7 576,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,142.7 579.6,141.7 581.3,140.7 583.1,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "583.1,143.8 581.3,142.7 583.1,141.7 584.8,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "584.8,144.7 583.1,143.8 584.8,142.7 586.5,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.1,137.7 567.4,136.7 569.1,135.6 570.9,136.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,140.7 572.6,139.7 574.4,138.8 576,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,142.7 576,141.7 577.8,140.7 579.6,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,144.7 579.6,143.8 581.3,142.7 583.1,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "583.1,145.7 581.3,144.7 583.1,143.8 584.8,144.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "567.4,138.8 565.7,137.7 567.4,136.7 569.1,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "570.9,140.7 569.1,139.7 570.9,138.8 572.6,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,141.7 570.9,140.7 572.6,139.7 574.4,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,143.8 574.4,142.7 576,141.7 577.8,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,144.7 576,143.8 577.8,142.7 579.6,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,146.7 579.6,145.7 581.3,144.7 583.1,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "555.3,133.7 553.6,132.7 555.3,131.7 557.1,132.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "557.1,134.7 555.3,133.7 557.1,132.7 558.7,133.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,136.7 558.7,135.6 560.5,134.7 562.2,135.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,138.8 562.2,137.7 564,136.7 565.7,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.1,141.7 567.4,140.7 569.1,139.7 570.9,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,143.8 570.9,142.7 572.6,141.7 574.4,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,145.7 574.4,144.7 576,143.8 577.8,144.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,146.7 576,145.7 577.8,144.7 579.6,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,148.8 579.6,147.7 581.3,146.7 583.1,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "586.5,151.8 584.8,150.7 586.5,149.7 588.2,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "553.6,134.7 551.8,133.7 553.6,132.7 555.3,133.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "562.2,139.7 560.5,138.8 562.2,137.7 564,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,140.7 562.2,139.7 564,138.8 565.7,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,141.7 564,140.7 565.7,139.7 567.4,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "570.9,144.7 569.1,143.8 570.9,142.7 572.6,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,146.7 572.6,145.7 574.4,144.7 576,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,147.7 574.4,146.7 576,145.7 577.8,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,150.7 579.6,149.7 581.3,148.8 583.1,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "555.3,137.7 553.6,136.7 555.3,135.6 556.9,136.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,138.8 555.3,137.7 556.9,136.7 558.7,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,139.7 556.9,138.8 558.7,137.7 560.5,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,143.8 564,142.7 565.7,141.7 567.4,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.1,145.7 567.4,144.7 569.1,143.8 570.9,144.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,148.8 572.6,147.7 574.4,146.7 576,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,149.7 574.4,148.8 576,147.7 577.8,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,150.7 576,149.7 577.8,148.8 579.6,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "579.6,151.8 577.8,150.7 579.6,149.7 581.3,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,152.7 579.6,151.8 581.3,150.7 583.1,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "584.8,154.7 583.1,153.8 584.8,152.7 586.5,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,140.7 555.3,139.7 556.9,138.8 558.7,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,141.7 556.9,140.7 558.7,139.7 560.5,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "562.2,143.8 560.5,142.7 562.2,141.7 564,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,145.7 564,144.7 565.7,143.8 567.4,144.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "567.4,146.7 565.7,145.7 567.4,144.7 569.1,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "570.9,148.8 569.1,147.7 570.9,146.7 572.6,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,149.7 570.9,148.8 572.6,147.7 574.4,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,151.8 574.4,150.7 576,149.7 577.8,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "581.3,154.7 579.6,153.8 581.3,152.7 583.1,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.3,137.7 546.6,136.7 548.3,135.6 550,136.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "550,138.8 548.3,137.7 550,136.7 551.8,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "551.8,139.7 550,138.8 551.8,137.7 553.6,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "553.6,140.7 551.8,139.7 553.6,138.8 555.3,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,142.7 555.3,141.7 556.9,140.7 558.7,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,143.8 556.9,142.7 558.7,141.7 560.5,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,144.7 558.7,143.8 560.5,142.7 562.2,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,146.7 562.2,145.7 564,144.7 565.7,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "570.9,150.7 569.1,149.7 570.9,148.8 572.6,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,154.7 576,153.8 577.8,152.7 579.6,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "546.6,138.8 544.9,137.7 546.6,136.7 548.3,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "551.8,141.7 550,140.7 551.8,139.7 553.6,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "555.3,143.8 553.6,142.7 555.3,141.7 556.9,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,144.7 555.3,143.8 556.9,142.7 558.7,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,145.7 556.9,144.7 558.7,143.8 560.5,144.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "562.2,147.7 560.5,146.7 562.2,145.7 564,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,149.7 564,148.8 565.7,147.7 567.4,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "567.4,150.7 565.7,149.7 567.4,148.8 569.1,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,153.8 570.9,152.7 572.6,151.8 574.4,152.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,154.7 572.6,153.8 574.4,152.7 576,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,155.7 574.4,154.7 576,153.8 577.8,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,156.8 576,155.7 577.8,154.7 579.6,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "544.9,139.7 543.1,138.8 544.9,137.7 546.6,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "550,142.7 548.3,141.7 550,140.7 551.8,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "551.8,143.8 550,142.7 551.8,141.7 553.6,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,148.8 558.7,147.7 560.5,146.7 562.2,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "562.2,149.7 560.5,148.8 562.2,147.7 564,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,155.7 570.9,154.7 572.6,153.8 574.4,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,157.7 574.4,156.8 576,155.7 577.8,156.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "577.8,158.8 576,157.7 577.8,156.8 579.6,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "543.1,140.7 541.4,139.7 543.1,138.8 544.9,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "546.6,142.7 544.9,141.7 546.6,140.7 548.3,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.3,143.8 546.6,142.7 548.3,141.7 550,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "555.3,147.7 553.6,146.7 555.3,145.7 556.9,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,152.7 562.2,151.8 564,150.7 565.7,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.1,155.7 567.4,154.7 569.1,153.8 570.9,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "574.4,158.8 572.6,157.7 574.4,156.8 576,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576,159.7 574.4,158.8 576,157.7 577.8,158.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "541.4,141.7 539.6,140.7 541.4,139.7 543.1,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "555.3,149.7 553.6,148.8 555.3,147.7 556.9,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,150.7 555.3,149.7 556.9,148.8 558.7,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,151.8 556.9,150.7 558.7,149.7 560.5,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,154.7 562.2,153.8 564,152.7 565.7,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,155.7 564,154.7 565.7,153.8 567.4,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,159.7 570.9,158.8 572.6,157.7 574.4,158.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "550,148.8 548.3,147.7 550,146.7 551.8,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "551.8,149.7 550,148.8 551.8,147.7 553.6,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,152.7 555.3,151.8 556.9,150.7 558.7,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,153.8 556.9,152.7 558.7,151.8 560.5,152.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,154.7 558.7,153.8 560.5,152.7 562.2,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,156.8 562.2,155.7 564,154.7 565.7,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,157.7 564,156.8 565.7,155.7 567.4,156.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "572.6,161.8 570.9,160.7 572.6,159.7 574.4,160.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.3,149.7 546.6,148.8 548.3,147.7 550,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "550,150.7 548.3,149.7 550,148.8 551.8,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "551.8,151.8 550,150.7 551.8,149.7 553.6,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,154.7 555.3,153.8 556.9,152.7 558.7,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,156.8 558.7,155.7 560.5,154.7 562.2,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,158.8 562.2,157.7 564,156.8 565.7,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,159.7 564,158.8 565.7,157.7 567.4,158.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "567.4,160.7 565.7,159.7 567.4,158.8 569.1,159.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.1,161.8 567.4,160.7 569.1,159.7 570.9,160.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "570.9,162.7 569.1,161.8 570.9,160.7 572.6,161.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "550,152.7 548.3,151.8 550,150.7 551.8,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "553.6,154.7 551.8,153.8 553.6,152.7 555.3,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "555.3,155.7 553.6,154.7 555.3,153.8 556.9,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,158.8 558.7,157.7 560.5,156.8 562.2,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,160.7 562.2,159.7 564,158.8 565.7,159.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "565.7,161.8 564,160.7 565.7,159.7 567.4,160.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "543.1,150.7 541.4,149.7 543.1,148.8 544.9,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "546.6,146.7 544.9,145.7 546.6,144.7 548.3,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "544.9,151.8 543.1,150.7 544.9,149.7 546.6,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.3,153.8 546.6,152.7 548.3,151.8 550,152.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "553.6,156.8 551.8,155.7 553.6,154.7 555.3,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.7,159.7 556.9,158.8 558.7,157.7 560.5,158.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "562.2,161.8 560.5,160.7 562.2,159.7 564,160.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "541.4,151.8 539.6,150.7 541.4,149.7 543.1,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "543.1,152.7 541.4,151.8 543.1,150.7 544.9,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "546.6,154.7 544.9,153.8 546.6,152.7 548.3,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.3,155.7 546.6,154.7 548.3,153.8 550,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "550,156.8 548.3,155.7 550,154.7 551.8,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "553.6,158.8 551.8,157.7 553.6,156.8 555.3,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "556.9,160.7 555.3,159.7 556.9,158.8 558.7,159.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "560.5,162.7 558.7,161.8 560.5,160.7 562.2,161.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M538,141.7l-6.9,4.1l6.9,4.1l6.9-4.1L538,141.7z M538,148.4l-4.6-2.7l4.6-2.7l4.6,2.7L538,148.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "538,144 535,145.7 538,147.4 540.8,145.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M564,126.7l-6.9,4.1l6.9,4.1l6.9-4.1L564,126.7z M564,133.3l-4.6-2.7l4.6-2.7l4.6,2.7L564,133.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "564,129 561.1,130.6 564,132.4 566.8,130.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.7,142.7l-6.9,4.1l6.9,4.1l6.9-4.1L591.7,142.7z M591.7,149.5l-4.6-2.7l4.6-2.7l4.6,2.7L591.7,149.5 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "591.7,145.1 588.9,146.7 591.7,148.4 594.6,146.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "511.6,76.9 490.4,89.1 468.2,76.2 489.4,64  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,69.7 494.6,69 495.6,68.5 496.7,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,70.2 495.6,69.7 496.7,69 497.8,69.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.9,73.9 502,73.2 502.9,72.7 504,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.6,69.7 492.5,69 493.6,68.5 494.6,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,71.4 495.6,70.8 496.7,70.2 497.8,70.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.7,72.7 497.8,72 498.7,71.4 499.8,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,73.2 498.7,72.7 499.8,72 500.9,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502,74.4 500.9,73.9 502,73.2 502.9,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.9,75.1 502,74.4 502.9,73.9 504,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492.5,70.2 491.5,69.7 492.5,69 493.6,69.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,72 494.6,71.4 495.6,70.8 496.7,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,74.4 498.7,73.9 499.8,73.2 500.9,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.9,75.1 499.8,74.4 500.9,73.9 502,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502,75.6 500.9,75.1 502,74.4 502.9,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492.5,71.4 491.5,70.8 492.5,70.2 493.6,70.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,73.2 494.6,72.7 495.6,72 496.7,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,74.4 496.7,73.9 497.8,73.2 498.7,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,75.6 498.7,75.1 499.8,74.4 500.9,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.9,76.2 499.8,75.6 500.9,75.1 502,75.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "491.5,72 490.4,71.4 491.5,70.8 492.5,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.6,73.2 492.5,72.7 493.6,72 494.6,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,73.9 493.6,73.2 494.6,72.7 495.6,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,75.1 495.6,74.4 496.7,73.9 497.8,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,75.6 496.7,75.1 497.8,74.4 498.7,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,76.9 498.7,76.2 499.8,75.6 500.9,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.2,69 483.1,68.5 484.2,67.8 485.2,68.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,69.7 484.2,69 485.2,68.5 486.2,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,70.8 486.2,70.2 487.3,69.7 488.3,70.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,72 488.3,71.4 489.4,70.8 490.4,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492.5,73.9 491.5,73.2 492.5,72.7 493.6,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,75.1 493.6,74.4 494.6,73.9 495.6,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,76.2 495.6,75.6 496.7,75.1 497.8,75.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,76.9 496.7,76.2 497.8,75.6 498.7,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,78.1 498.7,77.4 499.8,76.9 500.9,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.9,79.8 502,79.3 502.9,78.6 504,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.1,69.7 482,69 483.1,68.5 484.2,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.3,72.7 487.3,72 488.3,71.4 489.4,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,73.2 488.3,72.7 489.4,72 490.4,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,73.9 489.4,73.2 490.4,72.7 491.5,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.6,75.6 492.5,75.1 493.6,74.4 494.6,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,76.9 494.6,76.2 495.6,75.6 496.7,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,77.4 495.6,76.9 496.7,76.2 497.8,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,79.3 498.7,78.6 499.8,78.1 500.9,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.2,71.4 483.1,70.8 484.2,70.2 485.2,70.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,72 484.2,71.4 485.2,70.8 486.2,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,72.7 485.2,72 486.2,71.4 487.3,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,75.1 489.4,74.4 490.4,73.9 491.5,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492.5,76.2 491.5,75.6 492.5,75.1 493.6,75.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,78.1 494.6,77.4 495.6,76.9 496.7,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,78.6 495.6,78.1 496.7,77.4 497.8,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,79.3 496.7,78.6 497.8,78.1 498.7,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.7,79.8 497.8,79.3 498.7,78.6 499.8,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,80.5 498.7,79.8 499.8,79.3 500.9,79.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502,81.7 500.9,81.1 502,80.5 502.9,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,73.2 484.2,72.7 485.2,72 486.2,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,73.9 485.2,73.2 486.2,72.7 487.3,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.3,75.1 487.3,74.4 488.3,73.9 489.4,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,76.2 489.4,75.6 490.4,75.1 491.5,75.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "491.5,76.9 490.4,76.2 491.5,75.6 492.5,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.6,78.1 492.5,77.4 493.6,76.9 494.6,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,78.6 493.6,78.1 494.6,77.4 495.6,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,79.8 495.6,79.3 496.7,78.6 497.8,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.8,81.7 498.7,81.1 499.8,80.5 500.9,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480,71.4 478.9,70.8 480,70.2 481,70.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481,72 480,71.4 481,70.8 482,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482,72.7 481,72 482,71.4 483.1,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.1,73.2 482,72.7 483.1,72 484.2,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,74.4 484.2,73.9 485.2,73.2 486.2,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,75.1 485.2,74.4 486.2,73.9 487.3,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,75.6 486.2,75.1 487.3,74.4 488.3,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,76.9 488.3,76.2 489.4,75.6 490.4,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.6,79.3 492.5,78.6 493.6,78.1 494.6,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,81.7 496.7,81.1 497.8,80.5 498.7,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.9,72 477.8,71.4 478.9,70.8 480,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482,73.9 481,73.2 482,72.7 483.1,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.2,75.1 483.1,74.4 484.2,73.9 485.2,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,75.6 484.2,75.1 485.2,74.4 486.2,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,76.2 485.2,75.6 486.2,75.1 487.3,75.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.3,77.4 487.3,76.9 488.3,76.2 489.4,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,78.6 489.4,78.1 490.4,77.4 491.5,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "491.5,79.3 490.4,78.6 491.5,78.1 492.5,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,81.1 493.6,80.5 494.6,79.8 495.6,80.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,81.7 494.6,81.1 495.6,80.5 496.7,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,82.3 495.6,81.7 496.7,81.1 497.8,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,82.8 496.7,82.3 497.8,81.7 498.7,82.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "477.8,72.7 476.9,72 477.8,71.4 478.9,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481,74.4 480,73.9 481,73.2 482,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482,75.1 481,74.4 482,73.9 483.1,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,78.1 486.2,77.4 487.3,76.9 488.3,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.3,78.6 487.3,78.1 488.3,77.4 489.4,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,82.3 493.6,81.7 494.6,81.1 495.6,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,83.5 495.6,82.8 496.7,82.3 497.8,82.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.8,84 496.7,83.5 497.8,82.8 498.7,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "476.9,73.2 475.8,72.7 476.9,72 477.8,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.9,74.4 477.8,73.9 478.9,73.2 480,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480,75.1 478.9,74.4 480,73.9 481,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.2,77.4 483.1,76.9 484.2,76.2 485.2,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,80.5 488.3,79.8 489.4,79.3 490.4,79.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492.5,82.3 491.5,81.7 492.5,81.1 493.6,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.6,84 494.6,83.5 495.6,82.8 496.7,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "496.7,84.7 495.6,84 496.7,83.5 497.8,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.8,73.9 474.7,73.2 475.8,72.7 476.9,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.2,78.6 483.1,78.1 484.2,77.4 485.2,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,79.3 484.2,78.6 485.2,78.1 486.2,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,79.8 485.2,79.3 486.2,78.6 487.3,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,81.7 488.3,81.1 489.4,80.5 490.4,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,82.3 489.4,81.7 490.4,81.1 491.5,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,84.7 493.6,84 494.6,83.5 495.6,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481,78.1 480,77.4 481,76.9 482,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482,78.6 481,78.1 482,77.4 483.1,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,80.5 484.2,79.8 485.2,79.3 486.2,79.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,81.1 485.2,80.5 486.2,79.8 487.3,80.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,81.7 486.2,81.1 487.3,80.5 488.3,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,82.8 488.3,82.3 489.4,81.7 490.4,82.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,83.5 489.4,82.8 490.4,82.3 491.5,82.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.6,85.9 493.6,85.3 494.6,84.7 495.6,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480,78.6 478.9,78.1 480,77.4 481,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481,79.3 480,78.6 481,78.1 482,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482,79.8 481,79.3 482,78.6 483.1,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,81.7 484.2,81.1 485.2,80.5 486.2,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,82.8 486.2,82.3 487.3,81.7 488.3,82.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,84 488.3,83.5 489.4,82.8 490.4,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,84.7 489.4,84 490.4,83.5 491.5,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "491.5,85.3 490.4,84.7 491.5,84 492.5,84.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492.5,85.9 491.5,85.3 492.5,84.7 493.6,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.6,86.5 492.5,85.9 493.6,85.3 494.6,85.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481,80.5 480,79.8 481,79.3 482,79.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.1,81.7 482,81.1 483.1,80.5 484.2,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.2,82.3 483.1,81.7 484.2,81.1 485.2,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,84 486.2,83.5 487.3,82.8 488.3,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,85.3 488.3,84.7 489.4,84 490.4,84.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.4,85.9 489.4,85.3 490.4,84.7 491.5,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "476.9,79.3 475.8,78.6 476.9,78.1 477.8,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.9,76.9 477.8,76.2 478.9,75.6 480,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "477.8,79.8 476.9,79.3 477.8,78.6 478.9,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480,81.1 478.9,80.5 480,79.8 481,80.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.1,82.8 482,82.3 483.1,81.7 484.2,82.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.2,84.7 485.2,84 486.2,83.5 487.3,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.3,85.9 487.3,85.3 488.3,84.7 489.4,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.8,79.8 474.7,79.3 475.8,78.6 476.9,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "476.9,80.5 475.8,79.8 476.9,79.3 477.8,79.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.9,81.7 477.8,81.1 478.9,80.5 480,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480,82.3 478.9,81.7 480,81.1 481,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481,82.8 480,82.3 481,81.7 482,82.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.1,84 482,83.5 483.1,82.8 484.2,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.2,85.3 484.2,84.7 485.2,84 486.2,84.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "487.3,86.5 486.2,85.9 487.3,85.3 488.3,85.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.6,73.9l-4.2,2.4l4.2,2.4l4.2-2.4L473.6,73.9z M473.6,77.8l-2.8-1.6l2.8-1.6l2.8,1.6L473.6,77.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.6,75.2 472,76.2 473.6,77.3 475.4,76.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.4,64.8l-4.2,2.4l4.2,2.4l4.2-2.4L489.4,64.8z M489.4,68.9l-2.8-1.6l2.8-1.6l2.8,1.6L489.4,68.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.4,66.2 487.6,67.2 489.4,68.2 491.1,67.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506,74.4l-4.2,2.4l4.2,2.4l4.2-2.4L506,74.4z M506,78.5l-2.8-1.6l2.8-1.6l2.8,1.6L506,78.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,75.9 504.4,76.9 506,77.8 507.8,76.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.8,95.4c-11.2-7.2-29.8-8.1-41.6-2s-12.2,16.8-0.9,24c11.2,7.2,29.8,8.1,41.6,2 C544.5,113.4,545,102.6,533.8,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M530.7,96.6c-9.8-6.2-25.7-7-36-1.8c-10.2,5.3-10.6,14.5-0.8,20.7c9.8,6.2,25.7,7,36,1.8 C540,112.2,540.4,102.9,530.7,96.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st231",
    d: "M510.9,121c7.3,0,14.1-1.6,19.1-4.5c5.1-3,7.9-6.8,7.9-11c0-4.1-2.8-7.9-7.7-10.8c-5-3-11.9-4.6-19.1-4.6 c-7.3,0-14.1,1.6-19.1,4.5c-5.1,3-7.9,6.8-7.9,11c0,4.1,2.8,7.9,7.7,10.8C496.9,119.4,503.7,121,510.9,121z M510.9,120.7 c-6.9,0-13.4-1.6-18.3-4.5c-4.9-2.8-7.6-6.6-7.6-10.7c0-4.1,2.7-8,7.7-10.8c4.9-2.8,11.4-4.3,18.3-4.3c6.9,0,13.4,1.6,18.3,4.5 c4.9,2.8,7.6,6.6,7.6,10.7s-2.7,8-7.7,10.8C524.3,119.3,517.8,120.7,510.9,120.7z M493.6,95.3c9.6-5.6,25.2-5.6,34.8,0.1 c9.6,5.7,9.8,14.9,0.1,20.4c-9.6,5.6-25.2,5.6-34.8-0.1S483.9,101,493.6,95.3z M504,102.3c-1.1-0.7-1.1-1.6,0-2.3 c1.1-0.7,2.8-0.7,3.9,0c0.9,0.5,1.1,1.4,0.4,2l21.3,12.6c0.5-0.4,1.1-0.9,1.6-1.4l-10.8-6.4l-1.9-3.3c-0.8,0-1.6-0.1-2.3-0.4 c-1.1-0.7-1.1-1.6,0-2.3c1.1-0.7,2.8-0.7,3.9,0c1.1,0.7,1.1,1.6,0,2.3c-0.1,0.1-0.3,0.1-0.4,0.1l1.9,3.1l10.4,6.1 c5.1-5.4,3.8-12.3-4.1-16.9c-9.3-5.6-24.5-5.6-33.9-0.1c-9.3,5.4-9.2,14.4,0.1,19.9c7.6,4.5,19,5.4,27.9,2.7l-10.2-6l-3.5-0.7 c-0.1,0.1-0.1,0.1-0.3,0.3c-1.1,0.7-2.8,0.7-3.9,0c-1.1-0.7-1.1-1.6,0-2.3c1.1-0.7,2.8-0.7,3.9,0c0.7,0.4,0.9,0.8,0.8,1.4 l3.8,0.8l10.7,6.4c0.8-0.3,1.8-0.7,2.4-0.9L498.8,101c-1.1,0.4-2.4,0.3-3.4-0.3c-1.1-0.7-1.1-1.6,0-2.3c1.1-0.7,2.8-0.7,3.9,0 c0.9,0.5,1.1,1.4,0.4,2l26.9,16c0.4-0.3,0.8-0.4,1.4-0.7c0.3-0.1,0.5-0.3,0.8-0.4l-21.4-12.6C506.4,103,504.9,102.9,504,102.3 L504,102.3z M507,101.8c0.5-0.3,0.5-0.9,0-1.2c-0.5-0.3-1.5-0.4-2,0c-0.5,0.3-0.5,0.9,0,1.2C505.5,102.2,506.4,102.2,507,101.8 L507,101.8z M519.3,102.7c0.5-0.3,0.5-0.9,0-1.2c-0.5-0.3-1.5-0.4-2,0c-0.5,0.3-0.5,0.9,0,1.2C517.7,103,518.6,103,519.3,102.7 L519.3,102.7z M498.4,100.2c0.5-0.3,0.5-0.9,0-1.2c-0.5-0.3-1.5-0.4-2,0c-0.5,0.3-0.5,0.8,0,1.2 C496.9,100.6,497.9,100.6,498.4,100.2L498.4,100.2z M507.1,111.1c0.5-0.3,0.5-0.8,0-1.2c-0.5-0.3-1.5-0.4-2,0 c-0.5,0.4-0.5,0.9,0,1.2C505.6,111.4,506.6,111.5,507.1,111.1L507.1,111.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.8,98.9c-6.1,3.5-15.8,3.5-21.9,0c-6.1-3.5-6.1-9.2-0.1-12.7c6.1-3.5,15.8-3.5,21.9,0 C478.8,89.7,478.9,95.4,472.8,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M472.6,98.7c2.8-1.6,4.3-3.8,4.3-6.1c0-2.3-1.6-4.5-4.5-6.1c-2.8-1.6-6.6-2.6-10.7-2.6s-7.9,0.9-10.7,2.6 c-2.8,1.6-4.3,3.8-4.3,6.1c0,2.3,1.6,4.5,4.5,6.1c2.8,1.6,6.6,2.6,10.7,2.6C465.9,101.2,469.7,100.3,472.6,98.7z M451.7,98.7 c-2.8-1.6-4.3-3.8-4.3-6.1c0-2.3,1.5-4.3,4.2-6c2.7-1.6,6.4-2.4,10.2-2.4c3.8,0,7.4,0.8,10.3,2.4c2.8,1.6,4.3,3.8,4.3,6.1 s-1.5,4.3-4.2,6c-2.7,1.6-6.4,2.4-10.2,2.4C458.1,101.1,454.4,100.3,451.7,98.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M471.6,98.4c-5.4,3.1-14.1,3.3-19.5,0s-5.3-8.3,0-11.5c5.4-3.1,14.1-3.3,19.5,0S476.9,95.1,471.6,98.4z  M465.7,90.8c-0.5,0.3-1.4,0.4-1.9,0.1l-11.9,7c0.1,0.1,0.3,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.7,0.4l15-8.9 c-0.4-0.4-0.3-0.8,0.3-1.1c0.5-0.4,1.6-0.4,2.2,0c0.5,0.4,0.5,0.9,0,1.2c-0.5,0.3-1.4,0.4-1.9,0.1l-15,8.8 c0.4,0.3,0.9,0.4,1.4,0.5l6-3.5l2.2-0.4c0-0.3,0.1-0.5,0.4-0.8c0.5-0.4,1.6-0.4,2.2,0c0.5,0.4,0.5,0.9,0,1.2 c-0.5,0.4-1.6,0.4-2.2,0l-0.1-0.1l-2,0.4l-5.7,3.4c5,1.5,11.4,0.9,15.6-1.5c5.3-3.1,5.3-8.1,0-11.1c-5.3-3.1-13.7-3-19,0 c-4.3,2.6-5.1,6.5-2.2,9.5l5.8-3.4l1.1-1.8c-0.1,0-0.1-0.1-0.3-0.1c-0.5-0.4-0.5-0.9,0-1.2c0.5-0.4,1.6-0.4,2.2,0 c0.5,0.4,0.5,0.9,0,1.2c-0.4,0.3-0.8,0.3-1.2,0.3l-1.1,1.8l-6,3.8c0.3,0.3,0.5,0.5,0.9,0.8l11.9-7c-0.4-0.4-0.3-0.8,0.3-1.1 c0.5-0.4,1.6-0.4,2.2,0C466.3,89.9,466.3,90.4,465.7,90.8L465.7,90.8z M464,90.5c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7 c-0.3-0.1-0.8-0.1-1.2,0C463.8,90,463.8,90.3,464,90.5L464,90.5z M457.3,90.9c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7 s-0.8-0.1-1.2,0C456.9,90.5,456.9,90.8,457.3,90.9L457.3,90.9z M468.9,89.6c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7 s-0.8-0.1-1.2,0C468.5,89.1,468.5,89.5,468.9,89.6L468.9,89.6z M464,95.7c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7 s-0.8-0.1-1.2,0C463.8,95.3,463.8,95.6,464,95.7L464,95.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M575.4,119.7l1.5-0.9l-0.7-0.4l-2.4,0.4l-0.1,0.1l0.8,0.4l-0.5,0.3l0.7,0.4l0.5-0.3l0.3,0.1l0.3-0.1 L575.4,119.7z M574.7,119.3l-0.7-0.4l1.8-0.3L574.7,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M577.8,120.5c0-0.1-0.1-0.3-0.4-0.4h-0.1l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1 c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3 s0.5,0,0.8-0.3C577.7,120.7,577.8,120.6,577.8,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M573.5,117.8L573.5,117.8l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1 l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3 h-0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4 C573.9,118,573.7,117.9,573.5,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M572.2,116l-3.1,0.8l0.3,0.1l0.4-0.1l0.8,0.4l-0.1,0.3l0.8,0.4l1.4-1.9H572.2z M570.6,117.1l-0.5-0.3 l1.1-0.3L570.6,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M583.3,123c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C583.1,123.3,583.2,123.2,583.3,123z M582.1,123c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0H581l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C582.5,122.8,582.3,122.9,582.1,123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M580.6,121.1V121l-0.1-0.1c-0.1,0-0.1-0.1-0.3-0.1s-0.1-0.1-0.3-0.1s-0.3,0-0.3-0.1c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0.1,0.3c-0.3,0-0.4-0.1-0.5-0.1s-0.4,0.1-0.5,0.1 c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.3,0.1,0.5,0.3,0.8,0.3 c0.3,0,0.5,0,0.8-0.1c0.1-0.1,0.3-0.3,0.3-0.3c0-0.1,0-0.3-0.1-0.3c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0h0.1c0,0,0.1,0,0.1-0.1 C580.5,121.3,580.6,121.3,580.6,121.1z M578.9,121.7l-0.1,0.1c0,0-0.1,0-0.1,0.1h-0.1h-0.1v-0.1c0,0,0.1-0.1,0.4-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0.1,0,0.1C579.1,121.4,579,121.6,578.9,121.7z M579.8,121 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0,0-0.1,0.1-0.3c0.1-0.1,0.3-0.1,0.3-0.1h0.1c0,0,0,0,0,0.1C580,120.9,580,121,579.8,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M593.5,129.7c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3 c-0.1-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3 s-0.4,0.3-0.5,0.4s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1C593.1,129.8,593.4,129.8,593.5,129.7z M592.4,129.5c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1 l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3C592.7,129.4,592.6,129.4,592.4,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M596.5,130l-1.4-0.8l-0.3,0.1l0.9,0.5h-1.5l-0.1,0.1c0.1,0,0.1,0.1,0.1,0.1v0.1c0,0,0,0.1-0.1,0.1 l-0.1,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1h-0.3 v0.1c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0.1,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0c0.1,0,0.3,0,0.5,0 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1-0.1,0.3-0.1l0.1-0.1v-0.1c0,0,0-0.1,0-0.3h0.7L596.5,130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M592,128.2c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1s-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C591.7,128.3,592,128.2,592,128.2z M590.9,128.1c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C591.2,127.9,591.1,128.1,590.9,128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M589.4,126.3l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0H587h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3 c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3c0.3,0,0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4s-0.1-0.3-0.4-0.4h-0.1l0.5-0.4 L589.4,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M585.2,124.3c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0s-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C585,124.4,585.1,124.3,585.2,124.3z M584.2,124.1c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C584.4,124,584.3,124.1,584.2,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M586.7,125.8c0.3-0.1,0.4-0.3,0.5-0.4s0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1C586.3,125.9,586.6,125.9,586.7,125.8z M585.6,125.6c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3c0.1,0,0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0 h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3C585.9,125.5,585.8,125.5,585.6,125.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M571,122.1l1.5-0.9l-0.7-0.4l-2.4,0.4l-0.1,0.1l0.8,0.4l-0.5,0.3l0.7,0.4l0.5-0.3l0.3,0.1l0.3-0.1 L571,122.1z M570.3,121.7l-0.7-0.4l1.8-0.3L570.3,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M573.5,122.9c0-0.1-0.1-0.3-0.4-0.4h-0.1l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1 c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3H571c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3 s0.5,0,0.8-0.3C573.5,123.2,573.5,123,573.5,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M569.1,120.2L569.1,120.2l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1 l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3 h-0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4 C569.5,120.5,569.4,120.3,569.1,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M567.9,118.4l-3.1,0.8l0.3,0.1l0.4-0.1l0.8,0.4l-0.1,0.3l0.8,0.4l1.4-1.9H567.9z M566.3,119.5l-0.5-0.3 l1.1-0.3L566.3,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M579,125.6c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C578.7,125.8,578.9,125.6,579,125.6z M577.8,125.5c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C578.2,125.3,577.9,125.5,577.8,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M576.3,123.7v-0.1l-0.1-0.1c-0.1,0-0.1-0.1-0.3-0.1s-0.1-0.1-0.3-0.1s-0.3,0-0.3-0.1c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0.1,0.3c-0.3,0-0.4-0.1-0.5-0.1s-0.4,0.1-0.5,0.1 c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.3,0.1,0.5,0.3,0.8,0.3 c0.3,0,0.5,0,0.8-0.1c0.1-0.1,0.3-0.3,0.3-0.3c0-0.1,0-0.3-0.1-0.3c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0h0.1c0,0,0.1,0,0.1-0.1 C576.2,123.7,576.3,123.7,576.3,123.7z M574.5,124.1l-0.1,0.1c0,0-0.1,0-0.1,0.1h-0.1H574v-0.1c0,0,0.1-0.1,0.4-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0.1,0,0.1C574.8,124,574.7,124,574.5,124.1z M575.5,123.6 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0,0-0.1,0.1-0.3c0.1-0.1,0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0s0,0,0,0.1 C575.6,123.5,575.6,123.5,575.5,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M589.2,132.1c0.3-0.1,0.4-0.3,0.5-0.4s0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3s0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0c0.1,0,0.4,0,0.5-0.1 C588.8,132.4,589,132.3,589.2,132.1z M588.1,132c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1 c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0 c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3C588.4,131.8,588.2,132,588.1,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M592.1,132.5l-1.4-0.8l-0.3,0.1l0.9,0.5H590l-0.1,0.1c0.1,0,0.1,0.1,0.1,0.1v0.1c0,0,0,0.1-0.1,0.1 l-0.1,0.1c0,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1h-0.3v0.1 c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0.1,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0c0.1,0,0.3,0,0.5,0 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1-0.1,0.3-0.1l0.1-0.1v-0.1c0,0,0-0.1,0-0.3h0.7L592.1,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M587.7,130.6c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1s-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.5,0c0.1,0,0.4,0,0.5-0.1 c0.1,0,0.4-0.1,0.7-0.3C587.4,130.9,587.7,130.8,587.7,130.6z M586.6,130.6c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3 s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1C586.9,130.4,586.7,130.5,586.6,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M585.1,128.7l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0h-0.1h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3H582c0,0.1,0.1,0.3,0.1,0.3 c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3c0.3,0,0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4s-0.1-0.3-0.4-0.4H584l0.5-0.4 L585.1,128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M580.9,126.7c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0s-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C580.6,127,580.8,126.8,580.9,126.7z M579.8,126.7c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1S580,126.6,579.8,126.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M582.4,128.2c0.3-0.1,0.4-0.3,0.5-0.4s0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1C582,128.5,582.3,128.3,582.4,128.2z M581.3,128.1c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1 l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3C581.6,127.9,581.4,128.1,581.3,128.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "538.7,86.8 572.8,106.4 511.6,141.6 477.6,122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "477.6,153.4 511.6,173.2 511.6,141.6 477.6,122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "481.8,124.4 543,89.2 538.7,86.8 477.6,122 477.6,153.4 481.8,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "511.6,141.6 572.6,106.4 568.4,103.8 507.2,139.2 507.2,170.6 511.6,173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.8,124.4 477.6,122 477.6,153.4 481.8,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.6,141.6 507.2,139.2 507.2,170.6 511.6,173  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M607.2,134.3c-2.8-1.6-7.4-1.6-10.3,0c-2.8,1.6-2.8,4.3,0,6c2.8,1.6,7.4,1.6,10.3,0 C610.2,138.6,610,135.9,607.2,134.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x37__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109715244804938021090000016119097821327229085_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.0535,
    y1: 526.0141,
    x2: 519.9653,
    y2: 526.0141,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109715244804938021090000016119097821327229085_)"
    },
    d: "M520,191.4l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L520,191.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064333226785785474000000009067839618143077815_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.9522,
    y1: 523.7035,
    x2: 519.2535,
    y2: 523.7035,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000064333226785785474000000009067839618143077815_)",
      enableBackground: "new"
    },
    d: " M451.4,200.6v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C449.5,197.8,450.4,199.3,451.4,200.6z M469.9,210.9v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C471.5,211.3,470.7,211.2,469.9,210.9z M480.3,212.4v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C481.9,212.6,481.1,212.6,480.3,212.4z  M475.1,211.9v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C476.8,212.3,476,212,475.1,211.9z M454.1,203.5v7.7c0.8,0.7,1.6,1.4,2.6,1.9 v-7.9C455.9,204.7,455,204.2,454.1,203.5z M464.6,209.4v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9 C466.3,209.9,465.4,209.7,464.6,209.4z M459.4,207v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C461.1,207.8,460.2,207.4,459.4,207z  M485.4,212.6v8.1c0.8,0,1.6,0,2.6-0.1v-8.1C487.2,212.4,486.4,212.6,485.4,212.6z M511.6,205v7.9c0.9-0.7,1.8-1.4,2.6-2 v-7.7C513.3,203.9,512.4,204.4,511.6,205z M490.7,212.3v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C492.3,212,491.5,212.2,490.7,212.3z  M516.7,200.2v7.9c1.2-1.5,2-3.1,2.6-4.6v-7.6C518.7,197.4,517.8,198.9,516.7,200.2z M506.3,208v7.9c0.8-0.4,1.8-0.8,2.6-1.2 v-7.7C508,207.3,507.2,207.6,506.3,208z M501.1,210v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9C502.9,209.6,502,209.7,501.1,210z  M495.9,211.3v8c0.8-0.1,1.6-0.4,2.6-0.7v-7.9C497.6,211.1,496.8,211.2,495.9,211.3z"
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M509.4,177.1c14.1,8,14.1,21.1,0.1,29.4c-13.9,8.3-36.7,8.3-50.8,0.3c-14.1-8-14.1-21.1-0.1-29.4 C472.6,169.2,495.3,169.1,509.4,177.1z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M508.3,177.5c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 c0,5.4,3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C518.6,186.3,515,181.3,508.3,177.5z M508.2,205.5c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7s-9.9-8.5-9.9-13.7 c0-5.1,3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7c6.4,3.7,9.9,8.5,9.9,13.7 C517.9,196.9,514.4,201.7,508.2,205.5z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M507,178.8c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C473.6,171.8,494.2,171.8,507,178.8z M476.8,186.7c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.6-20c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3L486,200l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C473.1,185.9,475.4,185.9,476.8,186.7 L476.8,186.7z M475.5,189c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C473.6,189.4,474.9,189.4,475.5,189L475.5,189z M477.4,198.1c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C475.4,198.5,476.6,198.5,477.4,198.1L477.4,198.1z M472,182.5c0.8-0.4,0.7-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C470,182.9,471.2,182.9,472,182.5L472,182.5z M496.4,189c0.8-0.4,0.8-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.7,1.1,0,1.5C494.5,189.4,495.7,189.4,496.4,189L496.4,189z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021081029027289933230000002118879057870929544_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.2924,
    y1: 534.6815,
    x2: 522.2042,
    y2: 534.6815,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021081029027289933230000002118879057870929544_)"
    },
    d: "M522.1,182.8l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L522.1,182.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049179680831079579250000008350877297981500596_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.1684,
    y1: 532.5063,
    x2: 521.455,
    y2: 532.5063,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000049179680831079579250000008350877297981500596_)",
      enableBackground: "new"
    },
    d: " M453.7,191.8v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C451.7,189.1,452.7,190.5,453.7,191.8z M472,202.1v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C473.8,202.5,473,202.4,472,202.1z M482.5,203.6v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C484.2,203.8,483.4,203.8,482.5,203.6z  M477.3,203.2v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C478.9,203.5,478.1,203.2,477.3,203.2z M456.5,194.8v7.7c0.8,0.7,1.6,1.4,2.6,1.9 v-7.9C458.1,195.9,457.1,195.4,456.5,194.8z M466.9,200.6v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9 C468.5,201.2,467.7,200.9,466.9,200.6z M461.6,198.2v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C463.4,199,462.4,198.7,461.6,198.2z  M487.7,203.8v8.1c0.8,0,1.6,0,2.6-0.1v-8.1C489.4,203.6,488.5,203.8,487.7,203.8z M513.7,196.2v7.9c0.9-0.7,1.8-1.4,2.6-2 v-7.7C515.5,195.1,514.5,195.6,513.7,196.2z M492.9,203.5v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C494.6,203.2,493.8,203.4,492.9,203.5 z M518.9,191.4v7.9c1.2-1.5,2-3.1,2.6-4.6v-7.6C520.9,188.6,520.1,190.1,518.9,191.4z M508.6,199.2v7.9 c0.8-0.4,1.8-0.8,2.6-1.2v-7.7C510.2,198.5,509.4,198.7,508.6,199.2z M503.3,201.2v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9 C505.1,200.8,504.1,200.9,503.3,201.2z M498.2,202.5v8c0.8-0.1,1.6-0.4,2.6-0.7V202C499.8,202.3,499,202.4,498.2,202.5z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -4.190579e-03 4.190579e-03 1 -0.7633 2.0393)",
    className: "st189",
    cx: 486.2,
    cy: 183.2,
    rx: 35.9,
    ry: 20.7
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M510.6,168.7c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 s3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C520.8,177.6,517.3,172.5,510.6,168.7z M510.3,196.7c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7s-9.9-8.5-9.9-13.7 c0-5.1,3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7s9.9,8.5,9.9,13.7 C520.1,188.2,516.7,193.1,510.3,196.7z"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M509.1,170.2c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C476,163,496.5,163,509.1,170.2z M478.9,177.9c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.6-20c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C475.3,177.1,477.6,177.1,478.9,177.9 L478.9,177.9z M477.8,180.2c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C475.8,180.6,477,180.6,477.8,180.2L477.8,180.2z M479.6,189.3c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C477.7,189.7,478.9,189.7,479.6,189.3L479.6,189.3z M474.2,173.7c0.8-0.4,0.7-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C472.2,174.1,473.4,174.1,474.2,173.7L474.2,173.7z M498.7,180.2 c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.7,1.1,0,1.5C496.7,180.6,497.9,180.6,498.7,180.2L498.7,180.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081645954890608976380000008528987264171124152_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.1056,
    y1: 543.3488,
    x2: 519.0173,
    y2: 543.3488,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081645954890608976380000008528987264171124152_)"
    },
    d: "M519,174.1l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L519,174.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076576507028148897620000014872539439695731335_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.9181,
    y1: 541.1059,
    x2: 518.2192,
    y2: 541.1059,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000076576507028148897620000014872539439695731335_)",
      enableBackground: "new"
    },
    d: " M450.5,183.2v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C448.6,180.5,449.4,181.8,450.5,183.2z M468.9,193.6v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C470.5,193.9,469.7,193.7,468.9,193.6z M479.3,195v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C481,195.1,480.1,195.1,479.3,195z  M474.1,194.6v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C475.8,194.8,475,194.7,474.1,194.6z M453.2,186.2v7.7c0.8,0.7,1.6,1.4,2.6,1.9 v-7.9C455,187.2,454,186.7,453.2,186.2z M463.6,192v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9C465.4,192.5,464.4,192.2,463.6,192z  M458.5,189.5v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C460.1,190.4,459.3,190.1,458.5,189.5z M484.5,195.1v8.1c0.8,0,1.6,0,2.6-0.1 V195C486.2,195.1,485.4,195.1,484.5,195.1z M510.6,187.6v7.9c0.9-0.7,1.8-1.4,2.6-2v-7.7C512.4,186.4,511.4,187,510.6,187.6z  M489.8,194.8v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C491.4,194.6,490.6,194.7,489.8,194.8z M515.8,182.9v7.9c1.2-1.5,2-3.1,2.6-4.6 v-7.6C517.8,179.9,516.9,181.4,515.8,182.9z M505.3,190.5v7.9c0.8-0.4,1.8-0.8,2.6-1.2v-7.7 C507.1,189.8,506.2,190.2,505.3,190.5z M500.2,192.5v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9C501.8,192.1,501,192.2,500.2,192.5z  M494.9,193.9v8c0.8-0.1,1.6-0.4,2.6-0.7v-7.9C496.7,193.6,495.9,193.7,494.9,193.9z"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M508.5,159.7c14.1,8,14.1,21.1,0.1,29.4c-13.9,8.1-36.7,8.3-50.8,0.3c-14.1-8-14.1-21.1-0.1-29.4 C471.6,151.8,494.4,151.6,508.5,159.7z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M507.4,160c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 c0,5.4,3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C517.7,169,514,163.8,507.4,160z M507.1,188.1c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7s-9.9-8.5-9.9-13.7 s3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7c6.4,3.7,9.9,8.5,9.9,13.7 C517,179.5,513.5,184.4,507.1,188.1z"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M506,161.5c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C472.7,154.3,493.3,154.3,506,161.5z M475.8,169.2c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9L471.5,166c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7L478,181c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C472,168.4,474.3,168.4,475.8,169.2L475.8,169.2 z M474.6,171.5c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C472.7,171.9,473.9,171.9,474.6,171.5 L474.6,171.5z M476.5,180.6c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C474.5,181,475.7,181,476.5,180.6L476.5,180.6z M470.9,165c0.8-0.4,0.7-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C469,165.4,470.3,165.4,470.9,165L470.9,165z M495.5,171.5c0.8-0.4,0.8-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.7,1.1,0,1.5C493.6,171.9,494.8,171.9,495.5,171.5L495.5,171.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018948213289342260220000012936309516369754000_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.9521,
    y1: 551.4744,
    x2: 520.8638,
    y2: 551.4744,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018948213289342260220000012936309516369754000_)"
    },
    d: "M520.8,166l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L520.8,166z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178189509256992857220000018416251205564398260_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.8141,
    y1: 549.1638,
    x2: 520.1152,
    y2: 549.1638,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000178189509256992857220000018416251205564398260_)",
      enableBackground: "new"
    },
    d: " M452.4,175.2v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C450.4,172.3,451.3,173.8,452.4,175.2z M470.8,185.5v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C472.4,185.9,471.6,185.7,470.8,185.5z M481.2,187v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C482.9,187.1,482,187,481.2,187z  M476,186.4v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C477.6,186.7,476.8,186.6,476,186.4z M455.1,178v7.7c0.8,0.7,1.6,1.4,2.6,1.9v-7.9 C456.7,179.2,455.8,178.7,455.1,178z M465.5,184v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9C467.3,184.4,466.3,184.3,465.5,184z  M460.2,181.5v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C462,182.4,461.1,182,460.2,181.5z M486.4,187.1v8.1c0.8,0,1.6,0,2.6-0.1V187 C488,187,487.2,187.1,486.4,187.1z M512.4,179.5v7.9c0.9-0.7,1.8-1.4,2.6-2v-7.7C514.1,178.4,513.3,179,512.4,179.5z  M491.7,186.8v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C493.3,186.6,492.5,186.7,491.7,186.8z M517.7,174.8v7.9c1.2-1.5,2-3.1,2.6-4.6 v-7.6C519.6,171.9,518.7,173.4,517.7,174.8z M507.2,182.5v7.9c0.8-0.4,1.8-0.8,2.6-1.2v-7.7C509,181.7,508,182.1,507.2,182.5 z M502,184.5v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9C503.7,184,502.9,184.3,502,184.5z M496.8,185.9v8c0.8-0.1,1.6-0.4,2.6-0.7 v-7.9C498.4,185.6,497.6,185.7,496.8,185.9z"
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M510.2,151.6c14.1,8,14.1,21.1,0.1,29.4c-13.9,8.1-36.7,8.3-50.8,0.3c-14.1-8-14.1-21.1-0.1-29.4 C473.4,143.8,496.1,143.6,510.2,151.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M509.3,152c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 c0,5.4,3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C519.6,160.8,515.9,155.8,509.3,152z M509,180.1c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7c-6.4-3.7-9.9-8.5-9.9-13.7 c0-5.1,3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7c6.4,3.7,9.9,8.5,9.9,13.7 C518.9,171.4,515.4,176.3,509,180.1z"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M507.8,153.4c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C474.6,146.2,495.2,146.2,507.8,153.4z M477.7,161.2c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.6-20c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C473.9,160.4,476.2,160.4,477.7,161.2 L477.7,161.2z M476.5,163.4c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C474.5,163.9,475.7,163.9,476.5,163.4L476.5,163.4z M478.3,172.6c0.8-0.4,0.8-1.1,0-1.5s-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C476.4,173,477.6,173,478.3,172.6L478.3,172.6z M472.8,157c0.8-0.4,0.7-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C470.9,157.4,472.2,157.4,472.8,157L472.8,157z M497.3,163.5c0.8-0.4,0.8-1.1,0-1.5s-2-0.4-2.7,0 c-0.8,0.4-0.7,1.1,0,1.5C495.3,163.9,496.5,163.9,497.3,163.5L497.3,163.5z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031907336216119871470000000543985653236244383_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.1056,
    y1: 537.9994,
    x2: 522.1812,
    y2: 537.9994,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3922E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000031907336216119871470000000543985653236244383_)",
      enableBackground: "new"
    },
    d: " M518.9,182.8c0-0.1,0-0.3,0-0.4v-1.6c1.2-2,1.8-4.2,1.9-6.4v-7.6c-0.1,5.1-3.7,10.3-10.4,14.4c-13.9,8.1-36.7,8.3-50.8,0.3 c-7-3.9-10.6-9.2-10.6-14.5c0,0.4,0,0.8,0,1.4c-1.2,2-1.8,4.2-1.9,6.4l0,0c0,0,0,0,0,0.1s0,0.1,0,0.3c0,2.7,0,5.3,0,8 c0,1.9,0.5,3.8,1.5,5.7c-0.4,1.2-0.5,2.3-0.5,3.5l0,0c0,0,0,0,0,0.1s0,0.1,0,0.3c0,2.7,0,5.3,0,8c0.1,7.4,7.2,14.8,21,18.6 c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8v-1.8c1.5-2.3,2.2-4.6,2.2-7v-8.3L518.9,182.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062897596387232960830000002566774067664837303_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.2084,
    y1: 133.1609,
    x2: 486.1608,
    y2: 133.1609,
    gradientTransform: "matrix(-0.5 0.866 0.866 0.5 624.9716 -266.4071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBCC34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CDA349"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062897596387232960830000002566774067664837303_)"
    },
    d: "M509.9,228.4l35.6-62.4 c-2.4-1.5-4.7-2.8-7.2-4.1c-6.5-3.5-16.4-1.1-26.7,8.9c-7.2,7-12.5,16.1-14.9,26c-3.5,13.9-0.5,23.6,5.8,27.4L509.9,228.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119117189599209279700000003654530185590594978_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.1115,
    y1: 130.9388,
    x2: 485.3765,
    y2: 130.9388,
    gradientTransform: "matrix(-0.5 0.866 0.866 0.5 624.9716 -266.4071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBCC34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CDA349"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000119117189599209279700000003654530185590594978_)",
      enableBackground: "new"
    },
    d: " M536.2,164.6l-6.9-3.9c1.8-0.3,3.5-0.3,5.1,0l6.6,3.8C539.6,164.2,538,164.4,536.2,164.6z M518.1,175.3l-6.9-3.9 c-0.7,0.7-1.2,1.2-1.8,1.9l6.9,3.9C517,176.7,517.5,176,518.1,175.3z M511.6,183.6l-7-4.1c-0.4,0.7-0.9,1.5-1.4,2.2l7,4.1 C510.6,185.1,511.2,184.4,511.6,183.6z M514.7,179.4l-6.9-3.9c-0.5,0.7-1.1,1.4-1.6,2l6.9,3.9 C513.6,180.7,514.1,180.1,514.7,179.4z M532.4,165.4l-6.8-3.8c-0.9,0.4-1.9,0.7-3,1.2l6.9,3.9 C530.5,166.4,531.5,165.8,532.4,165.4z M522.1,171.7l-6.8-3.9c-0.7,0.5-1.4,1.2-2,1.8l6.8,3.9 C520.8,172.9,521.5,172.2,522.1,171.7z M526.7,168.3l-6.8-3.9c-0.8,0.4-1.5,1.1-2.3,1.6l6.8,3.9 C525.2,169.4,525.9,168.8,526.7,168.3z M508.9,188.1l-7-4.1c-0.4,0.7-0.8,1.5-1.2,2.3l7,4.1 C508.2,189.5,508.5,188.9,508.9,188.1z M502.5,214.5l-6.9-3.9c0.1,1.1,0.3,2.2,0.4,3.1l6.6,3.8 C502.5,216.5,502.5,215.4,502.5,214.5z M506.6,192.8l-6.9-3.9c-0.3,0.8-0.7,1.6-0.9,2.4l6.9,3.9 C506,194.4,506.3,193.6,506.6,192.8z M504,221.2l-6.9-3.9c0.7,1.8,1.6,3.3,2.7,4.5l6.6,3.8C505.5,224.5,504.7,223,504,221.2z  M502.5,208.4l-6.8-3.9c-0.1,0.9-0.1,1.9-0.1,2.8l6.8,3.9C502.2,210.3,502.4,209.3,502.5,208.4z M503.3,202.9l-6.8-3.9 c-0.1,0.8-0.4,1.8-0.5,2.6l6.8,3.9C502.9,204.6,503.2,203.8,503.3,202.9z M504.8,197.7l-6.9-3.9c-0.3,0.8-0.5,1.6-0.7,2.4 l6.9,3.9C504.1,199.3,504.5,198.5,504.8,197.7z"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4964 -0.8681 0.8681 0.4964 94.5274 557.2441)",
    className: "st11",
    cx: 527.5,
    cy: 197.2,
    rx: 35.9,
    ry: 20.7
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M527.8,225.4c6.5-3.8,12.5-10.2,17.1-18c4.6-8.1,7.2-16.7,7.2-24.2c0-7.6-2.6-13.3-7.3-16 c-4.7-2.7-11-2-17.5,1.8s-12.5,10.2-17.1,18c-4.6,8.1-7.2,16.7-7.2,24.2c0,7.6,2.6,13.3,7.3,16 C515.1,229.9,521.3,229.2,527.8,225.4z M503.7,211.2c0-7.4,2.4-16,7-24c4.5-7.9,10.4-14.1,16.8-17.7 c6.4-3.7,12.3-4.3,16.8-1.8s6.9,8,7,15.3c0,7.4-2.4,16-7,24c-4.5,7.9-10.4,14.1-16.8,17.7c-6.4,3.7-12.3,4.3-16.8,1.8 S503.7,218.5,503.7,211.2z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "st243"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M527.4,223.5c-12.6,7.4-22.6,1.6-22.6-12.9c0.1-14.5,10.4-32.4,22.9-39.7c12.6-7.4,22.6-1.6,22.6,12.9 C550.2,198.2,539.9,216.1,527.4,223.5z M535.7,193.5c-1.2,0.7-2.2,0.3-2.4-0.8L505.5,209c0,0.4,0,0.8,0,1.2c0,0.7,0,1.2,0,1.9 l35.2-20.7c0.3-1.5,1.2-3,2.4-3.7c1.4-0.8,2.6-0.1,2.6,1.5c0,1.6-1.2,3.7-2.6,4.5c-1.2,0.7-2.2,0.3-2.4-0.8l-35.1,20.7 c0.1,0.9,0.3,2,0.5,2.8l13.9-8.3l3.3-0.1c0.4-0.9,1.2-1.9,2-2.3c1.4-0.8,2.6-0.1,2.6,1.5c0,1.6-1.2,3.7-2.6,4.5 c-1.4,0.8-2.6,0.1-2.6-1.5c0-0.1,0-0.4,0-0.5l-3.1,0.1l-13.3,7.9c2.8,8.7,11.1,11.1,21,5.3c12.2-7.2,22.2-24.6,22.3-38.7 c0.1-14.1-9.8-19.8-21.9-12.6c-10.2,6-18.8,19-21.5,31.3l13.5-8l4.6-5.3c0-0.1,0-0.4,0-0.5c0-1.6,1.2-3.7,2.6-4.5 c1.4-0.8,2.6-0.1,2.6,1.5c0,1.6-1.2,3.7-2.6,4.5c-0.8,0.5-1.5,0.4-2,0l-4.9,5.6l-14.1,8.3c-0.1,1.1-0.4,2.2-0.4,3.3l27.8-16.4 c0.3-1.5,1.2-3,2.4-3.7c1.4-0.8,2.6-0.1,2.6,1.5C538.2,190.6,537,192.7,535.7,193.5L535.7,193.5z M534.3,191.3 c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8C535,189.4,534.3,190.5,534.3,191.3L534.3,191.3z  M525.5,188.3c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8C526.2,186.4,525.5,187.5,525.5,188.3 L525.5,188.3z M541.8,191.4c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8S541.8,190.5,541.8,191.4 L541.8,191.4z M523.9,209.4c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8 C524.6,207.4,523.9,208.5,523.9,209.4L523.9,209.4z"
  })))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "_x34__3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M827.9,650.9c0,0.8,0.5,1.6,1.8,2.3l72.3,41.8c2,1.2,5.3,1.4,7,0.3l43.3-24.9c0.9-0.5,1.2-1.2,1.2-1.9 c0-0.4,0-0.8-0.1-1.2c-0.1-0.7-0.7-1.5-1.6-2l-72.3-41.8c-2-1.2-5.3-1.4-7-0.3l-43.3,24.9c-0.8,0.4-1.2,1.1-1.2,1.6 C827.7,650,827.9,650.5,827.9,650.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M879.3,623.3l72.3,41.8c2,1.2,2.3,3,0.5,4.1l-43.3,24.9c-1.8,1.1-5,0.9-7-0.3L829.5,652 c-2-1.2-2.3-3-0.5-4.1l43.3-24.9C874,621.9,877.2,622.1,879.3,623.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M945.4,664.4c0.8,0.4,1.2,1.1,1.4,1.6s-0.3,1.2-0.9,1.6l-4.7,2.7c-1.5,0.8-3.9,0.7-5.6-0.3l-14.8-8.5 c-0.8-0.4-1.2-1.1-1.4-1.6c-0.1-0.5,0.3-1.2,0.9-1.6l4.7-2.7c1.5-0.8,3.9-0.7,5.6,0.3L945.4,664.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st244",
    d: "M930.2,656.5L945,665c1.4,0.8,1.5,2,0.3,2.7l-4.7,2.7c-1.2,0.7-3.3,0.5-4.6-0.1l-14.8-8.5 c-1.4-0.8-1.5-2-0.3-2.7l4.7-2.7C926.9,655.6,928.9,655.8,930.2,656.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M856.4,652c0.5,0.4,0.9,0.8,1.1,1.2c0,0.4-0.1,0.9-0.7,1.2l-5.3,3.1c-1.1,0.7-3,0.5-4.2-0.1l-11-6.4 c-0.5-0.4-0.9-0.8-1.1-1.2c0-0.4,0.1-0.9,0.7-1.2l5.3-3.1c1.1-0.7,3-0.5,4.2,0.1L856.4,652z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M836.7,651l11,6.4c1.1,0.5,2.6,0.7,3.5,0.1l5.3-3.1c0.9-0.5,0.8-1.4-0.3-2l-11-6.4 c-1.1-0.5-2.6-0.7-3.5-0.1l-5.3,3.1C835.4,649.6,835.6,650.5,836.7,651z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st243"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M844.8,645.9c-0.1,0-0.3-0.1-0.4-0.1l-8.4,4.9c0.1,0.1,0.1,0.1,0.3,0.3l2-1.2l3.5,2 c-0.7,0.7-0.5,1.6,0.5,2.2c1.1,0.7,2.7,0.8,3.8,0.4l3.7,2.2l-2,1.2c0.1,0,0.3,0.1,0.4,0.1l8.4-4.9c-0.1-0.1-0.1-0.1-0.3-0.3 L854,654l-3.7-2.2c0.8-0.7,0.5-1.6-0.5-2.3c-1.1-0.7-2.8-0.8-3.9-0.3l-3.5-2L844.8,645.9z M846.7,654l3.5-2l3.7,2l-3.5,2 L846.7,654C846.5,654,846.7,654,846.7,654z M842.8,653.8c-0.9-0.5-1.1-1.4-0.5-1.9l3.8,2.2 C845.1,654.3,843.7,654.3,842.8,653.8z M849.7,649.7c0.9,0.5,1.1,1.4,0.5,1.9l-3.8-2.2C847.2,649.1,848.7,649.1,849.7,649.7z  M846,649.6l3.8,2.2l-3.5,2l0,0l-3.8-2.2l0,0L846,649.6z M845.7,649.4l-3.5,2l0,0l-3.4-2l3.5-2L845.7,649.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st244",
    d: "M878.2,628c0,0.3-0.1,0.4-0.5,0.7l-0.4,0.3h-0.1l-0.3-0.1c0,0,0,0,0-0.1l0.4-0.3c0.3-0.1,0.4-0.3,0.4-0.4 c0-0.1-0.1-0.3-0.4-0.4l-0.8-0.5c-0.3-0.1-0.4-0.1-0.7-0.1s-0.5,0.1-0.7,0.3l-2.7,1.5c-0.3,0.1-0.4,0.3-0.4,0.4s0.1,0.3,0.3,0.4 l0.9,0.5c0.3,0.1,0.4,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3l0.4-0.3h0.1l0.3,0.1c0,0,0,0,0,0.1l-0.4,0.3c-0.3,0.1-0.7,0.3-1.1,0.3 c-0.4,0-0.7-0.1-1.1-0.3l-0.9-0.5c-0.3-0.1-0.5-0.4-0.5-0.7s0.1-0.4,0.5-0.7l2.7-1.6c0.3-0.1,0.7-0.3,1.1-0.3s0.7,0.1,1.1,0.3 l0.9,0.5C878.1,627.5,878.2,627.7,878.2,628z M878.1,633H878l-0.3-0.1c0,0-0.1-0.1,0-0.1l0.9-1.6l-1.2-0.7h-0.1l-1.9,1.1h-0.1 l-0.3-0.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.8,0.9c0.3,0.1,0.5,0.4,0.5,0.7s-0.1,0.4-0.5,0.7l-0.7,0.4c-0.3,0.1-0.5,0.3-0.9,0.3 c-0.3,0-0.7,0-0.9-0.1l0,0L878.1,633z M879.2,631.1c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3l0.7-0.4 c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1-0.1-0.3-0.4-0.4l-1.4-0.8h-0.1l-2,1.2c0,0,0,0,0,0.1L879.2,631.1z M886.4,632.4l-2.3-1.4h-0.1 l-4.7,2.7c0,0,0,0,0,0.1l2.3,1.4h0.1l0.1-0.1c0,0,0,0,0-0.1l-1.9-1.1c0,0,0,0,0-0.1l1.9-1.1h0.1l1.8,0.9h0.1l0.1-0.1 c0,0,0,0,0-0.1l-1.8-0.9c0,0,0,0,0-0.1l1.8-0.9h0.1l1.9,1.1h0.1L886.4,632.4C886.5,632.4,886.5,632.4,886.4,632.4z M890,634.8 c0,0.3-0.1,0.4-0.5,0.7l-2.7,1.6c-0.3,0.1-0.7,0.3-1.1,0.3s-0.7-0.1-1.1-0.3l-1.9-1.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.9,1.1 C889.9,634.4,890,634.5,890,634.8z M889.1,635.2c0.3-0.1,0.4-0.3,0.4-0.4s-0.1-0.3-0.4-0.4l-1.5-0.8h-0.1l-4.1,2.3 c0,0,0,0,0,0.1l1.5,0.8c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3L889.1,635.2z M892.2,635.6l-0.3-0.1h-0.1l-4.7,2.7 c0,0,0,0,0,0.1l0.3,0.1h0.1L892.2,635.6C892.2,635.7,892.2,635.7,892.2,635.6z M895.8,637.8l-2.7-1.6H893l-0.1,0.1 c0,0,0,0,0,0.1l1.1,0.7c0,0,0,0,0,0.1l-4.3,2.6v0.1l0.3,0.1h0.1l4.3-2.6h0.1l1.1,0.7h0.1L895.8,637.8 C896,637.9,896,637.8,895.8,637.8z M900.7,640.6l-0.9-0.5c-0.3-0.1-0.7-0.3-1.1-0.3s-0.7,0.1-1.1,0.3l-2.7,1.6 c-0.3,0.1-0.5,0.4-0.5,0.7c0,0.3,0.1,0.4,0.5,0.7l0.9,0.5c0.3,0.1,0.7,0.3,1.1,0.3c0.4,0,0.7-0.1,1.1-0.3l0.4-0.3v-0.1l-0.3-0.1 H898l-0.4,0.3c-0.3,0.1-0.5,0.3-0.7,0.3c-0.3,0-0.5,0-0.7-0.1l-0.9-0.5c-0.3-0.1-0.4-0.3-0.3-0.4c0-0.1,0.1-0.3,0.4-0.4l2.7-1.5 c0.3-0.1,0.5-0.3,0.7-0.3c0.3,0,0.5,0,0.7,0.1l0.9,0.5c0.3,0.1,0.4,0.3,0.4,0.4s-0.1,0.3-0.4,0.4l-0.4,0.3v0.1l0.3,0.1h0.1 l0.4-0.3c0.3-0.1,0.5-0.4,0.5-0.7C901.1,641,901,640.8,900.7,640.6z M904.4,642.8l-3.1,3.5h-0.1l-0.3-0.1c0,0,0,0,0-0.1l0.8-0.9 l-2-1.1l-1.6,0.4c-0.1,0-0.1,0-0.1,0l-0.3-0.1c0,0,0,0,0-0.1l6.2-1.9c0.1,0,0.1,0,0.1,0L904.4,642.8 C904.4,642.8,904.5,642.8,904.4,642.8z M901.9,644.9l1.9-2.2l0,0l-3.7,1.1L901.9,644.9z M905.1,648.6h-0.1l-0.3-0.1 c0,0-0.1-0.1,0-0.1l0.9-1.6l-1.2-0.7h-0.1l-1.9,1.1h-0.1l-0.3-0.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.8,0.9c0.3,0.1,0.5,0.4,0.5,0.7 s-0.1,0.4-0.5,0.7l-0.7,0.4c-0.3,0.1-0.5,0.3-0.9,0.3c-0.3,0-0.7,0-0.9-0.1l0,0L905.1,648.6z M906.1,646.6 c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3l0.7-0.4c0.3-0.1,0.4-0.3,0.4-0.4s-0.1-0.3-0.4-0.4l-1.4-0.8h-0.1l-2,1.2 c0,0,0,0,0,0.1L906.1,646.6z M912.8,648.9l-2.7,1.6c-0.3,0.1-0.7,0.3-1.1,0.3s-0.7-0.1-1.1-0.3l-1.9-1.1c0,0,0,0,0-0.1l4.7-2.7 h0.1l1.9,1.1c0.3,0.1,0.5,0.4,0.5,0.7C913.3,648.5,913.2,648.6,912.8,648.9z M912.5,648.6c0.3-0.1,0.4-0.3,0.4-0.4 c0-0.1-0.1-0.3-0.4-0.4L911,647h-0.1l-4.1,2.3c0,0,0,0,0,0.1l1.5,0.8c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3 L912.5,648.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M900.6,684.8c-2.2,1.2-5.7,1.2-7.9,0s-2.2-3.3,0-4.6c2.2-1.2,5.7-1.2,7.9,0S902.7,683.5,900.6,684.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M909.7,690c-2.2,1.2-5.7,1.2-7.9,0s-2.2-3.3,0-4.6c2.2-1.2,5.7-1.2,7.9,0 C911.8,686.8,911.8,688.8,909.7,690z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st244",
    d: "M871.3,645.8l-2.2,1.2c-0.4,0.3-1.2,0.3-1.6,0l-11.1-6.4c-0.4-0.3-0.4-0.7,0-0.9l2.2-1.2 c0.4-0.3,1.2-0.3,1.6,0l11.1,6.4C871.7,645.1,871.7,645.5,871.3,645.8z M888.8,655l-11.1-6.4c-0.4-0.3-1.2-0.3-1.6,0l-2.2,1.2 c-0.4,0.3-0.4,0.7,0,0.9l11.1,6.4c0.4,0.3,1.2,0.3,1.6,0l2.2-1.2C889.2,655.6,889.2,655.1,888.8,655z M906.3,665l-11.1-6.4 c-0.4-0.3-1.2-0.3-1.6,0l-2.2,1.2c-0.4,0.3-0.4,0.7,0,0.9l11.1,6.4c0.4,0.3,1.2,0.3,1.6,0l2.2-1.2 C906.7,665.7,906.7,665.3,906.3,665z M923.7,675.1l-11.1-6.4c-0.4-0.3-1.2-0.3-1.6,0l-2.2,1.2c-0.4,0.3-0.4,0.7,0,0.9l11.1,6.4 c0.4,0.3,1.2,0.3,1.6,0l2.2-1.2C924.1,675.8,924.1,675.3,923.7,675.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodsRight);
export default __webpack_public_path__ + "static/media/payment-methods-right.bfbfbca35d9b30dcd8bbf72e9080a697.svg";
export { ForwardRef as ReactComponent };